export const styleIdSet = new Set([
  '3-biotech',
  '3d-printing-in-medicine',
  '3d-research',
  '3d-printed-materials-and-systems',
  '4or',
  'aapg-bulletin',
  'aaps-open',
  'aaps-pharmscitech',
  'aasri-procedia',
  'abi-technik',
  'computing-surveys',
  'journal-on-emerging-technologies-in-computing-systems',
  'acm-sig-proceedings-long-author-list',
  'acm-sig-proceedings',
  'acm-sigchi-proceedings',
  'acm-sigchi-proceedings-extended-abstract-format',
  'acm-siggraph',
  'transactions-on-accessible-computing',
  'transactions-on-algorithms',
  'transactions-on-applied-perception',
  'transactions-on-architecture-and-code-optimization',
  'transactions-on-asian-language-information-processing',
  'transactions-on-autonomous-and-adaptive-systems',
  'transactions-on-computation-theory',
  'transactions-on-computational-logic',
  'transactions-on-computer-systems',
  'transactions-on-computer-human-interaction',
  'transactions-on-computing-education',
  'transactions-on-database-systems',
  'transactions-on-design-automation-of-electronic-systems',
  'transactions-on-embedded-computing-systems',
  'transactions-on-graphics',
  'transactions-on-information-systems',
  'transactions-on-information-and-system-security',
  'transactions-on-intelligent-systems-and-technology',
  'transactions-on-interactive-intelligent-systems',
  'transactions-on-internet-technology',
  'transactions-on-knowledge-discovery-from-data',
  'transactions-on-management-information-systems',
  'transactions-on-mathematical-software',
  'transactions-on-modeling-and-computer-simulation',
  'transactions-on-multimedia-computing-communications-and-applications',
  'transactions-on-parallel-computing',
  'transactions-on-programming-languages-and-systems',
  'transactions-on-reconfigurable-technology-and-systems',
  'transactions-on-sensor-networks',
  'transactions-on-software-engineering-and-methodology',
  'transactions-on-spatial-algorithms-and-systems',
  'transactions-on-speech-and-language-processing',
  'transactions-on-storage',
  'transactions-on-the-web',
  'acs-applied-materials-and-interfaces',
  'acs-biomaterials-science-and-engineering',
  'acs-catalysis',
  'acs-chemical-biology',
  'acs-chemical-neuroscience',
  'acs-combinatorial-science',
  'acs-infectious-diseases',
  'acs-macro-letters',
  'acs-medicinal-chemistry-letters',
  'acs-nano',
  'acs-photonics',
  'acs-sustainable-chemistry-and-engineering',
  'acs-synthetic-biology',
  'adhd-attention-deficit-and-hyperactivity-disorders',
  'aeue-international-journal-of-electronics-and-communications',
  'age',
  'ai-and-society',
  'aiaa-journal',
  'aids',
  'aids-care',
  'aids-research-and-therapy',
  'aids-and-behavior',
  'aip-advances',
  'akce-international-journal-of-graphs-and-combinatorics',
  'amar-analytic-methods-in-accident-research',
  'amb-express',
  'ambio',
  'ams-review',
  'annali-delluniversita-di-ferrara',
  'associacao-nacional-de-pesquisa-e-ensino-em-transportes',
  'aorn-journal',
  'apcbee-procedia',
  'apl-materials',
  'asaio-journal',
  'asce-asme-journal-of-risk-and-uncertainty-in-engineering-systems-part-a-civil-engineering',
  'astra-proceedings',
  'asta-advances-in-statistical-analysis',
  'asta-wirtschafts-und-sozialstatistisches-archiv',
  'abhandlungen-aus-dem-mathematischen-seminar-der-universitat-hamburg',
  'academic-medicine',
  'academic-pediatrics',
  'academic-psychiatry',
  'academic-questions',
  'academy-of-management-discoveries',
  'academy-of-management-journal',
  'academy-of-management-learning-and-education',
  'academy-of-management-perspectives',
  'academy-of-management-proceedings',
  'academy-of-management-review',
  'accident-analysis-and-prevention',
  'accounting-forum',
  'accounting-history-review',
  'accounting-organizations-and-society',
  'accounts-of-chemical-research',
  'accreditation-and-quality-assurance',
  'achievements-in-the-life-sciences',
  'acoustics-australia',
  'acta-agriculturae-scandinavica-section-b-soil-and-plant-science',
  'acta-anaesthesiologica-scandinavica',
  'acta-anaesthesiologica-taiwanica',
  'acta-analytica',
  'acta-applicandae-mathematicae',
  'acta-astronautica',
  'acta-biomaterialia',
  'acta-biotheoretica',
  'acta-botanica-gallica',
  'acta-crystallographica-section-a-foundations-and-advances',
  'acta-crystallographica-section-b-structural-science-crystal-engineering-and-materials',
  'acta-crystallographica-section-c-structural-chemistry',
  'acta-crystallographica-section-d-biological-crystallography',
  'acta-crystallographica-section-e-structure-reports-online',
  'acta-crystallographica-section-f-structural-biology-communications',
  'acta-cytologica',
  'acta-diabetologica',
  'acta-ecologica-sinica',
  'acta-geochimica',
  'acta-geodaetica-et-geophysica',
  'acta-geotechnica',
  'acta-haematologica',
  'acta-haematologica-polonica',
  'acta-histochemica',
  'acta-materialia',
  'acta-mathematica-vietnamica',
  'acta-mechanica',
  'acta-mechanica-sinica',
  'acta-medica',
  'acta-metallurgica-sinica',
  'acta-medica-colombiana',
  'acta-naturae',
  'acta-neurochirurgica',
  'acta-neurologica-belgica',
  'acta-neuropathologica',
  'acta-neuropathologica-communications',
  'acta-oecologica',
  'acta-ophthalmologica',
  'acta-orthopaedica',
  'acta-otorrinolaringologica-espanola',
  'acta-paediatrica',
  'acta-palaeontologica-polonica',
  'acta-pharmaceutica',
  'acta-pharmaceutica-sinica-b',
  'acta-pharmacologica-sinica',
  'acta-philosophica',
  'acta-physiologiae-plantarum',
  'acta-polytechnica',
  'acta-psychiatrica-scandinavica',
  'acta-psychologica',
  'acta-societatis-botanicorum-poloniae',
  'acta-sociologica',
  'acta-tropica',
  'acta-universitatis-agriculturae-sueciae',
  'acta-veterinaria-scandinavica',
  'action-learning-research-and-practice',
  'actualites-pharmaceutiques',
  'actuators',
  'acupuncture-and-related-therapies',
  'acupuncture-in-medicine',
  'ad-hoc-networks',
  'adaptive-human-behavior-and-physiology',
  'addiction-science-and-clinical-practice',
  'addictive-behaviors',
  'addictive-behaviors-reports',
  'additive-manufacturing',
  'adipocyte',
  'administration-and-policy-in-mental-health-and-mental-health-services-research',
  'administrative-science-quarterly',
  'administrative-sciences',
  'adolescent-research-review',
  'adsorption',
  'advanced-composite-materials',
  'advanced-drug-delivery-reviews',
  'advanced-engineering-informatics',
  'advanced-engineering-materials',
  'advanced-functional-materials',
  'advanced-materials',
  'advanced-modeling-and-simulation-in-engineering-sciences',
  'advanced-powder-technology',
  'advanced-robotics',
  'advanced-structural-and-chemical-imaging',
  'advances-in-accounting-incorporating-advances-in-international-accounting',
  'advances-in-alzheimers-disease',
  'advances-in-applied-clifford-algebras',
  'advances-in-biological-regulation',
  'advances-in-building-energy-research',
  'advances-in-climate-change-research',
  'advances-in-colloid-and-interface-science',
  'advances-in-complex-systems',
  'advances-in-computational-mathematics',
  'advances-in-data-analysis-and-classification',
  'advances-in-difference-equations',
  'advances-in-digestive-medicine',
  'advances-in-eating-disorders-theory-research-and-practice',
  'advances-in-engineering-software',
  'advances-in-geosciences',
  'advances-in-health-sciences-education',
  'advances-in-integrative-medicine',
  'advances-in-life-course-research',
  'advances-in-manufacturing',
  'advances-in-medical-sciences',
  'advances-in-natural-sciences-nanoscience-and-nanotechnology',
  'advances-in-nutrition',
  'advances-in-oceanography-and-limnology',
  'advances-in-physiology-education',
  'advances-in-radio-science',
  'advances-in-school-mental-health-promotion',
  'advances-in-science-and-research',
  'advances-in-simulation',
  'advances-in-space-research',
  'advances-in-therapy',
  'advances-in-water-resources',
  'aeolian-research',
  'aequationes-mathematicae',
  'aerobiologia',
  'aerospace',
  'aerospace-science-and-technology',
  'aesthetic-plastic-surgery',
  'africa-review',
  'african-archaeological-review',
  'african-geographical-review',
  'african-identities',
  'african-journal-of-emergency-medicine',
  'african-journal-of-urology',
  'african-zoology',
  'african-and-black-diaspora-an-international-journal',
  'afrika-matematika',
  'ageing-international',
  'ageing-research-reviews',
  'aggression-and-violent-behavior',
  'aging-and-mental-health',
  'aging-cell',
  'aging-clinical-and-experimental-research',
  'aging-health',
  'aging-neuropsychology-and-cognition',
  'agricultural-research',
  'agricultural-systems',
  'agricultural-water-management',
  'agricultural-and-food-economics',
  'agricultural-and-forest-meteorology',
  'agriculture',
  'agriculture-and-food-security',
  'agriculture-and-human-values',
  'agriculture-ecosystems-and-environment',
  'agroforestry-systems',
  'agronomy',
  'agronomy-journal',
  'agronomy-for-sustainable-development',
  'ain-shams-engineering-journal',
  'air-quality-atmosphere-and-health',
  'universitat-freiburg-geschichte',
  'alcohol',
  'alcoholism-and-drug-addiction',
  'alergologia-polska-polish-journal-of-allergology',
  'alexandria-engineering-journal',
  'alexandria-journal-of-medicine',
  'algal-research',
  'algebra-universalis',
  'algebras-and-representation-theory',
  'algorithmica',
  'algorithms',
  'algorithms-for-molecular-biology',
  'allergology-international',
  'allergy',
  'allergy-asthma-and-clinical-immunology',
  'alpine-botany',
  'alter-european-journal-of-disability-research-revue-europeenne-de-recherche-sur-le-handicap',
  'alternatives-to-animal-experimentation',
  'alzheimers-and-dementia-diagnosis-assessment-and-disease-monitoring',
  'alzheimers-and-dementia-the-journal-of-the-alzheimers-association',
  'alzheimers-and-dementia-translational-research-and-clinical-interventions',
  'alzheimers-research-and-therapy',
  'ameghiniana',
  'american-anthropological-association',
  'american-antiquity',
  'american-association-for-cancer-research',
  'american-association-of-petroleum-geologists',
  'american-chemical-society',
  'american-chemical-society-author-date',
  'american-chemical-society-page-first',
  'american-chemical-society-with-titles-sentence-case-doi',
  'american-chemical-society-with-titles',
  'american-chemical-society-with-titles-no-et-al',
  'american-chemical-society-with-titles-page-first',
  'american-chemical-society-with-titles-sentence-case',
  'american-educational-research-journal',
  'american-entomologist',
  'american-family-physician',
  'american-fisheries-society',
  'american-geophysical-union',
  'american-heart-association',
  'american-heart-journal',
  'american-institute-of-aeronautics-and-astronautics',
  'american-institute-of-physics',
  'american-journal-of-agricultural-economics',
  'american-journal-of-alzheimers-disease-and-other-dementias',
  'american-journal-of-archaeology',
  'american-journal-of-botany',
  'american-journal-of-cardiovascular-drugs',
  'american-journal-of-clinical-dermatology',
  'american-journal-of-clinical-pathology',
  'american-journal-of-community-psychology',
  'american-journal-of-criminal-justice',
  'american-journal-of-dance-therapy',
  'american-journal-of-emergency-medicine',
  'american-journal-of-epidemiology',
  'american-journal-of-gastroenterology-supplements',
  'american-journal-of-health-behavior',
  'american-journal-of-health-system-pharmacy',
  'american-journal-of-human-genetics',
  'american-journal-of-hypertension',
  'american-journal-of-infection-control',
  'american-journal-of-kidney-diseases',
  'american-journal-of-medical-genetics',
  'american-journal-of-nephrology',
  'american-journal-of-neuroradiology',
  'american-journal-of-obstetrics-and-gynecology',
  'american-journal-of-ophthalmology',
  'american-journal-of-orthodontics-and-dentofacial-orthopedics',
  'american-journal-of-orthopsychiatry',
  'american-journal-of-otolaryngology-head-and-neck-medicine-and-surgery',
  'american-journal-of-physical-anthropology',
  'ajp-cell-physiology',
  'ajp-endocrinology-and-metabolism',
  'ajp-gastrointestinal-and-liver-physiology',
  'ajp-heart-and-circulatory-physiology',
  'ajp-lung-cellular-and-molecular-physiology',
  'ajp-regulatory-integrative-and-comparative-physiology',
  'ajp-renal-physiology',
  'american-journal-of-plant-sciences',
  'american-journal-of-political-science',
  'american-journal-of-potato-research',
  'american-journal-of-primatology',
  'american-journal-of-public-health',
  'american-journal-of-reproductive-immunology',
  'american-journal-of-respiratory-and-critical-care-medicine',
  'american-journal-of-roentgenology',
  'american-journal-of-surgical-pathology',
  'american-journal-of-veterinary-research',
  'american-marketing-association',
  'american-medical-association-no-et-al',
  'american-medical-association-no-url',
  'american-medical-association-alphabetical',
  'american-medical-association',
  'american-medical-association',
  'american-medical-writers-association-journal',
  'american-meteorological-society',
  'american-mineralogist',
  'american-physics-society',
  'american-physiological-society',
  'american-phytopathological-society',
  'american-phytopathological-society-numeric',
  'american-political-science-association',
  'american-political-science-review',
  'apa-5th-edition',
  'apa',
  'apa-fr',
  'apa-de',
  'apa-it',
  'apa-fr-provost',
  'apa-es',
  'apa-tr',
  'apa-fr-universite-de-montreal',
  'apa-annotated-bibliography',
  'apa-cv',
  'apa-no-doi-no-issue',
  'apa-no-ampersand',
  'apa-single-spaced',
  'apa7',
  'american-psychologist',
  'american-review-of-canadian-studies',
  'american-society-for-microbiology',
  'american-society-for-pharmacology-and-experimental-therapeutics',
  'asa-cssa-sssa',
  'american-society-of-civil-engineers',
  'american-society-of-mechanical-engineers',
  'american-sociological-association',
  'american-sociological-review',
  'american-veterinary-medical-association',
  'amino-acids',
  'ampersand',
  'anaerobe',
  'anaesthesia',
  'anaesthesia-critical-care-and-pain-medicine',
  'anaesthesia-and-intensive-care',
  'anales-de-antropologia',
  'anales-de-pediatria',
  'analog-integrated-circuits-and-signal-processing',
  'analysis-and-mathematical-physics',
  'analyst',
  'analytic-methods-in-accident-research',
  'analytica-chimica-acta',
  'analytical-biochemistry',
  'analytical-chemistry',
  'analytical-chemistry-research',
  'analytical-methods',
  'analytical-sciences',
  'analytical-and-bioanalytical-chemistry',
  'anatolia',
  'anatomical-science-international',
  'anesthesia-and-analgesia',
  'anesthesiology',
  'anesthesie-and-reanimation',
  'angelaki',
  'angewandte-chemie',
  'angiogenesis',
  'angiologia',
  'animal-behaviour',
  'animal-biotelemetry',
  'animal-cells-and-systems',
  'animal-cognition',
  'animal-feed-science-and-technology',
  'animal-gene',
  'animal-nutrition',
  'animal-production-science',
  'animal-reproduction-science',
  'animal-welfare',
  'animals',
  'annalen-des-naturhistorischen-museums-in-wien',
  'annales-francaises-danesthesie-et-de-reanimation',
  'annales-geophysicae',
  'annales-henri-poincare',
  'annales-pharmaceutiques-francaises',
  'annales-dendocrinologie',
  'annales-de-chirurgie-vasculaire',
  'annales-de-dermatologie-et-de-venereologie',
  'annales-de-paleontologie',
  'annales-de-pathologie',
  'annales-de-cardiologie-et-dangeiologie',
  'annales-de-chirurgie-plastique-esthetique',
  'annales-de-linstitut-henri-poincare-analyse-non-lineaire',
  'annales-francaises-doto-rhino-laryngologie-et-de-pathologie-cervico-faciale',
  'annales-mathematiques-du-quebec',
  'annales-medico-psychologiques',
  'annales',
  'annali-di-matematica-pura-ed-applicata',
  'annals-of-agricultural-sciences',
  'annals-of-allergy-asthma-and-immunology',
  'annals-of-anatomy',
  'annals-of-applied-biology',
  'annals-of-behavioral-science-and-medical-education',
  'annals-of-biomedical-engineering',
  'annals-of-botany',
  'annals-of-clinical-and-laboratory-science',
  'annals-of-clinical-biochemistry',
  'annals-of-clinical-microbiology-and-antimicrobials',
  'annals-of-data-science',
  'annals-of-diagnostic-pathology',
  'annals-of-dyslexia',
  'annals-of-emergency-medicine',
  'annals-of-epidemiology',
  'annals-of-finance',
  'annals-of-forest-science',
  'annals-of-general-psychiatry',
  'annals-of-global-analysis-and-geometry',
  'annals-of-global-health',
  'annals-of-hematology',
  'annals-of-intensive-care',
  'annals-of-internal-medicine',
  'annals-of-leisure-research',
  'annals-of-mathematics-and-artificial-intelligence',
  'annals-of-medicine-and-surgery',
  'annals-of-microbiology',
  'annals-of-neurology',
  'annals-of-nuclear-energy',
  'annals-of-nuclear-medicine',
  'annals-of-nutrition-and-metabolism',
  'annals-of-occupational-and-environmental-medicine',
  'annals-of-oncology',
  'annals-of-operations-research',
  'annals-of-otology-rhinology-and-laryngology',
  'annals-of-physical-and-rehabilitation-medicine',
  'annals-of-physics',
  'annals-of-saudi-medicine',
  'annals-of-solid-and-structural-mechanics',
  'annals-of-surgery',
  'annals-of-surgical-innovation-and-research',
  'annals-of-tourism-research',
  'annals-of-tropical-paediatrics',
  'annals-of-the-association-of-american-geographers',
  'annals-of-the-entomological-society-of-america',
  'annals-of-the-icrp',
  'annals-of-the-institute-of-statistical-mathematics',
  'annals-of-the-rheumatic-diseases',
  'annals-of-the-royal-college-of-surgeons-of-england',
  'annals-academy-of-medicine-singapore',
  'annual-review-of-analytical-chemistry',
  'annual-review-of-animal-biosciences',
  'annual-review-of-anthropology',
  'annual-review-of-astronomy-and-astrophysics',
  'annual-review-of-biochemistry',
  'annual-review-of-biomedical-engineering',
  'annual-review-of-biophysics',
  'annual-review-of-cell-and-developmental-biology',
  'annual-review-of-chemical-and-biomolecular-engineering',
  'annual-review-of-clinical-psychology',
  'annual-review-of-condensed-matter-physics',
  'annual-review-of-earth-and-planetary-sciences',
  'annual-review-of-ecology-evolution-and-systematics',
  'annual-review-of-economics',
  'annual-review-of-entomology',
  'annual-review-of-environment-and-resources',
  'annual-review-of-financial-economics',
  'annual-review-of-fluid-mechanics',
  'annual-review-of-food-science-and-technology',
  'annual-review-of-genetics',
  'annual-review-of-genomics-and-human-genetics',
  'annual-review-of-immunology',
  'annual-review-of-law-and-social-science',
  'annual-review-of-marine-science',
  'annual-review-of-materials-research',
  'annual-review-of-medicine',
  'annual-review-of-microbiology',
  'annual-review-of-neuroscience',
  'annual-review-of-nuclear-and-particle-science',
  'annual-review-of-nutrition',
  'annual-review-of-organizational-psychology-and-organizational-behavior',
  'annual-review-of-pathology-mechanisms-of-disease',
  'annual-review-of-pharmacology-and-toxicology',
  'annual-review-of-physical-chemistry',
  'annual-review-of-physiology',
  'annual-review-of-phytopathology',
  'annual-review-of-plant-biology',
  'annual-review-of-political-science',
  'annual-review-of-psychology',
  'annual-review-of-public-health',
  'annual-review-of-resource-economics',
  'annual-review-of-sociology',
  'annual-review-of-statistics-and-its-application',
  'annual-review-of-virology',
  'annual-reviews-author-date',
  'annual-reviews-alphabetical',
  'annual-reviews',
  'annual-reviews-without-titles',
  'annual-reviews-in-control',
  'antarctic-science',
  'anthropocene',
  'anthropology-and-medicine',
  'antibiotics',
  'antibodies',
  'anticancer-research',
  'antimicrobial-agents-and-chemotherapy',
  'antimicrobial-resistance-and-infection-control',
  'antioxidants',
  'antiquity',
  'antiviral-research',
  'antonie-van-leeuwenhoek',
  'anuario-de-psicologia-juridica',
  'anxiety-stress-and-coping',
  'aphasiology',
  'apollo-medicine',
  'apoptosis',
  'appetite',
  'applicable-algebra-in-engineering-communication-and-computing',
  'applicable-analysis',
  'applied-and-translational-genomics',
  'applied-acoustics',
  'applied-adhesion-science',
  'applied-animal-behaviour-science',
  'applied-biochemistry-and-biotechnology',
  'applied-catalysis-a-general',
  'applied-catalysis-b-environmental',
  'applied-categorical-structures',
  'applied-clay-science',
  'applied-composite-materials',
  'applied-computing-and-informatics',
  'applied-energy',
  'applied-entomology-and-zoology',
  'applied-ergonomics',
  'applied-geochemistry',
  'applied-geography',
  'applied-geomatics',
  'applied-health-economics-and-health-policy',
  'applied-informatics',
  'applied-intelligence',
  'applied-magnetic-resonance',
  'applied-materials-today',
  'applied-mathematical-finance',
  'applied-mathematical-modelling',
  'applied-mathematics-and-optimization',
  'applied-mathematics-letters',
  'applied-mathematics-and-computation',
  'applied-mechanics-reviews',
  'applied-microbiology-and-biotechnology',
  'applied-nanoscience',
  'applied-network-science',
  'applied-nursing-research',
  'applied-ocean-research',
  'applied-petrochemical-research',
  'applied-physics-a',
  'applied-physics-b',
  'applied-physics-letters',
  'applied-physiology-nutrition-and-metabolism',
  'applied-psychophysiology-and-biofeedback',
  'applied-radiation-and-isotopes',
  'applied-research-in-quality-of-life',
  'applied-sciences',
  'applied-soft-computing-journal',
  'applied-soil-ecology',
  'applied-spatial-analysis-and-policy',
  'applied-spectroscopy',
  'applied-surface-science',
  'applied-thermal-engineering',
  'applied-water-science',
  'applied-and-computational-harmonic-analysis',
  'applied-and-environmental-microbiology',
  'aquacultural-engineering',
  'aquaculture',
  'aquaculture-environment-interactions',
  'aquaculture-international',
  'aquaculture-reports',
  'aquatic-biology',
  'aquatic-biosystems',
  'aquatic-botany',
  'aquatic-conservation',
  'aquatic-ecology',
  'aquatic-geochemistry',
  'aquatic-living-resources',
  'aquatic-microbial-ecology',
  'aquatic-procedia',
  'aquatic-sciences',
  'aquatic-toxicology',
  'arab-economic-and-business-journal',
  'arab-journal-of-gastroenterology',
  'arabian-journal-for-science-and-engineering',
  'arabian-journal-of-chemistry',
  'arabian-journal-of-geosciences',
  'arabian-journal-of-mathematics',
  'arachne',
  'arachnology',
  'arboricultural-journal-the-international-journal-of-urban-forestry',
  'archaeological-research-in-asia',
  'archaeological-and-anthropological-sciences',
  'archaeometry',
  'architectural-engineering-and-design-management',
  'architectural-science-review',
  'archiv-fur-geschichte-der-philosophie',
  'archiv-fur-die-civilistische-praxis',
  'archival-science',
  'archive-for-history-of-exact-sciences',
  'archive-for-mathematical-logic',
  'archive-for-rational-mechanics-and-analysis',
  'archive-of-applied-mechanics',
  'archives-of-phytopathology-and-plant-protection',
  'archives-and-records',
  'archives-de-pediatrie',
  'archives-des-maladies-professionnelles-et-de-lenvironnement',
  'archives-des-maladies-du-coeur-et-des-vaisseaux-pratique',
  'archives-of-agronomy-and-soil-science',
  'archives-of-animal-nutrition',
  'archives-of-biochemistry-and-biophysics',
  'archives-of-cardiovascular-diseases',
  'archives-of-civil-and-mechanical-engineering',
  'archives-of-computational-methods-in-engineering',
  'archives-of-dermatological-research',
  'archives-of-disease-in-childhood',
  'archives-of-environmental-contamination-and-toxicology',
  'archives-of-facial-plastic-surgery',
  'archives-of-general-psychiatry',
  'archives-of-gerontology-and-geriatrics',
  'archives-of-gynecology-and-obstetrics',
  'archives-of-internal-medicine',
  'archives-of-medical-research',
  'archives-of-microbiology',
  'archives-of-neurology',
  'archives-of-ophthalmology',
  'archives-of-oral-biology',
  'archives-of-orthopaedic-and-trauma-surgery',
  'archives-of-osteoporosis',
  'archives-of-otolaryngology-head-and-neck-surgery',
  'archives-of-pathology-and-laboratory-medicine',
  'archives-of-pediatrics-and-adolescent-medicine',
  'archives-of-pharmacal-research',
  'archives-of-physical-medicine-and-rehabilitation',
  'archives-of-physiotherapy',
  'archives-of-psychiatric-nursing',
  'archives-of-public-health',
  'archives-of-scientific-psychology',
  'archives-of-sexual-behavior',
  'archives-of-surgery',
  'archives-of-toxicology',
  'archives-of-virology',
  'archives-of-womens-mental-health',
  'archivos-de-bronconeumologia',
  'archivos-de-cardiologia-de-mexico',
  'archivos-de-medicina-interna',
  'archivos-de-psiquiatria',
  'archivos-de-la-sociedad-espanola-de-oftalmologia',
  'archivum-immunologiae-et-therapiae-experimentalis',
  'archeologie-medievale',
  'harvard-arden-university',
  'argumentation',
  'arnold-mathematical-journal',
  'arquivos-brasileiros-de-cardiologia',
  'arquivos-brasileiros-de-endocrinologia-e-metabologia',
  'art-history',
  'arteriosclerosis-thrombosis-and-vascular-biology',
  'artery-research',
  'arthritis-and-rheumatism',
  'arthritis-care-and-research',
  'arthritis-research-and-therapy',
  'arthroplasty-today',
  'arthropod-structure-and-development',
  'arthropod-plant-interactions',
  'arthroscopy-techniques',
  'arthroscopy',
  'arthroskopie',
  'artificial-dna-pna-and-xna',
  'artificial-intelligence',
  'artificial-intelligence-in-medicine',
  'artificial-intelligence-review',
  'artificial-intelligence-and-law',
  'artificial-life-and-robotics',
  'arts',
  'arts-and-health',
  'arzneimitteltherapie',
  'asia-and-the-pacific-policy-studies',
  'asia-europe-journal',
  'asia-pacific-business-review',
  'asia-pacific-education-review',
  'asia-pacific-family-medicine',
  'asia-pacific-journal-of-counselling-and-psychotherapy',
  'asia-pacific-journal-of-education',
  'asia-pacific-journal-of-social-work-and-development',
  'asia-pacific-journal-of-tourism-research',
  'asia-pacific-journal-on-computational-engineering',
  'asia-pacific-management-review',
  'asia-pacific-financial-markets',
  'asia-pacific-journal-of-accounting-and-economics',
  'asia-pacific-journal-of-health-sport-and-physical-education',
  'asia-pacific-journal-of-sports-medicine-arthroscopy-rehabilitation-and-technology',
  'asia-pacific-science-education',
  'asian-american-journal-of-psychology',
  'asian-anthropology',
  'asian-ethnicity',
  'asian-geographer',
  'asian-journal-of-andrology',
  'asian-journal-of-business-ethics',
  'asian-journal-of-criminology',
  'asian-journal-of-gambling-issues-and-public-health',
  'asian-journal-of-german-and-european-studies',
  'asian-journal-of-health-sciences',
  'asian-journal-of-psychiatry',
  'asian-journal-of-surgery',
  'asian-journal-of-urology',
  'asian-nursing-research',
  'asian-pacific-journal-of-tropical-biomedicine',
  'asian-pacific-journal-of-tropical-disease',
  'asian-pacific-journal-of-tropical-medicine',
  'asian-philosophy',
  'asian-population-studies',
  'asian-studies-review',
  'asian-pacific-journal-of-second-and-foreign-language-education',
  'assessing-writing',
  'assessment-and-evaluation-in-higher-education',
  'assessment-in-education-principles-policy-and-practice',
  'association-for-computational-linguistics',
  'association-for-computing-machinery',
  'associacao-brasileira-de-normas-tecnicas',
  'associacao-brasileira-de-normas-tecnicas-note',
  'associacao-brasileira-de-normas-tecnicas-eceme',
  'associacao-brasileira-de-normas-tecnicas-usp-fmvz',
  'associacao-brasileira-de-normas-tecnicas-ipea',
  'associacao-brasileira-de-normas-tecnicas-ufjf',
  'associacao-brasileira-de-normas-tecnicas-ufmg-face-initials',
  'associacao-brasileira-de-normas-tecnicas-ufmg-face-full',
  'associacao-brasileira-de-normas-tecnicas-ufpr',
  'asthma-research-and-practice',
  'astronomy-and-computing',
  'astroparticle-physics',
  'astrophysics-and-space-science',
  'atencion-primaria',
  'atherosclerosis',
  'atherosclerosis-supplements',
  'athletic-training-and-sports-health-care',
  'atlantic-economic-journal',
  'atlantic-studies',
  'atmosphere',
  'atmosphere-ocean',
  'atmospheric-chemistry-and-physics',
  'atmospheric-chemistry-and-physics-discussions',
  'atmospheric-environment',
  'atmospheric-measurement-techniques',
  'atmospheric-measurement-techniques-discussions',
  'atmospheric-pollution-research',
  'atmospheric-research',
  'atomic-data-and-nuclear-data-tables',
  'atoms',
  'attachment-and-human-development',
  'audiology-and-neurotology',
  'audiology-and-neurotology-extra',
  'augmented-human-research',
  'aula-abierta',
  'auris-nasus-larynx',
  'ausonius-editions',
  'austral-ecology',
  'australasian-dispute-resolution-journal',
  'australasian-emergency-nursing-journal',
  'australasian-journal-of-dermatology',
  'australasian-marketing-journal',
  'australasian-physical-and-engineering-sciences-in-medicine',
  'australasian-plant-disease-notes',
  'australasian-plant-pathology',
  'australian-academic-and-research-libraries',
  'australian-business-law-review',
  'australian-critical-care',
  'australian-family-physician',
  'australian-feminist-studies',
  'australian-gst-journal',
  'australian-geographer',
  'australian-guide-to-legal-citation',
  'australian-historical-studies',
  'australian-intellectual-property-journal',
  'australian-journal-of-administrative-law',
  'australian-journal-of-botany',
  'australian-journal-of-competition-and-consumer-law',
  'australian-journal-of-earth-sciences',
  'australian-journal-of-grape-and-wine-research',
  'australian-journal-of-international-affairs',
  'australian-journal-of-learning-difficulties',
  'australian-journal-of-primary-health',
  'australian-journal-of-rural-health',
  'australian-journal-of-zoology',
  'australian-mammalogy',
  'australian-orthoptic-journal',
  'australian-planner',
  'australian-systematic-botany',
  'australian-tax-review',
  'australian-veterinary-journal',
  'austrian-legal',
  'austrian-studies',
  'autoimmunity-highlights',
  'autoimmunity-reviews',
  'automated-software-engineering',
  'automatica',
  'automation-in-construction',
  'automotive-and-engine-technology',
  'autonomic-neuroscience-basic-and-clinical',
  'autonomous-agents-and-multi-agent-systems',
  'autonomous-robots',
  'autophagy',
  'avian-conservation-and-ecology',
  'avian-diseases',
  'avian-pathology',
  'avian-research',
  'aviation-psychology-and-applied-human-factors',
  'aviation-space-and-environmental-medicine',
  'axiomathes',
  'axioms',
  'bba-bioenergetics',
  'bba-biomembranes',
  'bba-gene-regulatory-mechanisms',
  'bba-general-subjects',
  'bba-molecular-basis-of-disease',
  'bba-molecular-cell-research',
  'bba-molecular-and-cell-biology-of-lipids',
  'bba-proteins-and-proteomics',
  'bba-reviews-on-cancer',
  'bba-clinical',
  'bioethics-update',
  'bit-numerical-mathematics',
  'bjog',
  'bmc-anesthesiology',
  'bmc-biochemistry',
  'bmc-bioinformatics',
  'bmc-biology',
  'bmc-biophysics',
  'bmc-biotechnology',
  'bmc-cancer',
  'bmc-cardiovascular-disorders',
  'bmc-cell-biology',
  'bmc-clinical-pathology',
  'bmc-complementary-and-alternative-medicine',
  'bmc-dermatology',
  'bmc-developmental-biology',
  'bmc-ear-nose-and-throat-disorders',
  'bmc-ecology',
  'bmc-emergency-medicine',
  'bmc-endocrine-disorders',
  'bmc-evolutionary-biology',
  'bmc-family-practice',
  'bmc-gastroenterology',
  'bmc-genetics',
  'bmc-genomics',
  'bmc-geriatrics',
  'bmc-health-services-research',
  'bmc-hematology',
  'bmc-immunology',
  'bmc-infectious-diseases',
  'bmc-international-health-and-human-rights',
  'bmc-medical-education',
  'bmc-medical-ethics',
  'bmc-medical-genetics',
  'bmc-medical-genomics',
  'bmc-medical-imaging',
  'bmc-medical-informatics-and-decision-making',
  'bmc-medical-physics',
  'bmc-medical-research-methodology',
  'bmc-medicine',
  'bmc-microbiology',
  'bmc-molecular-biology',
  'bmc-musculoskeletal-disorders',
  'bmc-nephrology',
  'bmc-neurology',
  'bmc-neuroscience',
  'bmc-nursing',
  'bmc-nutrition',
  'bmc-obesity',
  'bmc-ophthalmology',
  'bmc-oral-health',
  'bmc-palliative-care',
  'bmc-pediatrics',
  'bmc-pharmacology-and-toxicology',
  'bmc-physiology',
  'bmc-plant-biology',
  'bmc-pregnancy-and-childbirth',
  'bmc-proceedings',
  'bmc-psychiatry',
  'bmc-psychology',
  'bmc-public-health',
  'bmc-pulmonary-medicine',
  'bmc-research-notes',
  'bmc-sports-science-medicine-and-rehabilitation',
  'bmc-structural-biology',
  'bmc-surgery',
  'bmc-systems-biology',
  'bmc-urology',
  'bmc-veterinary-research',
  'bmc-womens-health',
  'bmc-zoology',
  'bmj',
  'bmj-case-reports',
  'bmj-open',
  'bmj-open-diabetes-research-and-care',
  'bmj-open-respiratory-research',
  'bmj-quality-and-safety',
  'bmj-quality-improvement-reports',
  'bmj-supportive-and-palliative-care',
  'brq-business-research-quarterly',
  'byzantina-symmeikta',
  'babes-bolyai-university-faculty-of-orthodox-theology',
  'bacteriophage',
  'bandung-journal-of-the-global-south',
  'bangladesh-journal-of-child-health',
  'basal-ganglia',
  'basic-research-in-cardiology',
  'basic-and-applied-ecology',
  'basic-and-applied-pathology',
  'basic-and-clinical-andrology',
  'behavior-analysis-in-practice',
  'behavior-genetics',
  'behavior-therapy',
  'behavioral-ecology',
  'behavioral-ecology-and-sociobiology',
  'behavioral-neuroscience',
  'behavioral-sciences',
  'behavioral-sciences-of-terrorism-and-political-aggression',
  'behavioral-and-brain-functions',
  'behaviour-research-and-therapy',
  'behavioural-brain-research',
  'behavioural-processes',
  'beitrage-zur-algebra-und-geometrie-contributions-to-algebra-and-geometry',
  'beitrage-zur-popularmusikforschung',
  'bell-labs-technical-journal',
  'beltz-padagogik',
  'beni-suef-university-journal-of-basic-and-applied-sciences',
  'berliner-journal-fur-soziologie',
  'best-practice-and-research-clinical-anaesthesiology',
  'best-practice-and-research-clinical-endocrinology-and-metabolism',
  'best-practice-and-research-clinical-gastroenterology',
  'best-practice-and-research-clinical-haematology',
  'best-practice-and-research-clinical-obstetrics-and-gynaecology',
  'best-practice-and-research-clinical-rheumatology',
  'bibtex',
  'bibliotek-for-laeger',
  'big-data-analytics',
  'big-data-research',
  'bijblijven',
  'biocontrol',
  'biodata-mining',
  'biodrugs',
  'bioenergy-research',
  'bioessays',
  'biomed-central',
  'biomed-research-international',
  'biomedical-engineering-online',
  'biomedicine',
  'biometals',
  'bionanoscience',
  'biopsychosocial-medicine',
  'bioresources',
  'biosystems',
  'biotechniques',
  'bioactive-carbohydrates-and-dietary-fibre',
  'bioactive-materials',
  'bioanalysis',
  'bioarchaeology-of-the-near-east',
  'bioarchitecture',
  'biocatalysis-and-agricultural-biotechnology',
  'biochemical-engineering-journal',
  'biochemical-genetics',
  'biochemical-journal',
  'biochemical-pharmacology',
  'biochemical-society-transactions',
  'biochemical-systematics-and-ecology',
  'biochemical-and-biophysical-research-communications',
  'biochemistry',
  'biochemistry-and-biophysics-reports',
  'biochimica-et-biophysica-acta',
  'biochimie',
  'biochimie-open',
  'bioconjugate-chemistry',
  'biocontrol-science-and-technology',
  'biocybernetics-and-biomedical-engineering',
  'biodegradation',
  'biodiversity',
  'biodiversity-and-conservation',
  'bioelectrochemistry',
  'bioelectromagnetics',
  'bioengineered',
  'bioengineering',
  'biofabrication',
  'biofouling',
  'biofuels',
  'biogeochemistry',
  'biogeosciences',
  'biogeosciences-discussions',
  'biogerontology',
  'bioinformatics',
  'bioinspiration-and-biomimetics',
  'biologia',
  'biological-agriculture-and-horticulture',
  'biological-conservation',
  'biological-control',
  'biological-cybernetics',
  'biological-invasions',
  'biological-journal-of-the-linnean-society',
  'biological-procedures-online',
  'biological-psychiatry',
  'biological-psychology',
  'biological-research',
  'biological-reviews',
  'biological-rhythm-research',
  'biological-theory',
  'biological-trace-element-research',
  'biological-and-pharmaceutical-bulletin',
  'biologically-inspired-cognitive-architectures',
  'biologicals',
  'biologics-in-therapy',
  'biology',
  'biology-and-philosophy',
  'biology-direct',
  'biology-letters',
  'biology-open',
  'biology-and-fertility-of-soils',
  'biology-of-blood-and-marrow-transplantation',
  'biology-of-mood-and-anxiety-disorders',
  'biology-of-reproduction',
  'biology-of-sex-differences',
  'biomacromolecules',
  'biomarker-research',
  'biomarkers-and-genomic-medicine',
  'biomarkers-in-medicine',
  'biomass-conversion-and-biorefinery',
  'biomass-and-bioenergy',
  'biomaterials',
  'biomaterials-research',
  'biomaterials-science',
  'biomatter',
  'biomechanics-and-modeling-in-mechanobiology',
  'biomedical-imaging-and-intervention-journal',
  'biomedical-materials',
  'biomedical-microdevices',
  'biomedical-reports',
  'biomedical-reviews',
  'biomedical-signal-processing-and-control',
  'biomedicine-and-aging-pathology',
  'biomedicine-and-pharmacotherapy',
  'biomedicine-and-preventive-nutrition',
  'biomedicines',
  'biometrics',
  'biomicrofluidics',
  'biomolecular-detection-and-quantification',
  'biomolecular-nmr-assignments',
  'biomolecules',
  'bioorganic-and-medicinal-chemistry-letters',
  'bioorganic-chemistry',
  'biophysical-chemistry',
  'biophysical-economics-and-resource-quality',
  'biophysical-journal',
  'biophysical-reviews',
  'biophysics-reports',
  'biopolymers',
  'bioprocess-and-biosystems-engineering',
  'bioresource-technology',
  'bioresources-and-bioprocessing',
  'biosemiotics',
  'biosensors',
  'biosensors-and-bioelectronics',
  'biosurface-and-biotribology',
  'biosystems-engineering',
  'biotechnology-advances',
  'biotechnology-letters',
  'biotechnology-progress',
  'biotechnology-reports',
  'biotechnology-and-bioengineering',
  'biotechnology-and-genetic-engineering-reviews',
  'biotechnology-for-biofuels',
  'biotribology',
  'biotropica',
  'blood',
  'blood-cancer-journal',
  'blood-cells-molecules-and-diseases',
  'blood-purification',
  'blood-reviews',
  'bluebook-inline',
  'bluebook-law-review',
  'bluebook2',
  'body-and-society',
  'body-image',
  'body-movement-and-dance-in-psychotherapy',
  'boletin-medico-del-hospital-infantil-de-mexico',
  'boletin-de-la-sociedad-espanola-de-ceramica-y-vidrio',
  'boletin-de-la-sociedad-matematica-mexicana',
  'bollettino-dellunione-matematica-italiana',
  'bone',
  'bone-and-joint-research',
  'bone-marrow-transplantation',
  'bone-reports',
  'borderline-personality-disorder-and-emotion-dysregulation',
  'boreal-environment-research',
  'borsa-istanbul-review',
  'botanical-studies',
  'boundary-value-problems',
  'boundary-layer-meteorology',
  'brain',
  'brain-behavior-and-immunity',
  'brain-imaging-and-behavior',
  'brain-informatics',
  'brain-research',
  'brain-research-bulletin',
  'brain-sciences',
  'brain-stimulation',
  'brain-structure-and-function',
  'brain-topography',
  'brain-tumor-pathology',
  'brain-and-cognition',
  'brain-and-development',
  'brain-and-language',
  'brain-behavior-and-evolution',
  'brazilian-journal-of-botany',
  'brazilian-journal-of-infectious-diseases',
  'brazilian-journal-of-physics',
  'brazilian-journal-of-science-and-technology',
  'breast-cancer',
  'breast-cancer-management',
  'breast-cancer-research',
  'breast-cancer-research-and-treatment',
  'breast-care',
  'briefings-in-bioinformatics',
  'british-dental-journal',
  'british-ecological-society',
  'british-journal-of-anaesthesia',
  'british-journal-of-biomedical-science',
  'british-journal-of-cancer',
  'british-journal-of-clinical-psychology',
  'british-journal-of-dermatology',
  'british-journal-of-developmental-psychology',
  'british-journal-of-educational-psychology',
  'british-journal-of-guidance-and-counselling',
  'british-journal-of-haematology',
  'british-journal-of-health-psychology',
  'british-journal-of-industrial-relations',
  'british-journal-of-mathematical-and-statistical-psychology',
  'british-journal-of-ophthalmology',
  'british-journal-of-pain',
  'british-journal-of-pharmacology',
  'british-journal-of-political-science',
  'british-journal-of-psychology',
  'british-journal-of-religious-education',
  'british-journal-of-social-psychology',
  'british-journal-of-sociology-of-education',
  'british-journal-of-sports-medicine',
  'british-journal-of-surgery',
  'british-medical-bulletin',
  'building-research-and-information',
  'building-structure',
  'building-and-construction-law-journal',
  'building-and-environment',
  'buildings',
  'bulletin-de-la-societe-prehistorique-francaise',
  'bulletin-des-sciences-mathematiques',
  'bulletin-du-cancer',
  'bulletin-of-earthquake-engineering',
  'bulletin-of-engineering-geology-and-the-environment',
  'bulletin-of-environmental-contamination-and-toxicology',
  'bulletin-of-faculty-of-pharmacy-cairo-university',
  'bulletin-of-marine-science',
  'bulletin-of-mathematical-biology',
  'bulletin-of-mathematical-sciences',
  'bulletin-of-volcanology',
  'bulletin-of-the-american-meteorological-society',
  'bulletin-of-the-chemical-society-of-japan',
  'bulletin-of-the-malaysian-mathematical-sciences-society',
  'bulletin-of-the-world-health-organization',
  'bundesgesundheitsblatt-gesundheitsforschung-gesundheitsschutz',
  'burnout-research',
  'burns',
  'burns-and-trauma',
  'business-and-information-systems-engineering',
  'business-history',
  'business-horizons',
  'business-research',
  'ceas-aeronautical-journal',
  'ceas-space-journal',
  'cen-case-reports',
  'chimia',
  'clara-architecture-recherche',
  'cmaj',
  'cns-and-neurological-disorders-drug-targets',
  'cns-drugs',
  'cns-oncology',
  'copd-research-and-practice',
  'cpt-pharmacometrics-and-systems-pharmacology',
  'csi-transactions-on-ict',
  'cahiers-de-nutrition-et-de-dietetique',
  'cahiers-de-la-puericultrice',
  'cahiers-du-centre-gustave-glotz',
  'calcified-tissue-international',
  'calcolo',
  'calculus-of-variations-and-partial-differential-equations',
  'calphad',
  'cambridge-archaeological-journal',
  'cambridge-journal-of-education',
  'campus-adventiste-du-saleve-faculte-adventiste-de-theologie',
  'canada-journal-of-public-health',
  'canadian-association-of-radiologists-journal',
  'canadian-family-physician',
  'mcgill-en',
  'mcgill-en-8th-edition',
  'canadian-journal-of-african-studies-la-revue-canadienne-des-etudes-africaines',
  'canadian-journal-of-anesthesia',
  'canadian-journal-of-behavioural-science',
  'canadian-journal-of-cardiology',
  'canadian-journal-of-development-studies-revue-canadienne-detudes-du-developpement',
  'canadian-journal-of-diabetes',
  'canadian-journal-of-dietetic-practice-and-research',
  'canadian-journal-of-electrical-and-computer-engineering',
  'canadian-journal-of-experimental-psychology',
  'canadian-journal-of-fisheries-and-aquatic-sciences',
  'canadian-journal-of-kidney-health-and-disease',
  'canadian-journal-of-occupational-therapy',
  'canadian-journal-of-ophthalmology',
  'canadian-journal-of-philosophy',
  'canadian-journal-of-surgery',
  'canadian-journal-of-veterinary-research',
  'canadian-pharmacists-journal',
  'canadian-psychology',
  'canadian-public-policy',
  'cancer-and-metabolism',
  'cancer-radiotherapie',
  'cancer-biology-and-medicine',
  'cancer-biology-and-therapy',
  'cancer-causes-and-control',
  'cancer-cell',
  'cancer-cell-international',
  'cancer-chemotherapy-and-pharmacology',
  'cancer-discovery',
  'cancer-epidemiology',
  'cancer-epidemiology-biomarkers-and-prevention',
  'cancer-gene-therapy',
  'cancer-imaging',
  'cancer-immunology-research',
  'cancer-immunology-immunotherapy',
  'cancer-letters',
  'cancer-microenvironment',
  'cancer-nanotechnology',
  'cancer-prevention-research',
  'cancer-research',
  'cancer-treatment-communications',
  'cancer-treatment-reviews',
  'cancer-and-metastasis-reviews',
  'cancers',
  'canine-genetics-and-epidemiology',
  'capitalism-nature-socialism',
  'carbohydrate-polymers',
  'carbohydrate-research',
  'carbon',
  'carbon-balance-and-management',
  'carbon-management',
  'carbonates-and-evaporites',
  'carcinogenesis',
  'harvard-cardiff-university-biosi-and-carbs',
  'cardio-oncology',
  'cardiovascular-and-interventional-radiology',
  'cardiocore',
  'cardiology',
  'cardiology-and-therapy',
  'cardiorenal-medicine',
  'cardiovascular-diabetology',
  'cardiovascular-drugs-and-therapy',
  'cardiovascular-intervention-and-therapeutics',
  'cardiovascular-pathology',
  'cardiovascular-research',
  'cardiovascular-revascularization-medicine',
  'cardiovascular-toxicology',
  'cardiovascular-ultrasound',
  'caries-research',
  'cartography-and-geographic-information-science',
  'case-reports-in-dermatology',
  'case-reports-in-gastroenterology',
  'case-reports-in-nephrology-and-urology',
  'case-reports-in-neurology',
  'case-reports-in-oncology',
  'case-reports-in-ophthalmology',
  'case-reports-in-womens-health',
  'case-studies-in-construction-materials',
  'case-studies-in-engineering-failure-analysis',
  'case-studies-in-fire-safety',
  'case-studies-in-mechanical-systems-and-signal-processing',
  'case-studies-in-nondestructive-testing-and-evaluation',
  'case-studies-in-structural-engineering',
  'case-studies-in-thermal-engineering',
  'case-studies-on-transport-policy',
  'catalysis-communications',
  'catalysis-letters',
  'catalysis-science-and-technology',
  'catalysis-surveys-from-asia',
  'catalysis-today',
  'catalysts',
  'catena',
  'catholic-biblical-association',
  'catholic-biblical-quarterly',
  'celestial-mechanics-and-dynamical-astronomy',
  'cell',
  'cell-and-bioscience',
  'cell-adhesion-and-migration',
  'cell-biochemistry-and-biophysics',
  'cell-biology-and-toxicology',
  'cell-calcium',
  'cell-communication-and-signaling',
  'cell-cycle',
  'cell-death-and-differentiation',
  'cell-death-and-disease',
  'cell-division',
  'cell-host-and-microbe',
  'cell-metabolism',
  'cell-regeneration',
  'cell-reports',
  'cell-research',
  'cell-stem-cell',
  'cell-stress-and-chaperones',
  'cell-systems',
  'cell-transplantation',
  'cell-and-tissue-banking',
  'cell-and-tissue-research',
  'cell-numeric',
  'cells',
  'cells-tissues-organs',
  'cellular-immunology',
  'cellular-logistics',
  'cellular-microbiology',
  'cellular-oncology',
  'cellular-physiology-and-biochemistry',
  'cellular-reprogramming',
  'cellular-signalling',
  'cellular-and-molecular-bioengineering',
  'cellular-and-molecular-gastroenterology-and-hepatology',
  'cellular-and-molecular-immunology',
  'cellular-and-molecular-life-sciences',
  'cellular-and-molecular-neurobiology',
  'cellulose',
  'cement-and-concrete-composites',
  'cement-and-concrete-research',
  'centaurus',
  'central-asian-survey',
  'central-european-journal-of-operations-research',
  'central-european-journal-of-urology',
  'centre-de-recherche-sur-les-civilisations-de-l-asie-orientale',
  'cephalalgia',
  'ceramics-international',
  'cerebellum-and-ataxias',
  'cerebral-cortex',
  'cerebrovascular-diseases',
  'cerebrovascular-diseases-extra',
  'cerevisia',
  'challenges',
  'changer-d-epoque',
  'changing-english',
  'channels',
  'chaos',
  'chemtexts',
  'chemical-communications',
  'chemical-engineering-and-processing-process-intensification',
  'chemical-engineering-journal',
  'chemical-engineering-research-and-design',
  'chemical-engineering-science',
  'chemical-geology',
  'chemical-physics',
  'chemical-research-in-toxicology',
  'chemical-reviews',
  'chemical-science',
  'chemical-senses',
  'chemical-society-reviews',
  'chemical-and-biological-technologies-in-agriculture',
  'chemical-and-pharmaceutical-bulletin',
  'chemico-biological-interactions',
  'chemistry-and-biology',
  'chemistry-central-journal',
  'chemistry-education-research-and-practice',
  'chemistry-letters',
  'chemistry-world',
  'chemistry-and-ecology',
  'chemistry-and-physics-of-lipids',
  'chemistry-of-materials',
  'chemoecology',
  'chemometrics-and-intelligent-laboratory-systems',
  'chemosensors',
  'chemosensory-perception',
  'chemosphere',
  'chemotherapy',
  'chest',
  'chicago-author-date',
  'chicago-author-date-basque',
  'chicago-author-date-fr',
  'chicago-author-date-de',
  'chicago-figures',
  'chicago-fullnote-bibliography',
  'chicago-fullnote-bibliography-fr',
  'chicago-fullnote-bibliography-no-ibid',
  'chicago-library-list',
  'chicago-annotated-bibliography',
  'chicago-note-biblio-no-ibid',
  'chicago-17-author-date',
  'chicago-note-bibliography',
  'chicago-17-fullnote-bibliography',
  'chicago-17-fullnote-bibliography',
  'child-and-youth-care-forum',
  'child-abuse-and-neglect',
  'child-indicators-research',
  'child-neuropsychology',
  'child-psychiatry-and-human-development',
  'child-and-adolescent-psychiatry-and-mental-health',
  'child-and-adolescent-social-work-journal',
  'childs-nervous-system',
  'children',
  'children-and-youth-services-review',
  'childrens-geographies',
  'chimerism',
  'china-communications',
  'china-economic-journal',
  'china-economic-review',
  'china-finance-and-economic-review',
  'china-journal-of-accounting-research',
  'china-journal-of-accounting-studies',
  'china-journal-of-economic-research',
  'china-journal-of-social-work',
  'china-eu-law-journal',
  'chinese-chemical-letters',
  'chinese-journal-of-aeronautics',
  'chinese-journal-of-cancer',
  'chinese-journal-of-chemical-engineering',
  'chinese-journal-of-communication',
  'chinese-journal-of-population-resources-and-environment',
  'chinese-journal-of-traumatology',
  'chinese-medical-journal',
  'chinese-medicine',
  'chinese-neurosurgical-journal',
  'chinese-nursing-research',
  'chinese-physics-b',
  'chinese-physics-c',
  'chinese-physics-letters',
  'chinese-political-science-review',
  'chinese-gb7714-1987-numeric',
  'chinese-gb7714-2005-author-date',
  'chinese-gb7714-2005-numeric',
  'chiropractic-and-manual-therapies',
  'chiropractic-journal-of-australia',
  'chirurgie-de-la-main',
  'chromatographia',
  'chromatography',
  'chromosoma',
  'chromosome-research',
  'chronic-diseases-and-injuries-in-canada',
  'chronic-diseases-and-translational-medicine',
  'chroniques-des-activites-archeologiques-de-l-ecole-francaise-de-rome',
  'ciencias-clinicas',
  'cilia',
  'circuits-systems-and-signal-processing',
  'circulation',
  'cirugia-cardiovascular',
  'cirugia-espanola',
  'cirugia-y-cirujanos',
  'cirujano-general',
  'harvard-cite-them-right-10',
  'harvard-cite-them-right-11',
  'harvard-cite-them-right-12',
  'cities',
  'citizenship-studies',
  'city',
  'city-and-community',
  'city-culture-and-society',
  'city-territory-and-architecture',
  'civil-engineering-and-environmental-systems',
  'cladistics',
  'classical-and-quantum-gravity',
  'classroom-discourse',
  'clay-minerals',
  'clays-and-clay-minerals',
  'clean-technologies-and-environmental-policy',
  'climacteric',
  'climate',
  'climate-change-responses',
  'climate-dynamics',
  'climate-policy',
  'climate-research',
  'climate-risk-management',
  'climate-services',
  'climate-of-the-past',
  'climate-of-the-past-discussions',
  'climatic-change',
  'clinica-chimica-acta',
  'clinical-and-experimental-metastasis',
  'clinical-and-experimental-ophthalmology',
  'clinical-and-translational-immunology',
  'clinical-autonomic-research',
  'clinical-biochemistry',
  'clinical-biomechanics',
  'clinical-breast-cancer',
  'clinical-cancer-research',
  'clinical-chemistry',
  'clinical-child-and-family-psychology-review',
  'clinical-colorectal-cancer',
  'clinical-diabetes-and-endocrinology',
  'clinical-drug-investigation',
  'clinical-epidemiology-and-global-health',
  'clinical-epigenetics',
  'clinical-gastroenterology-and-hepatology',
  'clinical-genitourinary-cancer',
  'clinical-hypertension',
  'clinical-imaging',
  'clinical-immunology',
  'clinical-infectious-diseases',
  'clinical-investigation',
  'clinical-journal-of-gastroenterology',
  'clinical-laboratory',
  'clinical-lipidology',
  'clinical-lung-cancer',
  'clinical-lymphoma-myeloma-and-leukemia',
  'clinical-medicine',
  'clinical-microbiology-newsletter',
  'clinical-microbiology-reviews',
  'clinical-microbiology-and-infection',
  'clinical-neurology-and-neurosurgery',
  'clinical-neurophysiology',
  'clinical-neuroradiology',
  'clinical-nuclear-medicine',
  'clinical-nutrition',
  'clinical-nutrition-espen',
  'clinical-nutrition-experimental',
  'clinical-oncology',
  'clinical-oral-investigations',
  'clinical-orthopaedics-and-related-research',
  'clinical-otolaryngology',
  'clinical-ovarian-and-other-gynecologic-cancer',
  'clinical-pediatrics',
  'clinical-pharmacokinetics',
  'clinical-pharmacology-and-therapeutics',
  'clinical-phytoscience',
  'clinical-plasma-medicine',
  'clinical-practice',
  'clinical-practice-in-pediatric-psychology',
  'clinical-proteomics',
  'clinical-psychology-review',
  'clinical-queries-nephrology',
  'clinical-research-in-cardiology',
  'clinical-research-in-cardiology-supplements',
  'clinical-reviews-in-allergy-and-immunology',
  'clinical-reviews-in-bone-and-mineral-metabolism',
  'clinical-rheumatology',
  'clinical-sarcoma-research',
  'clinical-simulation-in-nursing',
  'clinical-skin-cancer',
  'clinical-social-work-journal',
  'clinical-therapeutics',
  'clinical-trials-and-regulatory-science-in-cardiology',
  'clinical-and-experimental-medicine',
  'clinical-and-experimental-nephrology',
  'clinical-and-experimental-optometry',
  'clinical-and-experimental-pharmacology-and-physiology',
  'clinical-and-investigative-medicine',
  'clinical-and-molecular-allergy',
  'clinical-and-translational-allergy',
  'clinical-and-translational-gastroenterology',
  'clinical-and-translational-imaging',
  'clinical-and-translational-medicine',
  'clinical-and-translational-oncology',
  'clinical-and-vaccine-immunology',
  'clinicians-research-digest',
  'clinics-and-research-in-hepatology-and-gastroenterology',
  'clinics-in-dermatology',
  'clio-medica',
  'cliometrica',
  'cluster-computing',
  'clinica-e-investigacion-en-arteriosclerosis',
  'clinica-y-salud',
  'codesign',
  'coaching-theorie-and-praxis',
  'coaching-an-international-journal-of-theory-research-and-practice',
  'coastal-engineering',
  'coatings',
  'coevolution',
  'cognition',
  'cognition-and-emotion',
  'cognition-technology-and-work',
  'cognitive-computation',
  'cognitive-development',
  'cognitive-neurodynamics',
  'cognitive-neuropsychiatry',
  'cognitive-neuropsychology',
  'cognitive-neuroscience',
  'cognitive-processing',
  'cognitive-psychology',
  'cognitive-research',
  'cognitive-systems-research',
  'cognitive-therapy-and-research',
  'cognitive-and-behavioral-practice',
  'cold-regions-science-and-technology',
  'cold-spring-harbor-laboratory-press',
  'collectanea-mathematica',
  'collection-de-l-ecole-francaise-de-rome-full-note',
  'collection-de-l-ecole-francaise-de-rome-note',
  'collection-du-centre-jean-berard',
  'collections-electroniques-de-l-inha-author-date',
  'collections-electroniques-de-l-inha-full-note',
  'collegian',
  'colloid-and-polymer-science',
  'colloids-and-interface-science-communications',
  'colloids-and-surfaces-a-physicochemical-and-engineering-aspects',
  'colloids-and-surfaces-b-biointerfaces',
  'colombia-medica',
  'colombian-journal-of-anesthesiology',
  'colorectal-cancer',
  'combinatorial-chemistry-and-high-throughput-screening',
  'combinatorial-chemistry-an-online-journal',
  'comision-economica-para-america-latina-y-el-caribe',
  'communication-education',
  'communication-teacher',
  'communication-et-langages',
  'communications-in-mathematical-physics',
  'communications-in-mathematics-and-statistics',
  'communications-in-nonlinear-science-and-numerical-simulation',
  'communications-in-theoretical-physics',
  'communicative-and-integrative-biology',
  'communist-and-post-communist-studies',
  'community-dentistry-and-oral-epidemiology',
  'community-mental-health-journal',
  'community-work-and-family',
  'company-and-securities-law-journal',
  'comparative-biochemistry-and-physiology-part-d-genomics-and-proteomics',
  'comparative-biochemistry-and-physiology-part-a',
  'comparative-biochemistry-and-physiology-part-b',
  'comparative-biochemistry-and-physiology-part-c',
  'comparative-clinical-pathology',
  'comparative-education',
  'comparative-immunology-microbiology-and-infectious-diseases',
  'comparative-medicine',
  'comparative-migration-studies',
  'compare-a-journal-of-comparative-and-international-education',
  'complementary-therapies-in-clinical-practice',
  'complementary-therapies-in-medicine',
  'complex-and-intelligent-systems',
  'complex-adaptive-systems-modeling',
  'complex-analysis-and-operator-theory',
  'complex-analysis-and-its-synergies',
  'complex-variables-and-elliptic-equations',
  'composite-interfaces',
  'composite-structures',
  'composites-part-a',
  'composites-part-b',
  'composites-science-and-technology',
  'comprehensive-psychiatry',
  'comptes-rendus-biologies',
  'comptes-rendus-geoscience',
  'comptes-rendus-mathematique',
  'comptes-rendus-mecanique',
  'comptes-rendus-palevol',
  'comptes-rendus-physique',
  'computation',
  'computational-astrophysics-and-cosmology',
  'computational-biology-and-chemistry',
  'computational-cognitive-science',
  'computational-condensed-matter',
  'computational-economics',
  'computational-geometry-theory-and-applications',
  'computational-geosciences',
  'computational-management-science',
  'computational-materials-science',
  'computational-mechanics',
  'computational-methods-and-function-theory',
  'computational-optimization-and-applications',
  'computational-particle-mechanics',
  'computational-science-and-discovery',
  'computational-social-networks',
  'computational-statistics',
  'computational-statistics-and-data-analysis',
  'computational-and-applied-mathematics',
  'computational-and-mathematical-organization-theory',
  'computational-and-structural-biotechnology-journal',
  'computational-and-theoretical-chemistry',
  'computer',
  'computer-aided-geometric-design',
  'computer-architecture-letters',
  'computer-assisted-language-learning',
  'computer-communications',
  'computer-languages-systems-and-structures',
  'computer-law-and-security-review-the-international-journal-of-technology-law-and-practice',
  'computer-methods-and-programs-in-biomedicine',
  'computer-methods-in-applied-mechanics-and-engineering',
  'computer-methods-in-biomechanics-and-biomedical-engineering',
  'computer-methods-in-biomechanics-and-biomedical-engineering-imaging-and-visualization',
  'computer-networks',
  'computer-physics-communications',
  'computer-science-research-and-development',
  'computer-science-education',
  'computer-science-review',
  'computer-speech-and-language',
  'computer-standards-and-interfaces',
  'computer-vision-and-image-understanding',
  'computer-und-recht',
  'computer-aided-design',
  'computerized-medical-imaging-and-graphics',
  'computers',
  'computers-and-education',
  'computers-and-graphics',
  'computers-and-industrial-engineering',
  'computers-and-security',
  'computers-and-chemical-engineering',
  'computers-and-composition',
  'computers-and-electrical-engineering',
  'computers-and-electronics-in-agriculture',
  'computers-and-fluids',
  'computers-and-geosciences',
  'computers-and-geotechnics',
  'computers-and-mathematics-with-applications',
  'computers-and-operations-research',
  'computers-and-structures',
  'computers-in-biology-and-medicine',
  'computers-in-entertainment',
  'computers-in-human-behavior',
  'computers-in-industry',
  'computers-environment-and-urban-systems',
  'computing',
  'computing-and-visualization-in-science',
  'computing-in-science-and-engineering',
  'conflict-and-health',
  'connection-science',
  'consciousness-and-cognition',
  'conservation-biology',
  'conservation-genetics',
  'conservation-genetics-resources',
  'conservation-letters',
  'conservation-physiology',
  'constellations',
  'constitutional-political-economy',
  'constraints',
  'construction-and-building-materials',
  'constructive-approximation',
  'consulting-psychology-journal-practice-and-research',
  'consumption-markets-and-culture',
  'contact-lens-and-anterior-eye',
  'contaduria-y-administracion',
  'contemporary-arab-affairs',
  'contemporary-british-history',
  'contemporary-buddhism',
  'contemporary-clinical-trials',
  'contemporary-clinical-trials-communications',
  'contemporary-educational-psychology',
  'contemporary-family-therapy',
  'contemporary-islam',
  'contemporary-italian-politics',
  'contemporary-jewry',
  'contemporary-justice-review',
  'contemporary-school-psychology',
  'contemporary-social-science',
  'contemporary-sociology',
  'contemporary-south-asia',
  'continental-philosophy-review',
  'continental-shelf-research',
  'continuum',
  'continuum-mechanics-and-thermodynamics',
  'contraception',
  'contraception-and-reproductive-medicine',
  'contributions-to-mineralogy-and-petrology',
  'control-and-automation',
  'control-engineering-practice',
  'coordination-chemistry-reviews',
  'copernicus-publications',
  'cor-et-vasa',
  'coral-reefs',
  'cornea',
  'coronary-artery-disease',
  'corrosion',
  'corrosion-science',
  'cortex',
  'cosmetics',
  'cost-effectiveness-and-resource-allocation',
  'cough',
  'council-of-science-editors-alphabetical',
  'council-of-science-editors',
  'council-of-science-editors-author-date',
  'counselling-psychology-quarterly',
  'counselling-and-psychotherapy-research',
  'couple-and-family-psychology-research-and-practice',
  'cranfield-university-numeric',
  'creativity-and-innovation-management',
  'cretaceous-research',
  'crime-science',
  'crime-law-and-social-change',
  'criminal-justice-studies',
  'criminal-law-journal',
  'crisis-the-journal-of-crisis-intervention-and-suicide-prevention',
  'critical-african-studies',
  'critical-care',
  'critical-care-medicine',
  'critical-criminology',
  'critical-discourse-studies',
  'critical-perspectives-on-accounting',
  'critical-public-health',
  'critical-reviews-in-oncology-hematology',
  'critical-studies-in-media-communication',
  'critical-studies-on-security',
  'critical-studies-on-terrorism',
  'critical-ultrasound-journal',
  'crop-and-pasture-science',
  'crop-protection',
  'crop-science',
  'cryobiology',
  'cryogenics',
  'cryptography-and-communications',
  'crystengcomm',
  'crystal-growth-and-design',
  'crystallography-reviews',
  'crystals',
  'cuadernos-de-economia',
  'cuadernos-de-economia-y-direccion-de-la-empresa',
  'cuadernos-de-filologia-clasica',
  'cultivos-tropicales',
  'cultural-diversity-and-ethnic-minority-psychology',
  'cultural-studies-of-science-education',
  'cultural-trends',
  'culture-and-brain',
  'culture-and-organization',
  'culture-and-religion',
  'culture-health-and-sexuality',
  'culture-medicine-and-psychiatry',
  'current-addiction-reports',
  'current-allergy-and-asthma-reports',
  'current-anesthesiology-reports',
  'current-applied-physics',
  'current-atherosclerosis-reports',
  'current-behavioral-neuroscience-reports',
  'current-biology',
  'current-bladder-dysfunction-reports',
  'current-breast-cancer-reports',
  'current-cardiology-reports',
  'current-cardiovascular-imaging-reports',
  'current-cardiovascular-risk-reports',
  'current-climate-change-reports',
  'current-clinical-microbiology-reports',
  'current-colorectal-cancer-reports',
  'current-dermatology-reports',
  'current-developmental-disorders-reports',
  'current-diabetes-reports',
  'current-emergency-and-hospital-medicine-reports',
  'current-environmental-health-reports',
  'current-epidemiology-reports',
  'current-eye-research',
  'current-forestry-reports',
  'current-fungal-infection-reports',
  'current-gastroenterology-reports',
  'current-genetic-medicine-reports',
  'current-genetics',
  'current-geriatrics-reports',
  'current-hiv-aids-reports',
  'current-heart-failure-reports',
  'current-hematologic-malignancy-reports',
  'current-hepatology-reports',
  'current-hypertension-reports',
  'current-infectious-disease-reports',
  'current-issues-in-language-planning',
  'current-issues-in-tourism',
  'current-landscape-ecology-reports',
  'current-medicine-research-and-practice',
  'current-microbiology',
  'current-molecular-biology-reports',
  'current-neurology-and-neuroscience-reports',
  'current-nutrition-reports',
  'current-obesity-reports',
  'current-obstetrics-and-gynecology-reports',
  'current-oncology-reports',
  'current-ophthalmology-reports',
  'current-opinion-in-behavioral-sciences',
  'current-opinion-in-biotechnology',
  'current-opinion-in-cell-biology',
  'current-opinion-in-chemical-biology',
  'current-opinion-in-chemical-engineering',
  'current-opinion-in-colloid-and-interface-science',
  'current-opinion-in-environmental-sustainability',
  'current-opinion-in-food-science',
  'current-opinion-in-genetics-and-development',
  'current-opinion-in-immunology',
  'current-opinion-in-insect-science',
  'current-opinion-in-microbiology',
  'current-opinion-in-neurobiology',
  'current-opinion-in-ophthalmology',
  'current-opinion-in-pharmacology',
  'current-opinion-in-plant-biology',
  'current-opinion-in-psychology',
  'current-opinion-in-solid-state-and-materials-science',
  'current-opinion-in-structural-biology',
  'current-opinion-in-virology',
  'current-opinion',
  'current-oral-health-reports',
  'current-osteoporosis-reports',
  'current-otorhinolaryngology-reports',
  'current-pain-and-headache-reports',
  'current-pathobiology-reports',
  'current-pediatrics-reports',
  'current-pharmacology-reports',
  'current-physical-medicine-and-rehabilitation-reports',
  'current-plant-biology',
  'current-pollution-reports',
  'current-problems-in-cardiology',
  'current-problems-in-pediatric-and-adolescent-health-care',
  'current-problems-in-surgery',
  'current-proteomics',
  'current-protocols',
  'current-psychiatry-reports',
  'current-psychology',
  'current-pulmonology-reports',
  'current-radiology-reports',
  'current-reviews-in-musculoskeletal-medicine',
  'current-rheumatology-reports',
  'current-sexual-health-reports',
  'current-sleep-medicine-reports',
  'current-stem-cell-reports',
  'current-surgery-reports',
  'current-sustainable-renewable-energy-reports',
  'current-therapeutic-research',
  'current-topics-in-medicinal-chemistry',
  'current-transplantation-reports',
  'current-trauma-reports',
  'current-treatment-options-in-allergy',
  'current-treatment-options-in-cardiovascular-medicine',
  'current-treatment-options-in-gastroenterology',
  'current-treatment-options-in-infectious-diseases',
  'current-treatment-options-in-neurology',
  'current-treatment-options-in-oncology',
  'current-treatment-options-in-pediatrics',
  'current-treatment-options-in-psychiatry',
  'current-treatment-options-in-rheumatology',
  'current-tropical-medicine-reports',
  'current-urology',
  'current-urology-reports',
  'currents-in-biblical-research',
  'currents-in-pharmacy-teaching-and-learning',
  'curriculum-journal',
  'customer-needs-and-solutions',
  'cytogenetic-and-genome-research',
  'cytokine',
  'cytokine-and-growth-factor-reviews',
  'cytometry',
  'cytotechnology',
  'cytotherapy',
  'daru-journal-of-pharmaceutical-sciences',
  'decision-indian-institute-of-management-calcutta',
  'din-1505-2-alphanumeric',
  'din-1505-2',
  'din-1505-2-numeric',
  'din-1505-2-numeric-alphabetical',
  'dna-repair',
  'dna-research',
  'dairy-science-and-technology',
  'dalton-transactions',
  'danish-medical-journal',
  'data-and-knowledge-engineering',
  'data-mining-and-knowledge-discovery',
  'data-science-and-engineering',
  'data-in-brief',
  'database',
  'datenbank-spektrum',
  'de-buck',
  'de-economist',
  'deakin-university-harvard',
  'debatte-journal-of-contemporary-central-and-eastern-europe',
  'decision',
  'decision-analytics',
  'decision-sciences',
  'decision-support-systems',
  'decisions-in-economics-and-finance',
  'deep-sea-research-part-i',
  'deep-sea-research-part-ii',
  'defence-technology',
  'dementia-and-geriatric-cognitive-disorders',
  'dementia-and-geriatric-cognitive-disorders-extra',
  'democratization',
  'demographic-research',
  'demography',
  'dendrochronologia',
  'dental-abstracts',
  'dental-materials',
  'dentistry-journal',
  'dentomaxillofacial-radiology',
  'der-anaesthesist',
  'der-chirurg',
  'der-diabetologe',
  'der-freie-zahnarzt',
  'der-gastroenterologe',
  'der-gynakologe',
  'der-hautarzt',
  'der-internist',
  'der-kardiologe',
  'der-mkg-chirurg',
  'der-nephrologe',
  'der-nervenarzt',
  'der-onkologe',
  'der-ophthalmologe',
  'der-orthopade',
  'der-pathologe',
  'der-pneumologe',
  'der-radiologe',
  'der-schmerz',
  'der-unfallchirurg',
  'der-urologe',
  'der-zoologische-garten',
  'dermato-endocrinology',
  'dermatology',
  'dermatology-and-therapy',
  'dermatopathology',
  'desalination',
  'design-automation-for-embedded-systems',
  'design-studies',
  'designed-monomers-and-polymers',
  'designs-codes-and-cryptography',
  'deutsche-gesellschaft-fur-psychologie',
  'deutsche-medizinische-wochenschrift',
  'deutsche-sprache',
  'deutsches-archaologisches-institut',
  'deutsches-arzteblatt',
  'development',
  'development-engineering',
  'development-genes-and-evolution',
  'development-policy-review',
  'development-in-practice',
  'developmental-biology',
  'developmental-cell',
  'developmental-cognitive-neuroscience',
  'developmental-neuroscience',
  'developmental-psychology',
  'developmental-review',
  'developmental-and-comparative-immunology',
  'diabetes',
  'diabetes-and-metabolic-syndrome-clinical-research-and-reviews',
  'diabetes-and-vascular-disease-research',
  'diabetes-care',
  'diabetes-management',
  'diabetes-research-and-clinical-practice',
  'diabetes-therapy',
  'diabetes-and-metabolism',
  'diabetologia',
  'diabetology-and-metabolic-syndrome',
  'diabetology-international',
  'diagnostic-cytopathology',
  'diagnostic-microbiology-and-infectious-disease',
  'diagnostic-pathology',
  'diagnostic-and-interventional-imaging',
  'diagnostics',
  'diagnostics-in-neuropsychiatry',
  'diagnostico-prenatal',
  'dialectical-anthropology',
  'dialisis-y-trasplante',
  'diamond-and-related-materials',
  'diaspora-studies',
  'diatom-research',
  'die-bachelorarbeit-samac-et-al-in-text',
  'die-bachelorarbeit-samac-et-al-note',
  'differential-equations-and-dynamical-systems',
  'differential-geometry-and-its-applications',
  'differentiation',
  'digestion',
  'digestive-diseases',
  'digestive-surgery',
  'digestive-and-liver-disease',
  'digestive-and-liver-disease-supplements',
  'digital-applications-in-archaeology-and-cultural-heritage',
  'digital-communications-and-networks',
  'digital-creativity',
  'digital-experiences-in-mathematics-education',
  'digital-investigation',
  'digital-journalism',
  'digital-signal-processing',
  'diplo',
  'disability-and-society',
  'disability-and-health-journal',
  'disability-and-rehabilitation',
  'disaster-health',
  'disaster-and-military-medicine',
  'discourse-context-and-media',
  'discourse-studies-in-the-cultural-politics-of-education',
  'discrete-and-computational-geometry',
  'discrete-applied-mathematics',
  'discrete-event-dynamic-systems',
  'discrete-mathematics',
  'discrete-optimization',
  'disease-models-and-mechanisms',
  'disease-a-month',
  'diseases',
  'diseases-of-aquatic-organisms',
  'diseases-of-the-colon-and-rectum',
  'diseases-of-the-esophagus',
  'displays',
  'distributed-computing',
  'distributed-and-parallel-databases',
  'diversity',
  'diversity-and-distributions',
  'documenta-ophthalmologica',
  'documents-d-archeologie-francaise',
  'domestic-animal-endocrinology',
  'douleurs-evaluation-diagnostic-traitement',
  'dramatherapy',
  'dreaming',
  'drinking-water-engineering-and-science',
  'drinking-water-engineering-and-science-discussions',
  'drug-delivery-and-translational-research',
  'drug-development-research',
  'drug-discovery-today-disease-mechanisms',
  'drug-discovery-today-disease-models',
  'drug-discovery-today-technologies',
  'drug-discovery-today-therapeutic-strategies',
  'drug-invention-today',
  'drug-metabolism-and-disposition',
  'drug-metabolism-and-pharmacokinetics',
  'drug-resistance-updates',
  'drug-safety',
  'drug-safety-case-reports',
  'drug-testing-and-analysis',
  'drug-and-alcohol-dependence',
  'drug-and-therapeutics-bulletin',
  'drugs',
  'drugs-and-aging',
  'drugs-and-therapy-perspectives',
  'drugs-real-world-outcomes',
  'drugs-in-r-and-d',
  'drugs-of-today',
  'drugs-of-the-future',
  'durchstarten-zur-diplomarbeit-in-text',
  'durchstarten-zur-diplomarbeit-note',
  'durchstarten-zur-vorwissenschaftlichen-arbeit-in-text',
  'durchstarten-zur-vorwissenschaftlichen-arbeit-note',
  'dyes-and-pigments',
  'dynamic-games-and-applications',
  'dynamical-systems',
  'dynamics-of-atmospheres-and-oceans',
  'dysphagia',
  'ebiomedicine',
  'ejc-supplements',
  'ejnmmi-physics',
  'ejnmmi-radiopharmacy-and-chemistry',
  'ejnmmi-research',
  'embo-reports',
  'ens-de-lyon-centre-d-ingenierie-documentaire',
  'epj-data-science',
  'epj-nonlinear-biomedical-physics',
  'epj-quantum-technology',
  'epj-techniques-and-instrumentation',
  'epl',
  'epma-journal',
  'era-forum',
  'eurasip-journal-on-advances-in-signal-processing',
  'eurasip-journal-on-audio-speech-and-music-processing',
  'eurasip-journal-on-bioinformatics-and-systems-biology',
  'eurasip-journal-on-embedded-systems',
  'eurasip-journal-on-image-and-video-processing',
  'eurasip-journal-on-information-security',
  'eurasip-journal-on-wireless-communications-and-networking',
  'euro-journal-on-computational-optimization',
  'euro-journal-on-decision-processes',
  'euro-journal-on-transportation-and-logistics',
  'ear-and-hearing',
  'early-child-development-and-care',
  'early-childhood-education-journal',
  'early-childhood-research-quarterly',
  'early-christianity',
  'early-human-development',
  'early-medieval-europe',
  'early-popular-visual-culture',
  'early-years',
  'earth-interactions',
  'earth-perspectives',
  'earth-science-informatics',
  'earth-surface-dynamics',
  'earth-surface-dynamics-discussions',
  'earth-surface-processes-and-landforms',
  'earth-system-dynamics',
  'earth-system-dynamics-discussions',
  'earth-system-science-data',
  'earth-system-science-data-discussions',
  'earth-and-planetary-science-letters',
  'earth-moon-and-planets',
  'earth-planets-and-space',
  'earth-science-reviews',
  'earthquake-engineering-and-structural-dynamics',
  'earthquake-science',
  'east-asian-archives-of-psychiatry',
  'east-european-jewish-affairs',
  'east-european-politics',
  'eastern-mediterranean-health-journal',
  'eating-behaviors',
  'eating-and-weight-disorders-studies-on-anorexia-bulimia-and-obesity',
  'ecclesial-practices',
  'ecohealth',
  'ecography',
  'ecohydrology-and-hydrobiology',
  'ecological-complexity',
  'ecological-economics',
  'ecological-engineering',
  'ecological-entomology',
  'ecological-genetics-and-genomics',
  'ecological-indicators',
  'ecological-informatics',
  'ecological-modelling',
  'ecological-processes',
  'ecological-research',
  'ecology',
  'ecology-letters',
  'ecology-and-society',
  'econometrics',
  'economia',
  'economia-politica',
  'economic-analysis-and-policy',
  'economic-change-and-restructuring',
  'economic-commission-for-latin-america-and-the-caribbean',
  'economic-modelling',
  'economic-systems',
  'economic-theory',
  'economic-theory-bulletin',
  'economics-letters',
  'economics-and-human-biology',
  'economics-of-education-review',
  'economics-of-governance',
  'economics-of-innovation-and-new-technology',
  'economics-of-transportation',
  'economies',
  'ecosistemas',
  'ecosystem-services',
  'ecosystems',
  'ecotoxicology',
  'ecotoxicology-and-environmental-safety',
  'educacion-medica-superior',
  'educacion-quimica',
  'education-and-practice',
  'education-3-13',
  'education-economics',
  'education-sciences',
  'education-and-information-technologies',
  'education-for-chemical-engineers',
  'education-in-chemistry',
  'educational-action-research',
  'educational-assessment-evaluation-and-accountability',
  'educational-evaluation-and-policy-analysis',
  'educational-media-international',
  'educational-philosophy-and-theory',
  'educational-psychology',
  'educational-psychology-review',
  'educational-psychology-in-practice',
  'educational-research',
  'educational-research-review',
  'educational-research-and-evaluation',
  'educational-research-for-policy-and-practice',
  'educational-researcher',
  'educational-review',
  'educational-studies',
  'educational-studies-in-mathematics',
  'educational-technology-research-and-development',
  'efficacy-and-mechanism-evaluation',
  'egyptian-informatics-journal',
  'egyptian-journal-of-anaesthesia',
  'egyptian-journal-of-basic-and-applied-sciences',
  'egyptian-journal-of-chest-diseases-and-tuberculosis',
  'egyptian-journal-of-ear-nose-throat-and-allied-sciences',
  'egyptian-journal-of-medical-human-genetics',
  'eighteenth-century-life',
  'ekonomie-a-management',
  'ekonomie-a-management-cs',
  'el-profesional-de-la-informacion',
  'electoral-studies',
  'electric-power-systems-research',
  'electrical-engineering',
  'electrocatalysis',
  'electrochemistry-communications',
  'electrochimica-acta',
  'electronic-commerce-research',
  'electronic-commerce-research-and-applications',
  'electronic-journal-of-biotechnology',
  'electronic-markets',
  'electronic-notes-in-discrete-mathematics',
  'electronic-notes-in-theoretical-computer-science',
  'electronics',
  'electronics-letters',
  'elsevier-with-titles',
  'elsevier-with-titles-alphabetical',
  'elsevier-without-titles',
  'elsevier-harvard',
  'elsevier-harvard-without-titles',
  'elsevier-harvard2',
  'elsevier-vancouver',
  'emerald-harvard',
  'emergency-medicine-journal',
  'emergency-radiology',
  'emerging-contaminants',
  'emerging-infectious-diseases',
  'emerging-markets-review',
  'emerging-microbes-and-infections',
  'emerging-themes-in-epidemiology',
  'emission-control-science-and-technology',
  'emotion',
  'emotion-space-and-society',
  'emotional-and-behavioural-difficulties',
  'empirica',
  'empirical-economics',
  'empirical-research-in-vocational-education-and-training',
  'empirical-software-engineering',
  'employee-responsibilities-and-rights-journal',
  'emu-austral-ornithology',
  'endangered-species-research',
  'endeavour',
  'endeavour-college-of-natural-health',
  'endocrine',
  'endocrine-disruptors',
  'endocrine-press',
  'endocrine-reviews',
  'endocrine-related-cancer',
  'endocrinologia-y-nutricion',
  'endocrinology',
  'endoscopia',
  'energies',
  'energy',
  'energy-and-buildings',
  'energy-and-environmental-science',
  'energy-and-fuels',
  'energy-conversion-and-management',
  'energy-economics',
  'energy-efficiency',
  'energy-policy',
  'energy-reports',
  'energy-research-and-social-science',
  'energy-storage-materials',
  'energy-strategy-reviews',
  'energy-systems',
  'energy-for-sustainable-development',
  'energy-ecology-and-environment',
  'energy-sustainability-and-society',
  'enfermedades-infecciosas-y-microbiologia-clinica',
  'enfermeria-clinica',
  'enfermeria-intensiva',
  'engineering-and-technology',
  'engineering-analysis-with-boundary-elements',
  'engineering-applications-of-artificial-intelligence',
  'engineering-failure-analysis',
  'engineering-fracture-mechanics',
  'engineering-geology',
  'engineering-geology-special-publications',
  'engineering-management-journal',
  'engineering-optimization',
  'engineering-science-and-technology-an-international-journal',
  'engineering-structures',
  'engineering-in-agriculture-environment-and-food',
  'engineering-in-life-sciences',
  'engineering-with-computers',
  'english-for-specific-purposes',
  'ensayos-sobre-politica-economica',
  'enterprise-information-systems',
  'entertainment-computing',
  'entomologia-experimentalis-et-applicata',
  'entomological-society-of-america',
  'entrepreneurship-and-regional-development',
  'entrepreneurship-theory-and-practice',
  'entropy',
  'environment-international',
  'environment-systems-and-decisions',
  'environment-and-planning',
  'environment-and-planning-a',
  'environment-and-planning-b-planning-and-design',
  'environment-and-planning-c-government-and-policy',
  'environment-and-planning-d-society-and-space',
  'environment-and-urbanization',
  'environment-development-and-sustainability',
  'environmental-and-engineering-geoscience',
  'environmental-biology-of-fishes',
  'environmental-chemistry',
  'environmental-chemistry-letters',
  'environmental-communication-a-journal-of-nature-and-culture',
  'environmental-conservation',
  'environmental-development',
  'environmental-earth-sciences',
  'environmental-economics-and-policy-studies',
  'environmental-education-research',
  'environmental-entomology',
  'environmental-evidence',
  'environmental-fluid-mechanics',
  'environmental-geochemistry-and-health',
  'environmental-geosciences',
  'environmental-hazards',
  'environmental-health',
  'environmental-health-perspectives',
  'environmental-health-and-preventive-medicine',
  'environmental-impact-assessment-review',
  'environmental-innovation-and-societal-transitions',
  'environmental-management',
  'environmental-microbiology',
  'environmental-modeling-and-assessment',
  'environmental-modelling-and-software',
  'environmental-monitoring-and-assessment',
  'environmental-nanotechnology-monitoring-and-management',
  'environmental-pollution',
  'environmental-processes',
  'environmental-research',
  'environmental-research-letters',
  'environmental-science-and-technology',
  'environmental-science-and-technology-letters',
  'environmental-science-and-policy',
  'environmental-science-and-pollution-research',
  'environmental-science-nano',
  'environmental-science-processes-and-impacts',
  'environmental-sciences-europe',
  'environmental-systems-research',
  'environmental-technology',
  'environmental-technology-and-innovation',
  'environmental-technology-reviews',
  'environmental-toxicology-and-chemistry',
  'environmental-toxicology-and-pharmacology',
  'environmental-and-ecological-statistics',
  'environmental-and-experimental-botany',
  'environmental-and-planning-law-journal',
  'environmental-and-resource-economics',
  'environments',
  'environnement-risques-et-sante',
  'enzyme-and-microbial-technology',
  'epidemics',
  'epidemiology',
  'epigenetics',
  'epigenetics-and-chromatin',
  'epigenomics',
  'epilepsy-and-behavior',
  'epilepsy-and-behavior-case-reports',
  'epilepsy-research',
  'epileptology',
  'equine-veterinary-education',
  'equine-veterinary-journal',
  'erkenntnis',
  'erwerbs-obstbau',
  'escuela-nacional-de-antropologia-e-historia-author-date',
  'escuela-nacional-de-antropologia-e-historia-full-note',
  'escuela-nacional-de-antropologia-e-historia-short-note',
  'esophagus',
  'estuaries-and-coasts',
  'estuarine-coastal-and-shelf-science',
  'estudios-gerenciales',
  'estudios-de-historia-moderna-y-contemporanea-de-mexico',
  'estudios-de-historia-novohispana',
  'ethical-theory-and-moral-practice',
  'ethics-book-reviews',
  'ethics-and-education',
  'ethics-and-information-technology',
  'ethics-and-social-welfare',
  'ethics-in-science-and-environmental-politics',
  'ethics-medicine-and-public-health',
  'ethik-in-der-medizin',
  'ethique-et-sante',
  'ethnic-and-racial-studies',
  'ethnicity-and-health',
  'ethnobiology-and-conservation',
  'ethnography-and-education',
  'ethnologie-francaise',
  'eupa-open-proteomics',
  'eukaryotic-cell',
  'euphytica',
  'eurasian-business-review',
  'eurasian-economic-review',
  'eurasian-geography-and-economics',
  'euro-mediterranean-journal-for-environmental-integration',
  'europace',
  'european-actuarial-journal',
  'european-addiction-research',
  'european-annals-of-otorhinolaryngology-head-and-neck-diseases',
  'european-archives-of-oto-rhino-laryngology',
  'european-archives-of-paediatric-dentistry',
  'european-archives-of-psychiatry-and-clinical-neuroscience',
  'european-biophysics-journal',
  'european-business-organization-law-review',
  'european-cells-and-materials',
  'european-child-and-adolescent-psychiatry',
  'european-early-childhood-education-research-journal',
  'european-economic-review',
  'european-food-research-and-technology',
  'european-geriatric-medicine',
  'european-heart-journal',
  'european-heart-journal-acute-cardiovascular-care',
  'european-heart-journal-cardiovascular-imaging',
  'european-journal-for-philosophy-of-science',
  'european-journal-for-security-research',
  'european-journal-of-ageing',
  'european-journal-of-agronomy',
  'european-journal-of-applied-physiology',
  'european-journal-of-cancer',
  'european-journal-of-cardiovascular-nursing',
  'european-journal-of-cell-biology',
  'european-journal-of-clinical-investigation',
  'european-journal-of-clinical-microbiology-and-infectious-diseases',
  'european-journal-of-clinical-nutrition',
  'european-journal-of-clinical-pharmacology',
  'european-journal-of-combinatorics',
  'european-journal-of-developmental-psychology',
  'european-journal-of-drug-metabolism-and-pharmacokinetics',
  'european-journal-of-education-and-psychology',
  'european-journal-of-emergency-medicine',
  'european-journal-of-engineering-education',
  'european-journal-of-environmental-and-civil-engineering',
  'european-journal-of-epidemiology',
  'european-journal-of-forest-research',
  'european-journal-of-futures-research',
  'european-journal-of-gastroenterology-and-hepatology',
  'european-journal-of-haematology',
  'european-journal-of-heart-failure',
  'european-journal-of-higher-education',
  'european-journal-of-hospital-pharmacy',
  'european-journal-of-human-genetics',
  'european-journal-of-immunology',
  'european-journal-of-information-systems',
  'european-journal-of-integrative-medicine',
  'european-journal-of-internal-medicine',
  'european-journal-of-international-law',
  'european-journal-of-law-and-economics',
  'european-journal-of-mathematics',
  'european-journal-of-mechanics-a-solids',
  'european-journal-of-mechanics-b-fluids',
  'european-journal-of-medical-genetics',
  'european-journal-of-medical-research',
  'european-journal-of-medicinal-chemistry',
  'european-journal-of-neuroscience',
  'european-journal-of-nuclear-medicine-and-molecular-imaging',
  'european-journal-of-nutrition',
  'european-journal-of-obstetrics-and-gynecology',
  'european-journal-of-oncology-nursing',
  'european-journal-of-operational-research',
  'european-journal-of-ophthalmology',
  'european-journal-of-oral-sciences',
  'european-journal-of-orthopaedic-surgery-and-traumatology',
  'european-journal-of-paediatric-neurology',
  'european-journal-of-pain',
  'european-journal-of-pediatrics',
  'european-journal-of-pharmaceutical-sciences',
  'european-journal-of-pharmaceutics-and-biopharmaceutics',
  'european-journal-of-pharmacology',
  'european-journal-of-physics',
  'european-journal-of-plant-pathology',
  'european-journal-of-plastic-surgery',
  'european-journal-of-political-economy',
  'european-journal-of-political-research',
  'european-journal-of-population',
  'european-journal-of-preventive-cardiology',
  'european-journal-of-protistology',
  'european-journal-of-psychological-assessment',
  'european-journal-of-psychology-of-education',
  'european-journal-of-psychotherapy-and-counselling',
  'european-journal-of-psychotraumatology',
  'european-journal-of-radiology',
  'european-journal-of-radiology-open',
  'european-journal-of-social-work',
  'european-journal-of-soil-biology',
  'european-journal-of-soil-science',
  'european-journal-of-special-needs-education',
  'european-journal-of-sport-science',
  'european-journal-of-surgical-oncology',
  'european-journal-of-teacher-education',
  'european-journal-of-trauma-and-emergency-surgery',
  'european-journal-of-vascular-and-endovascular-surgery',
  'european-journal-of-wildlife-research',
  'european-journal-of-wood-and-wood-products',
  'european-journal-of-work-and-organizational-psychology',
  'european-journal-on-criminal-policy-and-research',
  'european-management-journal',
  'european-neurology',
  'european-neuropsychopharmacology',
  'european-orthopaedics-and-traumatology',
  'european-polymer-journal',
  'european-psychiatry',
  'european-psychologist',
  'european-radiology',
  'european-research-in-telemedicine-la-recherche-europeenne-en-telemedecine',
  'european-respiratory-journal',
  'european-retail-research',
  'european-review-of-aging-and-physical-activity',
  'european-review-of-history-revue-europeenne-dhistoire',
  'european-review-of-social-psychology',
  'european-society-of-cardiology',
  'european-spine-journal',
  'european-sport-management-quarterly',
  'european-surgery',
  'european-surgical-research',
  'european-thyroid-journal',
  'european-transport-research-review',
  'european-union-interinstitutional-style-guide',
  'european-urology',
  'european-urology-focus',
  'european-urology-supplements',
  'european-view',
  'evaluation-and-program-planning',
  'evidence-based-communication-assessment-and-intervention',
  'evidence-based-dentistry',
  'evidence-based-medicine',
  'evidence-based-mental-health',
  'evidence-based-nursing',
  'evodevo',
  'evolution',
  'evolution-and-development',
  'evolution-and-human-behavior',
  'evolution-education-and-outreach',
  'evolutionary-anthropology',
  'evolutionary-behavioral-sciences',
  'evolutionary-biology',
  'evolutionary-ecology',
  'evolutionary-ecology-research',
  'evolutionary-intelligence',
  'evolutionary-psychological-science',
  'evolutionary-and-institutional-economics-review',
  'evolving-systems',
  'experimental-and-molecular-medicine',
  'experimental-and-translational-stroke-medicine',
  'experimental-astronomy',
  'experimental-brain-research',
  'experimental-cell-research',
  'experimental-dermatology',
  'experimental-economics',
  'experimental-eye-research',
  'experimental-gerontology',
  'experimental-hematology-and-oncology',
  'experimental-mechanics',
  'experimental-neurology',
  'experimental-parasitology',
  'experimental-physiology',
  'experimental-psychology',
  'experimental-techniques',
  'experimental-thermal-and-fluid-science',
  'experimental-and-applied-acarology',
  'experimental-and-clinical-psychopharmacology',
  'experimental-and-molecular-pathology',
  'experimental-and-therapeutic-medicine',
  'experimental-and-toxicologic-pathology',
  'experiments-in-fluids',
  'expert-review-of-anti-infective-therapy',
  'expert-review-of-anticancer-therapy',
  'expert-review-of-cardiovascular-therapy',
  'expert-review-of-clinical-immunology',
  'expert-review-of-clinical-pharmacology',
  'expert-review-of-dermatology',
  'expert-review-of-endocrinology-and-metabolism',
  'expert-review-of-gastroenterology-and-hepatology',
  'expert-review-of-hematology',
  'expert-review-of-medical-devices',
  'expert-review-of-molecular-diagnostics',
  'expert-review-of-neurotherapeutics',
  'expert-review-of-obstetrics-and-gynecology',
  'expert-review-of-ophthalmology',
  'expert-review-of-pharmacoeconomics-and-outcomes-research',
  'expert-review-of-proteomics',
  'expert-review-of-respiratory-medicine',
  'expert-review-of-vaccines',
  'expert-systems-with-applications',
  'explorations-in-economic-history',
  'explore-the-journal-of-science-and-healing',
  'exposure-and-health',
  'extreme-mechanics-letters',
  'extreme-physiology-and-medicine',
  'extremes',
  'extremophiles',
  'eye',
  'eye-and-contact-lens',
  'eye-and-vision',
  'f1000research',
  'fems-microbiology-ecology',
  'fems-microbiology-letters',
  'fems-microbiology-reviews',
  'fems-yeast-research',
  'fold-and-r',
  'fachhochschule-kiel-fachbereich-medien',
  'fachhochschule-vorarlberg',
  'fachhochschule-vorarlberg-alphanumeric',
  'facial-plastic-surgery-clinics-of-north-america',
  'facies',
  'harvard-falmouth-university',
  'familial-cancer',
  'families-systems-and-health',
  'family-law-review',
  'family-medicine',
  'family-science',
  'faraday-discussions',
  'farmacia-hospitalaria',
  'fashion-and-textiles',
  'fatigue-biomedicine-health-and-behavior',
  'federation-of-european-microbiological-societies',
  'feminist-economics',
  'feminist-legal-studies',
  'feminist-media-studies',
  'ferdinand-porsche-fern-fachhochschule',
  'fertility-research-and-practice',
  'fertility-and-sterility',
  'fetal-and-neonatal',
  'fetal-diagnosis-and-therapy',
  'feuillets-de-radiologie',
  'few-body-systems',
  'fibers',
  'fibrogenesis-and-tissue-repair',
  'field-crops-research',
  'fields-mathematics-education-journal',
  'finance-research-letters',
  'finance-and-stochastics',
  'financial-innovation',
  'financial-markets-and-portfolio-management',
  'finanzarchiv',
  'finite-elements-in-analysis-and-design',
  'finite-fields-and-their-applications',
  'fire-safety-journal',
  'fire-science-reviews',
  'fire-technology',
  'first-amendment-studies',
  'first-monday',
  'first-world-war-studies',
  'fish-physiology-and-biochemistry',
  'fish-and-fisheries',
  'fish-and-shellfish-immunology',
  'fisheries',
  'fisheries-research',
  'fisheries-science',
  'fitoterapia',
  'fixed-point-theory-and-applications',
  'flavour',
  'flavour-and-fragrance-journal',
  'flexible-services-and-manufacturing-journal',
  'flora',
  'florida-entomologist',
  'flow-measurement-and-instrumentation',
  'flow-turbulence-and-combustion',
  'fluid-dynamics-research',
  'fluid-phase-equilibria',
  'fluids-and-barriers-of-the-cns',
  'fly',
  'folia-microbiologica',
  'folia-phoniatrica-et-logopaedica',
  'folia-primatologica',
  'food-and-function',
  'food-additives-and-contaminants-part-a',
  'food-additives-and-contaminants-part-b',
  'food-analytical-methods',
  'food-biophysics',
  'food-bioscience',
  'food-chemistry',
  'food-control',
  'food-digestion',
  'food-engineering-reviews',
  'food-ethics',
  'food-hydrocolloids',
  'food-microbiology',
  'food-packaging-and-shelf-life',
  'food-policy',
  'food-quality-and-preference',
  'food-research-international',
  'food-science-and-human-wellness',
  'food-security',
  'food-structure',
  'food-webs',
  'food-and-agriculture-organization-of-the-united-nations',
  'food-and-bioprocess-technology',
  'food-and-bioproducts-processing',
  'food-and-chemical-toxicology',
  'food-and-environmental-virology',
  'food-and-waterborne-parasitology',
  'foods',
  'foot-and-ankle-international',
  'foot-and-ankle-surgery',
  'foreign-policy-analysis',
  'forensic-science-international',
  'forensic-science-international-supplement-series',
  'forensic-science-international-genetics',
  'forensic-science-international-genetics-supplement-series',
  'forensic-science-review',
  'forensic-science-medicine-and-pathology',
  'forensic-toxicology',
  'forensische-psychiatrie-psychologie-kriminologie',
  'forest-ecology-and-management',
  'forest-ecosystems',
  'forest-policy-and-economics',
  'forest-science',
  'forest-science-and-technology',
  'forests',
  'forests-trees-and-livelihoods',
  'formal-methods-in-system-design',
  'formosan-journal-of-surgery',
  'forschende-komplementarmedizin',
  'forschung-im-ingenieurwesen',
  'forum',
  'forum-der-psychoanalyse',
  'forum-for-social-economics',
  'fossil-record',
  'foundations-of-chemistry',
  'foundations-of-physics',
  'foundations-of-science',
  'french4',
  'french2',
  'french3',
  'french1',
  'free-radical-biology-and-medicine',
  'free-radical-research',
  'free-radicals-and-antioxidants',
  'freie-universitat-berlin-geographische-wissenschaften',
  'french-historical-studies',
  'french-politics',
  'freshwater-biology',
  'freshwater-science',
  'frontiers-in-aging-neuroscience',
  'frontiers-in-behavioral-neuroscience',
  'frontiers-in-bioengineering-and-biotechnology',
  'frontiers-in-cell-and-developmental-biology',
  'frontiers-in-cellular-neuroscience',
  'frontiers-in-cellular-and-infection-microbiology',
  'frontiers-in-chemistry',
  'frontiers-in-computational-neuroscience',
  'frontiers-in-earth-science',
  'frontiers-in-ecology-and-evolution',
  'frontiers-in-ecology-and-the-environment',
  'frontiers-in-endocrinology',
  'frontiers-in-energy-research',
  'frontiers-in-environmental-science',
  'frontiers-in-evolutionary-neuroscience',
  'frontiers-in-genetics',
  'frontiers-in-human-neuroscience',
  'frontiers-in-immunology',
  'frontiers-in-integrative-neuroscience',
  'frontiers-in-life-science',
  'frontiers-in-marine-science',
  'frontiers-in-materials',
  'frontiers-in-microbiology',
  'frontiers-in-molecular-biosciences',
  'frontiers-in-molecular-neuroscience',
  'frontiers-in-neural-circuits',
  'frontiers-in-neuroanatomy',
  'frontiers-in-neuroendocrinology',
  'frontiers-in-neuroenergetics',
  'frontiers-in-neuroengineering',
  'frontiers-in-neuroinformatics',
  'frontiers-in-neurology',
  'frontiers-in-neurorobotics',
  'frontiers-in-neuroscience',
  'frontiers-in-nutrition',
  'frontiers-in-oncology',
  'frontiers-in-optics',
  'frontiers-in-pediatrics',
  'frontiers-in-pharmacology',
  'frontiers-in-physics',
  'frontiers-in-physiology',
  'frontiers-in-plant-science',
  'frontiers-in-psychiatry',
  'frontiers-in-psychology',
  'frontiers-in-public-health',
  'frontiers-in-surgery',
  'frontiers-in-synaptic-neuroscience',
  'frontiers-in-systems-neuroscience',
  'frontiers-in-zoology',
  'frontiers',
  'frontiers-medical-journals',
  'frontiers-of-architectural-research',
  'frontline-gastroenterology',
  'fudan-journal-of-the-humanities-and-social-sciences',
  'fuel',
  'fuel-processing-technology',
  'functional-and-integrative-genomics',
  'functional-ecology',
  'functional-linguistics',
  'functional-plant-biology',
  'fungal-biology-reviews',
  'fungal-biology-and-biotechnology',
  'fungal-diversity',
  'fungal-ecology',
  'fungal-genetics-and-biology',
  'fusion-engineering-and-design',
  'future-business-journal',
  'future-cardiology',
  'future-cities-and-environment',
  'future-dental-journal',
  'future-generation-computer-systems',
  'future-internet',
  'future-journal-of-pharmaceutical-sciences',
  'future-medicinal-chemistry',
  'future-microbiology',
  'future-neurology',
  'future-oncology',
  'future-science-group',
  'future-science-journals',
  'future-virology',
  'futures',
  'fuzzy-information-and-engineering',
  'fuzzy-optimization-and-decision-making',
  'fuzzy-sets-and-systems',
  'g3',
  'gem-international-journal-on-geomathematics',
  'giscience-and-remote-sensing',
  'glia',
  'gm-crops-and-food-biotechnology-in-agriculture-and-the-food-chain',
  'gms-medizin-bibliothek-information',
  'gps-solutions',
  'gsa-today',
  'gaceta-sanitaria',
  'gait-and-posture',
  'galaxies',
  'gallia',
  'games',
  'games-and-economic-behavior',
  'gastric-cancer',
  'gastroenterology',
  'gastroenterologia-y-hepatologia',
  'gastrointestinal-endoscopy',
  'gastrointestinal-endoscopy-clinics-of-north-america',
  'gastrointestinal-intervention',
  'gastrointestinal-tumors',
  'gefasschirurgie',
  'geistes-und-kulturwissenschaften-heilmann',
  'gender-issues',
  'gender-medicine',
  'gender-and-education',
  'gender-place-and-culture',
  'gene',
  'gene-expression-patterns',
  'gene-therapy',
  'general-hospital-psychiatry',
  'general-relativity-and-gravitation',
  'general-thoracic-and-cardiovascular-surgery',
  'general-and-comparative-endocrinology',
  'genes',
  'genes-and-development',
  'genes-and-diseases',
  'genes-and-genomics',
  'genes-and-immunity',
  'genes-and-nutrition',
  'genes-and-environment',
  'genes-to-cells',
  'genetic-programming-and-evolvable-machines',
  'genetic-resources-and-crop-evolution',
  'genetica',
  'genetics',
  'genetics-selection-evolution',
  'genetics-and-molecular-biology',
  'genome-announcements',
  'genome-biology',
  'genome-biology-and-evolution',
  'genome-integrity',
  'genome-medicine',
  'genome-research',
  'genomic-medicine-biomarkers-and-health-sciences',
  'genomics',
  'genomics-data',
  'genomics-proteomics-and-bioinformatics',
  'geneses',
  'geo-marine-letters',
  'geoinformatica',
  'geojournal',
  'georesj',
  'geoarchaeology',
  'geobiology',
  'geobios',
  'geocarto-international',
  'geochemical-transactions',
  'geochemistry-exploration-environment-analysis',
  'geochimica-et-cosmochimica-acta',
  'geoderma',
  'geoderma-regional',
  'geodesy-and-geodynamics',
  'geodinamica-acta',
  'geoenvironmental-disasters',
  'geoforum',
  'geografie-sbornik-cgs',
  'geografisk-tidsskrift-danish-journal-of-geography',
  'geographica-helvetica',
  'geoheritage',
  'geological-magazine',
  'geological-society-of-america-bulletin',
  'geological-society-london-memoirs',
  'geological-society-london-special-publications',
  'geology',
  'geology-of-the-intermountain-west',
  'geomatics-natural-hazards-and-risk',
  'geomechanics-and-geophysics-for-geo-energy-and-geo-resources',
  'geomechanics-for-energy-and-the-environment',
  'geometriae-dedicata',
  'geomorphology',
  'geopolitics',
  'georg-august-universitat-gottingen-institut-fur-ethnologie-und-ethnologische-sammlung',
  'georisk-assessment-and-management-of-risk-for-engineered-systems-and-geohazards',
  'geoscience-frontiers',
  'geoscience-letters',
  'geosciences',
  'geoscientific-instrumentation-methods-and-data-systems',
  'geoscientific-instrumentation-methods-and-data-systems-discussions',
  'geoscientific-model-development',
  'geoscientific-model-development-discussions',
  'geosphere',
  'geosystem-engineering',
  'geotechnical-and-geological-engineering',
  'geotextiles-and-geomembranes',
  'geothermal-energy',
  'geothermics',
  'geriatric-mental-health-care',
  'geriatric-nursing',
  'geropsych-the-journal-of-gerontopsychology-and-geriatric-psychiatry',
  'gerontology',
  'gesellschaft-fur-popularmusikforschung',
  'gesunde-pflanzen',
  'gewerblicher-rechtsschutz-und-urheberrecht',
  'gezinstherapie-wereldwijd',
  'gigascience',
  'glass-structures-and-engineering',
  'global-business-perspectives',
  'global-change-biology',
  'global-crime',
  'global-discourse',
  'global-ecology-and-biogeography',
  'global-ecology-and-conservation',
  'global-economics-and-management-review',
  'global-environmental-change',
  'global-finance-journal',
  'global-food-security',
  'global-heart',
  'global-journal-of-flexible-systems-management',
  'global-public-health',
  'global-social-welfare',
  'global-and-planetary-change',
  'globalisation-societies-and-education',
  'globalization-and-health',
  'glycoconjugate-journal',
  'gold-bulletin',
  'gondwana-research',
  'government-information-quarterly',
  'graefes-archive-for-clinical-and-experimental-ophthalmology',
  'granular-computing',
  'granular-matter',
  'graphical-models',
  'graphs-and-combinatorics',
  'grasas-y-aceites',
  'green-chemistry',
  'green-letters',
  'greenhouse-gas-measurement-and-management',
  'groundwater-for-sustainable-development',
  'group-decision-and-negotiation',
  'group-dynamics-theory-research-and-practice',
  'growth-hormone-and-igf-research',
  'grundwasser',
  'gruppe-interaktion-organisation-zeitschrift-fur-angewandte-organisationspsychologie',
  'lluelles',
  'lluelles-no-ibid',
  'gut',
  'gut-microbes',
  'gut-pathogens',
  'gynecologic-oncology',
  'gynecologic-oncology-case-reports',
  'gynecologic-oncology-reports',
  'gynecologic-oncology-research-and-practice',
  'gynecologic-and-obstetric-investigation',
  'gynecological-surgery',
  'gynecology-and-minimally-invasive-therapy',
  'gynakologische-endokrinologie',
  'gynecologie-obstetrique-et-fertilite',
  'hand',
  'hayati-journal-of-biosciences',
  'hbrc-journal',
  'hec-forum',
  'hiv-and-aids-review',
  'hkie-transactions',
  'hmd-praxis-der-wirtschaftsinformatik',
  'hno',
  'homo-journal-of-comparative-human-biology',
  'hpb',
  'hpv',
  'habitat-international',
  'haematologica',
  'hague-journal-on-the-rule-of-law',
  'hamburg-school-of-food-science',
  'harm-reduction-journal',
  'harmful-algae',
  'harper-adams-university-harvard',
  'harvard1',
  'harvard1',
  'harvard-de',
  'harvard-agps',
  'harvard-anglia-ruskin-university',
  'harvard-bangor-university',
  'harvard-bath-university',
  'harvard-bournemouth-university',
  'harvard-cape-peninsula-university-of-technology',
  'harvard-cardiff-university',
  'harvard-cardiff-university-biosi',
  'harvard-central-queensland-university',
  'harvard-cite-them-right',
  'harvard-city-university-london',
  'harvard-coventry-university',
  'harvard-cranfield-university',
  'harvard-dublin-city-university',
  'harvard-durham-university-business-school',
  'harvard-edge-hill-university',
  'harvard-european-archaeology',
  'harvard-fachhochschule-salzburg',
  'harvard-gesellschaft-fur-bildung-und-forschung-in-europa',
  'harvard-imperial-college-london',
  'harvard-institut-fur-praxisforschung-de',
  'harvard-james-cook-university',
  'harvard-kings-college-london',
  'harvard-leeds-beckett-university',
  'harvard-leeds-metropolitan-university',
  'harvard-liverpool-john-moores-university',
  'harvard-london-south-bank-university',
  'harvard-manchester-business-school',
  'harvard-manchester-metropolitan-university',
  'harvard-newcastle-university',
  'harvard-north-west-university',
  'harvard-oxford-brookes-university',
  'harvard-oxford-brookes-university-faculty-of-health-and-life-sciences',
  'harvard-pontificia-universidad-catolica-del-ecuador',
  'harvard-southampton-solent-university',
  'harvard-st-pauls-university',
  'harvard-staffordshire-university',
  'harvard-stellenbosch-university',
  'harvard-swinburne-university-of-technology',
  'harvard-the-university-of-manchester',
  'harvard-the-university-of-melbourne',
  'harvard-the-university-of-northampton',
  'harvard-the-university-of-sheffield-school-of-east-asian-studies',
  'harvard-the-university-of-sheffield-town-and-regional-planning',
  'harvard-universiti-tunku-abdul-rahman',
  'harvard-university-for-the-creative-arts',
  'harvard-university-of-abertay-dundee',
  'harvard-university-of-birmingham',
  'harvard-university-of-brighton-school-of-environment-and-technology',
  'harvard-university-of-cape-town',
  'harvard-university-of-gloucestershire',
  'harvard-university-of-greenwich',
  'harvard-university-of-hull',
  'harvard-university-of-kent',
  'harvard-university-of-leeds',
  'harvard-limerick',
  'harvard-university-of-liverpool',
  'harvard-university-of-new-south-wales',
  'harvard-university-of-queensland',
  'harvard-university-of-southampton',
  'harvard-university-of-southampton-health-sciences',
  'harvard-university-of-southern-queensland',
  'harvard-university-of-stirling',
  'harvard-university-of-sunderland',
  'harvard-university-of-technology-sydney',
  'harvard-university-of-west-london',
  'harvard-university-of-westminster',
  'harvard-university-of-wolverhampton',
  'harvard-university-of-worcester',
  'harvard-university-of-the-west-of-england',
  'harvard-university-of-the-west-of-scotland',
  'harvard-york-st-john-university',
  'harvard-university-of-york',
  'harvard-demontfort-university',
  'harvard-educational-review',
  'harvard7de',
  'harvard-southampton-solent',
  'harvard-warwick-wms',
  'harvard-WesternSydU',
  'hawaii-journal-of-medicine-and-public-health',
  'hawaii-international-conference-on-system-sciences-proceedings',
  'head-and-face-medicine',
  'head-and-neck-pathology',
  'headache',
  'health-and-justice',
  'health-and-social-care-in-the-community',
  'health-care-analysis',
  'health-care-management-science',
  'health-economics-review',
  'health-economics-policy-and-law',
  'health-information-science-and-systems',
  'health-policy-and-planning',
  'health-policy-and-technology',
  'health-psychology',
  'health-psychology-review',
  'health-psychology-and-behavioral-medicine-an-open-access-journal',
  'health-research-policy-and-systems',
  'health-sa-gesondheid',
  'health-services-research',
  'health-services-and-delivery-research',
  'health-services-and-outcomes-research-methodology',
  'health-technology-assessment',
  'health-and-place',
  'health-and-quality-of-life-outcomes',
  'health-and-technology',
  'health-policy',
  'health-risk-and-society',
  'healthcare',
  'healthcare-management-forum',
  'hearing-research',
  'heart',
  'heart-and-lung-the-journal-of-acute-and-critical-care',
  'heart-asia',
  'heart-failure-clinics',
  'heart-failure-reviews',
  'heart-rhythm',
  'heart-and-vessels',
  'heart-lung-and-circulation',
  'heat-and-mass-transfer',
  'heilberufescience',
  'helgoland-marine-research',
  'heliyon',
  'hellenic-journal-of-cardiology',
  'hellenic-journal-of-surgery',
  'hematology-oncology-clinics-of-north-america',
  'hepatic-oncology',
  'hepatology',
  'hepatology-international',
  'hepatology-medicine-and-policy',
  'hereditary-cancer-in-clinical-practice',
  'hereditas',
  'heredity',
  'heritage-science',
  'hernia',
  'herpesviridae',
  'herz',
  'herzschrittmachertherapie-elektrophysiologie',
  'high-ability-studies',
  'high-blood-pressure-and-cardiovascular-prevention',
  'high-energy-density-physics',
  'high-pressure-research',
  'higher-education',
  'higher-order-and-symbolic-computation',
  'hipertension-y-riesgo-vascular',
  'hippocampus',
  'hispanic-american-historical-review',
  'histochemistry-and-cell-biology',
  'histoire-et-mesure',
  'histoire-at-politique',
  'historia-mathematica',
  'history-and-anthropology',
  'history-and-philosophy-of-the-life-sciences',
  'history-and-theory',
  'history-of-geo-and-space-sciences',
  'history-of-political-economy',
  'history-of-psychology',
  'history-of-the-human-sciences',
  'stuttgart-media-university',
  'hochschule-fur-wirtschaft-und-recht-berlin',
  'homeopathy',
  'hong-kong-journal-of-occupational-therapy',
  'hong-kong-journal-of-ophthalmology',
  'hong-kong-journal-of-radiology',
  'hong-kong-medical-journal',
  'hong-kong-physiotherapy-journal',
  'hormigon-y-acero',
  'hormone-research-in-paediatrics',
  'hormone-and-metabolic-research',
  'hormones-and-behavior',
  'hormones-and-cancer',
  'horticulture-research',
  'hospital-chronicles',
  'hospital-pharmacy',
  'housing-policy-debate',
  'housing-theory-and-society',
  'huisarts-en-wetenschap',
  'human-brain-mapping',
  'human-cell',
  'human-development',
  'human-genetics',
  'human-genomics',
  'human-heredity',
  'human-immunology',
  'human-molecular-genetics',
  'human-movement-science',
  'human-mutation',
  'human-nature',
  'human-pathology',
  'human-pathology-case-reports',
  'human-relations',
  'human-reproduction',
  'human-reproduction-update',
  'human-resource-development-international',
  'human-resource-management-journal',
  'human-resource-management-review',
  'human-resources-for-health',
  'human-studies',
  'human-vaccines-and-immunotherapeutics',
  'human-wildlife-interactions',
  'human-centric-computing-and-information-sciences',
  'humanities',
  'humboldt-state-university-environmental-resources-engineering',
  'husserl-studies',
  'hydrobiologia',
  'hydrogeology-journal',
  'hydrological-processes',
  'hydrological-sciences-journal',
  'hydrology-and-earth-system-sciences',
  'hydrology-and-earth-system-sciences-discussions',
  'hydrometallurgy',
  'hyperfine-interactions',
  'hypertension-research',
  'hypotheses-in-the-life-sciences',
  'iatss-research',
  'ibm-journal-of-research-and-development',
  'ibms-bonekey',
  'ices-journal-of-marine-science',
  'ict-express',
  'idcases',
  'ie-comunicaciones',
  'ieee',
  'ieee-with-url',
  'ieee-access',
  'ieee-aerospace-and-electronic-systems-magazine',
  'ieee-annals-of-the-history-of-computing',
  'ieee-antennas-and-propagation-magazine',
  'ieee-antennas-and-wireless-propagation-letters',
  'ieee-circuits-and-systems-magazine',
  'ieee-communications-letters',
  'ieee-communications-magazine',
  'ieee-communications-surveys-and-tutorials',
  'ieee-computational-intelligence-magazine',
  'ieee-computer-graphics-and-applications',
  'ieee-consumer-electronics-magazine',
  'ieee-control-systems',
  'ieee-design-and-test',
  'ieee-electrical-insulation-magazine',
  'ieee-electrification-magazine',
  'ieee-electromagnetic-compatibility-magazine',
  'ieee-electron-device-letters',
  'ieee-embedded-systems-letters',
  'ieee-engineering-management-review',
  'ieee-geoscience-and-remote-sensing-letters',
  'ieee-geoscience-and-remote-sensing-magazine',
  'ieee-industrial-electronics-magazine',
  'ieee-industry-applications-magazine',
  'ieee-instrumentation-and-measurement-magazine',
  'ieee-intelligent-systems',
  'ieee-intelligent-transportation-systems-magazine',
  'ieee-internet-computing',
  'ieee-internet-of-things-journal',
  'ieee-journal-of-biomedical-and-health-informatics',
  'ieee-journal-of-emerging-and-selected-topics-in-power-electronics',
  'ieee-journal-of-oceanic-engineering',
  'ieee-journal-of-photovoltaics',
  'ieee-journal-of-quantum-electronics',
  'ieee-journal-of-selected-topics-in-applied-earth-observations-and-remote-sensing',
  'ieee-journal-of-selected-topics-in-quantum-electronics',
  'ieee-journal-of-selected-topics-in-signal-processing',
  'ieee-journal-of-solid-state-circuits',
  'ieee-journal-of-translational-engineering-in-health-and-medicine',
  'ieee-journal-of-the-electron-devices-society',
  'ieee-journal-on-emerging-and-selected-topics-in-circuits-and-systems',
  'ieee-journal-on-selected-areas-in-communications',
  'ieee-latin-america-transactions',
  'ieee-magnetics-letters',
  'ieee-micro',
  'ieee-microwave-magazine',
  'ieee-microwave-and-wireless-components-letters',
  'ieee-multimedia',
  'ieee-nanotechnology-magazine',
  'ieee-network',
  'ieee-pervasive-computing',
  'ieee-photonics-journal',
  'ieee-photonics-technology-letters',
  'ieee-potentials',
  'ieee-power-and-energy-magazine',
  'ieee-pulse',
  'ieee-reviews-in-biomedical-engineering',
  'ieee-revista-iberoamericana-de-tecnologias-del-aprendizaje',
  'ieee-robotics-and-automation-magazine',
  'ieee-security-and-privacy',
  'ieee-sensors-journal',
  'ieee-signal-processing-letters',
  'ieee-signal-processing-magazine',
  'ieee-software',
  'ieee-solid-state-circuits-magazine',
  'ieee-spectrum',
  'ieee-systems-journal',
  'ieee-technology-and-society-magazine',
  'ieee-transactions-on-aerospace-and-electronic-systems',
  'ieee-transactions-on-affective-computing',
  'ieee-transactions-on-antennas-and-propagation',
  'ieee-transactions-on-applied-superconductivity',
  'ieee-transactions-on-automatic-control',
  'ieee-transactions-on-automation-science-and-engineering',
  'ieee-transactions-on-autonomous-mental-development',
  'ieee-transactions-on-biomedical-circuits-and-systems',
  'ieee-transactions-on-biomedical-engineering',
  'ieee-transactions-on-broadcasting',
  'ieee-transactions-on-circuits-and-systems-i-regular-papers',
  'ieee-transactions-on-circuits-and-systems-ii-express-briefs',
  'ieee-transactions-on-circuits-and-systems-for-video-technology',
  'ieee-transactions-on-cloud-computing',
  'ieee-transactions-on-communications',
  'ieee-transactions-on-components-packaging-and-manufacturing-technology',
  'ieee-transactions-on-computational-intelligence-and-ai-in-games',
  'ieee-transactions-on-computer-aided-design-of-integrated-circuits-and-systems',
  'ieee-transactions-on-computers',
  'ieee-transactions-on-consumer-electronics',
  'ieee-transactions-on-control-systems-technology',
  'ieee-transactions-on-cybernetics',
  'ieee-transactions-on-dependable-and-secure-computing',
  'ieee-transactions-on-device-and-materials-reliability',
  'ieee-transactions-on-dielectrics-and-electrical-insulation',
  'ieee-transactions-on-education',
  'ieee-transactions-on-electromagnetic-compatibility',
  'ieee-transactions-on-electron-devices',
  'ieee-transactions-on-emerging-topics-in-computing',
  'ieee-transactions-on-energy-conversion',
  'ieee-transactions-on-engineering-management',
  'ieee-transactions-on-evolutionary-computation',
  'ieee-transactions-on-fuzzy-systems',
  'ieee-transactions-on-geoscience-and-remote-sensing',
  'ieee-transactions-on-haptics',
  'ieee-transactions-on-human-machine-systems',
  'ieee-transactions-on-image-processing',
  'ieee-transactions-on-industrial-electronics',
  'ieee-transactions-on-industrial-informatics',
  'ieee-transactions-on-industry-applications',
  'ieee-transactions-on-information-forensics-and-security',
  'ieee-transactions-on-information-theory',
  'ieee-transactions-on-instrumentation-and-measurement',
  'ieee-transactions-on-intelligent-transportation-systems',
  'ieee-transactions-on-knowledge-and-data-engineering',
  'ieee-transactions-on-learning-technologies',
  'ieee-transactions-on-magnetics',
  'ieee-transactions-on-medical-imaging',
  'ieee-transactions-on-microwave-theory-and-techniques',
  'ieee-transactions-on-mobile-computing',
  'ieee-transactions-on-multimedia',
  'ieee-transactions-on-nanobioscience',
  'ieee-transactions-on-nanotechnology',
  'ieee-transactions-on-network-and-service-management',
  'ieee-transactions-on-neural-networks-and-learning-systems',
  'ieee-transactions-on-neural-systems-and-rehabilitation-engineering',
  'ieee-transactions-on-nuclear-science',
  'ieee-transactions-on-parallel-and-distributed-systems',
  'ieee-transactions-on-pattern-analysis-and-machine-intelligence',
  'ieee-transactions-on-plasma-science',
  'ieee-transactions-on-power-delivery',
  'ieee-transactions-on-power-electronics',
  'ieee-transactions-on-power-systems',
  'ieee-transactions-on-professional-communication',
  'ieee-transactions-on-reliability',
  'ieee-transactions-on-robotics',
  'ieee-transactions-on-semiconductor-manufacturing',
  'ieee-transactions-on-services-computing',
  'ieee-transactions-on-signal-processing',
  'ieee-transactions-on-smart-grid',
  'ieee-transactions-on-software-engineering',
  'ieee-transactions-on-sustainable-energy',
  'ieee-transactions-on-systems-man-and-cybernetics-systems',
  'ieee-transactions-on-terahertz-science-and-technology',
  'ieee-transactions-on-ultrasonics-ferroelectrics-and-frequency-control',
  'ieee-transactions-on-vehicular-technology',
  'ieee-transactions-on-very-large-scale-integration-systems',
  'ieee-transactions-on-visualization-and-computer-graphics',
  'ieee-transactions-on-wireless-communications',
  'ieee-vehicular-technology-magazine',
  'ieee-wireless-communications',
  'ieee-wireless-communications-letters',
  'ieee-women-in-engineering-magazine',
  'ieee-acm-transactions-on-audio-speech-and-language-processing',
  'ieee-acm-transactions-on-computational-biology-and-bioinformatics',
  'ieee-acm-transactions-on-networking',
  'ieee-asme-transactions-on-mechatronics',
  'ieee-osa-journal-of-optical-communications-and-networking',
  'ieice-transactions-on-communications',
  'ieice-transactions-on-electronics',
  'ieice-transactions-on-fundamentals-of-electronics-communications-and-computer-sciences',
  'ieice-transactions-on-information-and-systems',
  'ieri-procedia',
  'iet-biometrics',
  'iet-circuits-devices-and-systems',
  'iet-communications',
  'iet-computer-vision',
  'iet-computers-and-digital-techniques',
  'iet-control-theory-and-applications',
  'iet-electric-power-applications',
  'iet-electrical-systems-in-transportation',
  'iet-generation-transmission-and-distribution',
  'iet-image-processing',
  'iet-information-security',
  'iet-intelligent-transport-systems',
  'iet-micro-and-nano-letters',
  'iet-microwaves-antennas-and-propagation',
  'iet-nanobiotechnology',
  'iet-networks',
  'iet-optoelectronics',
  'iet-power-electronics',
  'iet-radar-sonar-and-navigation',
  'iet-renewable-power-generation',
  'iet-science-measurement-and-technology',
  'iet-signal-processing',
  'iet-software',
  'iet-synthetic-biology',
  'iet-systems-biology',
  'iet-wireless-sensor-systems',
  'iica-catie',
  'iimb-management-review',
  'ijc-heart-and-vasculature',
  'ijc-heart-and-vessels',
  'ijc-metabolic-and-endocrine',
  'inter-ro',
  'iop-conference-series-earth-and-environmental-science',
  'iop-conference-series-materials-science-and-engineering',
  'irbm',
  'irbm-news',
  'isa-transactions',
  'iso690-author-date-cs',
  'iso690-author-date-en',
  'iso690-author-date-fr',
  'iso690-author-date-sk',
  'iso690-author-date-es',
  'iso690-author-date-fr-no-abstract',
  'iso690-full-note-sk',
  'iso690-note-fr',
  'iso690-note-cs',
  'iso690-numeric-en',
  'iso690-numeric-fr',
  'iso690-numeric-lt',
  'iso690-numeric-sk',
  'iso690-numeric-brackets-cs',
  'iso690-numeric-cs',
  'isprs-international-journal-of-geo-information',
  'isprs-journal-of-photogrammetry-and-remote-sensing',
  'it-professional',
  'iucrj',
  'iza-journal-of-european-labor-studies',
  'iza-journal-of-labor-and-development',
  'iza-journal-of-labor-economics',
  'iza-journal-of-labor-policy',
  'iza-journal-of-migration',
  'ibsen-studies',
  'icarus',
  'igaku-toshokan',
  'im-gesprach',
  'image-and-vision-computing',
  'imagerie-de-la-femme',
  'imaging-in-medicine',
  'immigrants-and-minorities',
  'immunity',
  'immunity-and-ageing',
  'immuno-analyse-et-biologie-specialisee',
  'immunobiology',
  'immunogenetics',
  'immunologic-research',
  'immunological-reviews',
  'immunology-and-cell-biology',
  'immunology-letters',
  'immunomics',
  'immunotherapy',
  'impact-assessment-and-project-appraisal',
  'implementation-science',
  'in-practice',
  'in-silico-cell-and-tissue-science',
  'in-silico-pharmacology',
  'in-vitro-cellular-and-developmental-biology-animal',
  'in-vitro-cellular-and-developmental-biology-plant',
  'invisu',
  'indian-geotechnical-journal',
  'indian-heart-journal',
  'indian-journal-of-anaesthesia',
  'indian-journal-of-cancer',
  'indian-journal-of-clinical-biochemistry',
  'indian-journal-of-critical-care-medicine',
  'indian-journal-of-dentistry',
  'indian-journal-of-dermatology',
  'indian-journal-of-dermatology-venereology-and-leprology',
  'indian-journal-of-gastroenterology',
  'indian-journal-of-gynecologic-oncology',
  'indian-journal-of-hematology-and-blood-transfusion',
  'indian-journal-of-human-genetics',
  'indian-journal-of-medical-informatics',
  'indian-journal-of-medical-microbiology',
  'indian-journal-of-medical-research',
  'indian-journal-of-medical-sciences',
  'indian-journal-of-medical-specialities',
  'indian-journal-of-microbiology',
  'indian-journal-of-occupational-and-environmental-medicine',
  'indian-journal-of-ophthalmology',
  'indian-journal-of-otolaryngology-and-head-and-neck-surgery',
  'indian-journal-of-pharmacology',
  'indian-journal-of-plant-physiology',
  'indian-journal-of-plastic-surgery',
  'indian-journal-of-rheumatology',
  'indian-journal-of-surgery',
  'indian-journal-of-surgical-oncology',
  'indian-journal-of-thoracic-and-cardiovascular-surgery',
  'indian-journal-of-transplantation',
  'indian-journal-of-tuberculosis',
  'indian-journal-of-urology',
  'indian-pacing-and-electrophysiology-journal',
  'indoor-air',
  'industrial-and-engineering-chemistry-research',
  'industrial-crops-and-products',
  'industrial-marketing-management',
  'infant-behavior-and-development',
  'infant-observation',
  'infectio',
  'infection',
  'infection-and-immunity',
  'infection-genetics-and-evolution',
  'infectious-agents-and-cancer',
  'infectious-disease-clinics-of-north-america',
  'infectious-diseases-and-therapy',
  'infectious-diseases-of-poverty',
  'inflammation',
  'inflammation-research',
  'inflammatory-bowel-diseases',
  'inflammopharmacology',
  'infoclio-de',
  'infoclio-fr-smallcaps',
  'infoclio-fr-nocaps',
  'informatics',
  'informatics-in-medicine-unlocked',
  'informatik-spektrum',
  'information',
  'information-and-communications-technology-law',
  'information-and-management',
  'information-economics-and-policy',
  'information-fusion',
  'information-processing-letters',
  'information-processing-and-management',
  'information-processing-in-agriculture',
  'information-retrieval-journal',
  'information-sciences',
  'information-security-technical-report',
  'information-systems',
  'information-systems-frontiers',
  'information-systems-research',
  'information-systems-and-e-business-management',
  'information-technology-and-tourism',
  'information-technology-and-management',
  'information-technology-for-development',
  'information-and-computation',
  'information-and-organization',
  'information-and-software-technology',
  'information-communication-and-society',
  'informationspraxis',
  'infrared-physics-and-technology',
  'infrastructure-complexity',
  'ingenieria-agricola',
  'injury',
  'injury-epidemiology',
  'injury-extra',
  'injury-prevention',
  'innovation-and-development',
  'innovation-in-language-learning-and-teaching',
  'innovation-the-european-journal-of-social-science-research',
  'innovations-in-education-and-teaching-international',
  'innovations-in-systems-and-software-engineering',
  'innovative-food-science-and-emerging-technologies',
  'innovative-higher-education',
  'innovative-infrastructure-solutions',
  'inorganic-chemistry',
  'inorganic-chemistry-communications',
  'inorganic-chemistry-frontiers',
  'inorganica-chimica-acta',
  'inorganics',
  'insect-biochemistry-and-molecular-biology',
  'insectes-sociaux',
  'insects',
  'insights-into-imaging',
  'insolvency-law-journal',
  'institut-national-de-la-recherche-scientifique-sciences-sociales',
  'institut-national-de-sante-publique-du-quebec-napp',
  'institut-national-de-sante-publique-du-quebec-topo',
  'institute-for-optimum-nutrition-harvard',
  'institute-of-physics-harvard',
  'institute-of-physics-numeric',
  'instituto-superior-de-teologia-de-las-islas-canarias',
  'instituto-de-pesquisas-tecnologicas',
  'instructional-science',
  'insurance-mathematics-and-economics',
  'integral-equations-and-operator-theory',
  'integral-transforms-and-special-functions',
  'integrating-materials-and-manufacturing-innovation',
  'integration-the-vlsi-journal',
  'integrative-biology',
  'integrative-medicine-international',
  'integrative-medicine-research',
  'integrative-psychological-and-behavioral-science',
  'intellectual-economics',
  'intelligence',
  'intelligent-buildings-international',
  'intelligent-industrial-systems',
  'intelligent-service-robotics',
  'intensive-and-critical-care-nursing',
  'intensive-care-medicine',
  'intensive-care-medicine-experimental',
  'inter-asia-cultural-studies',
  'inter-research-science-center',
  'interacting-with-computers',
  'interaction-design-and-architectures',
  'interactive-learning-environments',
  'interbloc',
  'interchange',
  'intercultural-education',
  'interdisciplinary-neurosurgery-advanced-techniques-and-case-management',
  'interdisciplinary-sciences-computational-life-sciences',
  'interdisziplinare-zeitschrift-fur-technologie-und-lernen',
  'interface-focus',
  'intermetallics',
  'internal-and-emergency-medicine',
  'international-advances-in-economic-research',
  'international-affairs-forum',
  'international-aquatic-research',
  'international-archives-of-allergy-and-immunology',
  'international-archives-of-medicine',
  'international-archives-of-occupational-and-environmental-health',
  'international-atomic-energy-agency',
  'international-biodeterioration-and-biodegradation',
  'international-breastfeeding-journal',
  'international-business-review',
  'international-cancer-conference-journal',
  'international-communication-of-chinese-culture',
  'international-communications-in-heat-and-mass-transfer',
  'international-comparative-jurisprudence',
  'international-conference-on-human-computer-interaction-proceedings',
  'international-conference-on-information-systems-development',
  'international-critical-thought',
  'international-dairy-journal',
  'international-economic-journal',
  'international-economics',
  'international-economics-and-economic-policy',
  'international-emergency-nursing',
  'international-entrepreneurship-and-management-journal',
  'international-environmental-agreements-politics-law-and-economics',
  'international-gambling-studies',
  'international-immunopharmacology',
  'international-information-and-library-review',
  'international-journal-for-academic-development',
  'international-journal-for-educational-integrity',
  'international-journal-for-educational-and-vocational-guidance',
  'international-journal-for-equity-in-health',
  'international-journal-for-ion-mobility-spectrometry',
  'international-journal-for-parasitology',
  'international-journal-for-parasitology-drugs-and-drug-resistance',
  'international-journal-for-parasitology-parasites-and-wildlife',
  'international-journal-for-philosophy-of-religion',
  'international-journal-for-the-advancement-of-counselling',
  'international-journal-for-the-semiotics-of-law-revue-internationale-de-semiotique-juridique',
  'international-journal-of-accounting',
  'international-journal-of-accounting-information-systems',
  'international-journal-of-adhesion-and-adhesives',
  'international-journal-of-adipose-tissue-and-stem-cells',
  'international-journal-of-adolescence-and-youth',
  'international-journal-of-advanced-structural-engineering',
  'international-journal-of-advances-in-engineering-sciences-and-applied-mathematics',
  'international-journal-of-africa-nursing-sciences',
  'international-journal-of-ambient-energy',
  'international-journal-of-antimicrobial-agents',
  'international-journal-of-applied-earth-observations-and-geoinformation',
  'international-journal-of-applied-and-computational-mathematics',
  'international-journal-of-approximate-reasoning',
  'international-journal-of-art-therapy',
  'international-journal-of-artificial-intelligence-in-education',
  'international-journal-of-audiology',
  'international-journal-of-behavioral-medicine',
  'international-journal-of-behavioral-nutrition-and-physical-activity',
  'international-journal-of-bilingual-education-and-bilingualism',
  'international-journal-of-biochemistry-and-cell-biology',
  'international-journal-of-biodiversity-science-ecosystem-services-and-management',
  'international-journal-of-biological-macromolecules',
  'international-journal-of-biological-sciences',
  'international-journal-of-biometeorology',
  'international-journal-of-bipolar-disorders',
  'international-journal-of-cancer',
  'international-journal-of-cardiology',
  'international-journal-of-chemical-and-analytical-science',
  'international-journal-of-child-care-and-education-policy',
  'international-journal-of-child-computer-interaction',
  'international-journal-of-childrens-spirituality',
  'international-journal-of-climatology',
  'international-journal-of-clinical-oncology',
  'international-journal-of-clinical-pharmacy',
  'international-journal-of-clinical-rheumatology',
  'international-journal-of-clinical-and-health-psychology',
  'international-journal-of-coal-geology',
  'international-journal-of-coal-science-and-technology',
  'international-journal-of-colorectal-disease',
  'international-journal-of-comparative-and-applied-criminal-justice',
  'international-journal-of-computational-fluid-dynamics',
  'international-journal-of-computer-assisted-radiology-and-surgery',
  'international-journal-of-computer-vision',
  'international-journal-of-computer-supported-collaborative-learning',
  'international-journal-of-concrete-structures-and-materials',
  'international-journal-of-control',
  'international-journal-of-critical-infrastructure-protection',
  'international-journal-of-cross-cultural-management',
  'international-journal-of-culture-and-mental-health',
  'international-journal-of-data-science-and-analytics',
  'international-journal-of-dental-science-and-research',
  'international-journal-of-design-creativity-and-innovation',
  'international-journal-of-developmental-neuroscience',
  'international-journal-of-dharma-studies',
  'international-journal-of-diabetes-mellitus',
  'international-journal-of-diabetes-in-developing-countries',
  'international-journal-of-digital-earth',
  'international-journal-of-disability-development-and-education',
  'international-journal-of-disaster-risk-reduction',
  'international-journal-of-disaster-risk-science',
  'international-journal-of-drug-policy',
  'international-journal-of-dynamics-and-control',
  'international-journal-of-early-childhood',
  'international-journal-of-early-years-education',
  'international-journal-of-earth-sciences',
  'international-journal-of-educational-development',
  'international-journal-of-educational-research',
  'international-journal-of-educational-technology-in-higher-education',
  'international-journal-of-electrical-power-and-energy-systems',
  'international-journal-of-electronic-commerce',
  'international-journal-of-electronics',
  'international-journal-of-electronics-letters',
  'international-journal-of-emergency-medicine',
  'international-journal-of-endocrine-oncology',
  'international-journal-of-energy-and-environmental-engineering',
  'international-journal-of-engineering-science',
  'international-journal-of-environmental-health-research',
  'international-journal-of-environmental-research-and-public-health',
  'international-journal-of-environmental-science-and-technology',
  'international-journal-of-epidemiology',
  'international-journal-of-epilepsy',
  'international-journal-of-ethics-education',
  'international-journal-of-exercise-science',
  'international-journal-of-fashion-design-technology-and-education',
  'international-journal-of-fatigue',
  'international-journal-of-financial-studies',
  'international-journal-of-food-contamination',
  'international-journal-of-food-microbiology',
  'international-journal-of-food-science-and-technology',
  'international-journal-of-forecasting',
  'international-journal-of-forest-engineering',
  'international-journal-of-fracture',
  'international-journal-of-fuzzy-systems',
  'international-journal-of-game-theory',
  'international-journal-of-gastronomy-and-food-science',
  'international-journal-of-general-systems',
  'international-journal-of-geo-engineering',
  'international-journal-of-geomechanics',
  'international-journal-of-geosynthetics-and-ground-engineering',
  'international-journal-of-geriatric-psychiatry',
  'international-journal-of-gerontology',
  'international-journal-of-greenhouse-gas-control',
  'international-journal-of-gynecology-and-obstetrics',
  'international-journal-of-health-economics-and-management',
  'international-journal-of-health-geographics',
  'international-journal-of-health-promotion-and-education',
  'international-journal-of-heat-and-fluid-flow',
  'international-journal-of-heat-and-mass-transfer',
  'international-journal-of-hematologic-oncology',
  'international-journal-of-hematology',
  'international-journal-of-hospitality-management',
  'international-journal-of-housing-policy',
  'international-journal-of-human-computer-studies',
  'international-journal-of-humanoid-robotics',
  'international-journal-of-hydrogen-energy',
  'international-journal-of-hygiene-and-environmental-health',
  'international-journal-of-impact-engineering',
  'international-journal-of-implant-dentistry',
  'international-journal-of-impotence-research',
  'international-journal-of-inclusive-education',
  'international-journal-of-industrial-chemistry',
  'international-journal-of-industrial-ergonomics',
  'international-journal-of-industrial-organization',
  'international-journal-of-infectious-diseases',
  'international-journal-of-information-management',
  'international-journal-of-information-security',
  'international-journal-of-injury-control-and-safety-promotion',
  'international-journal-of-intelligent-transportation-systems-research',
  'international-journal-of-intercultural-relations',
  'international-journal-of-jungian-studies',
  'international-journal-of-law-and-psychiatry',
  'international-journal-of-law-crime-and-justice',
  'international-journal-of-leadership-in-education',
  'international-journal-of-legal-medicine',
  'international-journal-of-lexicography',
  'international-journal-of-lifelong-education',
  'international-journal-of-logistics-research-and-applications',
  'international-journal-of-machine-learning-and-cybernetics',
  'international-journal-of-machine-tools-and-manufacture',
  'international-journal-of-management-science-and-engineering-management',
  'international-journal-of-marine-energy',
  'international-journal-of-mass-spectrometry',
  'international-journal-of-material-forming',
  'international-journal-of-mathematical-education-in-science-and-technology',
  'international-journal-of-mechanical-sciences',
  'international-journal-of-mechanical-and-materials-engineering',
  'international-journal-of-mechanics-and-materials-in-design',
  'international-journal-of-medical-informatics',
  'international-journal-of-medical-microbiology',
  'international-journal-of-medical-sciences',
  'international-journal-of-mental-health-promotion',
  'international-journal-of-mental-health-systems',
  'international-journal-of-mental-health-and-addiction',
  'international-journal-of-mineral-processing',
  'international-journal-of-mining-science-and-technology',
  'international-journal-of-molecular-medicine',
  'international-journal-of-molecular-sciences',
  'international-journal-of-multilingualism',
  'international-journal-of-multimedia-information-retrieval',
  'international-journal-of-multiphase-flow',
  'international-journal-of-mycobacteriology',
  'international-journal-of-non-linear-mechanics',
  'international-journal-of-nuclear-security',
  'international-journal-of-nursing-practice',
  'international-journal-of-nursing-sciences',
  'international-journal-of-nursing-studies',
  'international-journal-of-obesity',
  'international-journal-of-obesity-supplements',
  'international-journal-of-obstetric-anesthesia',
  'international-journal-of-occupational-medicine-and-environmental-health',
  'international-journal-of-odonatology',
  'international-journal-of-oncology',
  'international-journal-of-oral-science',
  'international-journal-of-oral-and-maxillofacial-surgery',
  'international-journal-of-orthopaedic-and-trauma-nursing',
  'international-journal-of-osteoarchaeology',
  'international-journal-of-osteopathic-medicine',
  'international-journal-of-paleopathology',
  'international-journal-of-parallel-programming',
  'international-journal-of-pavement-engineering',
  'international-journal-of-pediatric-endocrinology',
  'international-journal-of-pediatric-otorhinolaryngology',
  'international-journal-of-pediatric-otorhinolaryngology-extra',
  'international-journal-of-pediatrics-and-adolescent-medicine',
  'international-journal-of-peptide-research-and-therapeutics',
  'international-journal-of-pest-management',
  'international-journal-of-pharmaceutics',
  'international-journal-of-pharmacy-practice',
  'international-journal-of-philosophy-and-theology',
  'international-journal-of-plant-sciences',
  'international-journal-of-plasticity',
  'international-journal-of-plastics-technology',
  'international-journal-of-play',
  'international-journal-of-play-therapy',
  'international-journal-of-politics-culture-and-society',
  'international-journal-of-pressure-vessels-and-piping',
  'international-journal-of-primatology',
  'international-journal-of-production-economics',
  'international-journal-of-production-research',
  'international-journal-of-project-management',
  'international-journal-of-psychology',
  'international-journal-of-psychophysiology',
  'international-journal-of-public-health',
  'international-journal-of-qualitative-studies-in-education',
  'international-journal-of-quality-innovation',
  'international-journal-of-quantum-chemistry',
  'international-journal-of-radiation-oncology-biology-physics',
  'international-journal-of-rail-transportation',
  'international-journal-of-recycling-of-organic-waste-in-agriculture',
  'international-journal-of-refractory-metals-and-hard-materials',
  'international-journal-of-refrigeration',
  'international-journal-of-remote-sensing',
  'international-journal-of-research-and-method-in-education',
  'international-journal-of-research-in-marketing',
  'international-journal-of-research-in-undergraduate-mathematics-education',
  'international-journal-of-retina-and-vitreous',
  'international-journal-of-rock-mechanics-and-mining-sciences',
  'international-journal-of-std-and-aids',
  'international-journal-of-stem-education',
  'international-journal-of-science-education',
  'international-journal-of-science-education-part-b',
  'international-journal-of-science-and-mathematics-education',
  'international-journal-of-sediment-research',
  'international-journal-of-social-research-methodology',
  'international-journal-of-social-robotics',
  'international-journal-of-solids-and-structures',
  'international-journal-of-speech-technology',
  'international-journal-of-spine-surgery',
  'international-journal-of-sports-medicine',
  'international-journal-of-sport-and-exercise-psychology',
  'international-journal-of-stress-management',
  'international-journal-of-surgery',
  'international-journal-of-surgery-case-reports',
  'international-journal-of-surgery-open',
  'international-journal-of-sustainable-built-environment',
  'international-journal-of-sustainable-development-and-world-ecology',
  'international-journal-of-sustainable-energy',
  'international-journal-of-system-assurance-engineering-and-management',
  'international-journal-of-systematic-and-evolutionary-microbiology',
  'international-journal-of-technology-and-design-education',
  'international-journal-of-theoretical-physics',
  'international-journal-of-thermal-sciences',
  'international-journal-of-thermophysics',
  'international-journal-of-urban-sciences',
  'international-journal-of-urban-sustainable-development',
  'international-journal-of-veterinary-science-and-medicine',
  'international-journal-of-water-resources-development',
  'international-journal-of-wildland-fire',
  'international-journal-of-womens-dermatology',
  'international-journal-of-the-cardiovascular-academy',
  'international-journal-of-the-economics-of-business',
  'international-journal-on-digital-libraries',
  'international-journal-on-document-analysis-and-recognition',
  'international-journal-on-interactive-design-and-manufacturing',
  'international-journal-on-software-tools-for-technology-transfer',
  'international-labour-organization',
  'international-microbiology',
  'international-nano-letters',
  'international-ophthalmology',
  'international-organization',
  'international-orthodontics',
  'international-orthopaedics',
  'international-perspectives-in-psychology-research-practice-consultation',
  'international-pig-veterinary-society-congress-proceedings',
  'international-political-sociology',
  'international-research-in-geographical-and-environmental-education',
  'international-review-of-applied-economics',
  'international-review-of-economics',
  'international-review-of-economics-education',
  'international-review-of-economics-and-finance',
  'international-review-of-education',
  'international-review-of-financial-analysis',
  'international-review-of-law-and-economics',
  'international-review-of-law-computers-and-technology',
  'international-review-of-sport-and-exercise-psychology',
  'international-review-on-public-and-nonprofit-marketing',
  'international-soil-and-water-conservation-research',
  'international-strategic-management-review',
  'international-studies-association',
  'international-studies-perspectives',
  'international-studies-quarterly',
  'international-studies-review',
  'international-studies-in-catholic-education',
  'international-studies-in-sociology-of-education',
  'international-studies-in-the-philosophy-of-science',
  'international-surgery',
  'international-tax-and-public-finance',
  'international-transactions-on-systems-science-and-applications',
  'international-union-of-crystallography',
  'international-urogynecology-journal',
  'international-urology-and-nephrology',
  'internet-interventions-the-application-of-information-technology-in-mental-and-behavioural',
  'interventional-cardiology',
  'interventional-neurology',
  'intervirology',
  'intravital',
  'intrinsically-disordered-proteins',
  'inventiones-mathematicae',
  'inverse-problems',
  'inverse-problems-in-science-and-engineering',
  'invertebrate-biology',
  'invertebrate-neuroscience',
  'invertebrate-systematics',
  'investigaciones-europeas-de-direccion-y-economia-de-la-empresa',
  'investigaciones-de-historia-economica-economic-history-research',
  'investigational-new-drugs',
  'investigative-genetics',
  'investigative-ophthalmology-and-visual-science',
  'investigative-radiology',
  'ionics',
  'iranian-journal-of-allergy-asthma-and-immunology',
  'iranian-polymer-journal',
  'irish-educational-studies',
  'irish-historical-studies',
  'irish-journal-of-medical-science',
  'irish-journal-of-psychological-medicine',
  'irish-studies-review',
  'irish-veterinary-journal',
  'irrigation-science',
  'islam-and-christian-muslim-relations',
  'islets',
  'isotopes-in-environmental-and-health-studies',
  'israel-journal-of-ecology-and-evolution',
  'israel-journal-of-health-policy-research',
  'israel-journal-of-plant-sciences',
  'israel-medical-association-journal',
  'issues-in-environmental-science-and-technology',
  'italian-economic-journal',
  'italian-journal-of-pediatrics',
  'ithaque',
  'izvestiya-mathematics',
  'ja-clinical-reports',
  'jaad-case-reports',
  'jaapa',
  'jacc-cardiovascular-imaging',
  'jak-stat',
  'jama',
  'jama-dermatology',
  'jamia',
  'jbic-journal-of-biological-inorganic-chemistry',
  'jcc-open',
  'jgz-tijdschrift-voor-jeugdgezondheidszorg',
  'jmm-case-reports',
  'jom',
  'jpras-open',
  'jahrbuch-der-osterreichischen-byzantinischen-gesellschaft',
  'jahrbuch-fur-evangelikale-theologie',
  'jahresbericht-der-deutschen-mathematiker-vereinigung',
  'japan-and-the-world-economy',
  'japan-journal-of-industrial-and-applied-mathematics',
  'japanese-dental-science-review',
  'japanese-journal-of-ophthalmology',
  'japanese-journal-of-radiology',
  'javnost-the-public',
  'jeugdbeleid',
  'joint-bone-spine',
  'jornal-de-pediatria',
  'journal-europeen-des-urgences-et-de-reanimation',
  'journal-francais-dophtalmologie',
  'journal-of-magnetic-resonance-imaging',
  'journal-de-chirurgie-viscerale',
  'journal-de-gynecologie-obstetrique-et-biologie-de-la-reproduction',
  'journal-de-mycologie-medicale',
  'journal-de-radiologie-diagnostique-et-interventionnelle',
  'journal-de-therapie-comportementale-et-cognitive',
  'journal-de-traumatologie-du-sport',
  'journal-de-mathematiques-pures-et-appliquees',
  'journal-de-pediatrie-et-de-puericulture',
  'journal-de-readaptation-medicale',
  'journal-des-anti-infectieux',
  'journal-des-maladies-vasculaires',
  'journal-for-general-philosophy-of-science',
  'journal-for-immunotherapy-of-cancer',
  'journal-for-labour-market-research',
  'journal-for-nature-conservation',
  'journal-for-the-history-of-astronomy',
  'journal-fur-mathematik-didaktik',
  'journal-fur-verbraucherschutz-und-lebensmittelsicherheit',
  'journal-fur-asthetische-chirurgie',
  'journal-of-abnormal-child-psychology',
  'journal-of-abnormal-psychology',
  'journal-of-academic-ethics',
  'journal-of-accounting-education',
  'journal-of-accounting-literature',
  'journal-of-accounting-and-economics',
  'journal-of-accounting-and-public-policy',
  'journal-of-acute-medicine',
  'journal-of-adhesion-science-and-technology',
  'journal-of-adolescence',
  'journal-of-adolescent-health',
  'journal-of-adult-development',
  'journal-of-advanced-research',
  'journal-of-adventure-education-and-outdoor-learning',
  'journal-of-aerosol-medicine-and-pulmonary-drug-delivery',
  'journal-of-aerosol-science',
  'journal-of-aerospace-engineering',
  'journal-of-aerospace-information-systems',
  'journal-of-affective-disorders',
  'journal-of-african-american-studies',
  'journal-of-african-cultural-studies',
  'journal-of-african-earth-sciences',
  'journal-of-african-trade',
  'journal-of-aging-studies',
  'journal-of-agricultural-and-environmental-ethics',
  'journal-of-agricultural-and-food-chemistry',
  'journal-of-air-transport-management',
  'journal-of-aircraft',
  'journal-of-algebra',
  'journal-of-algebraic-combinatorics',
  'journal-of-alloys-and-compounds',
  'journal-of-alzheimers-disease',
  'journal-of-ambient-intelligence-and-humanized-computing',
  'journal-of-american-association-for-pediatric-ophthalmology-and-strabismus',
  'journal-of-analytical-atomic-spectrometry',
  'journal-of-analytical-science-and-technology',
  'journal-of-analytical-toxicology',
  'journal-of-analytical-and-applied-pyrolysis',
  'journal-of-anesthesia',
  'journal-of-anesthesia-history',
  'journal-of-animal-ecology',
  'journal-of-animal-physiology-and-animal-nutrition',
  'journal-of-animal-science',
  'journal-of-animal-science-and-biotechnology',
  'journal-of-animal-science-and-technology',
  'journal-of-anthropological-archaeology',
  'journal-of-antimicrobial-chemotherapy',
  'journal-of-anxiety-disorders',
  'journal-of-applied-animal-research',
  'journal-of-applied-animal-science',
  'journal-of-applied-biomedicine',
  'journal-of-applied-crystallography',
  'journal-of-applied-developmental-psychology',
  'journal-of-applied-ecology',
  'journal-of-applied-electrochemistry',
  'journal-of-applied-entomology',
  'journal-of-applied-genetics',
  'journal-of-applied-geophysics',
  'journal-of-applied-logic',
  'journal-of-applied-mathematics-and-computing',
  'journal-of-applied-mechanics',
  'journal-of-applied-meteorology-and-climatology',
  'journal-of-applied-non-classical-logics',
  'journal-of-applied-philosophy',
  'journal-of-applied-phycology',
  'journal-of-applied-physics',
  'journal-of-applied-physiology',
  'journal-of-applied-psychology',
  'journal-of-applied-remote-sensing',
  'journal-of-applied-research-and-technology',
  'journal-of-applied-research-in-memory-and-cognition',
  'journal-of-applied-research-on-medicinal-and-aromatic-plants',
  'journal-of-applied-volcanology',
  'journal-of-applied-water-engineering-and-research',
  'journal-of-aquatic-animal-health',
  'journal-of-archaeological-method-and-theory',
  'journal-of-archaeological-research',
  'journal-of-archaeological-science',
  'journal-of-archaeological-science-reports',
  'journal-of-architectural-engineering',
  'journal-of-arid-environments',
  'journal-of-arrhythmia',
  'journal-of-arthroscopy-and-joint-surgery',
  'journal-of-artificial-organs',
  'journal-of-asia-pacific-entomology',
  'journal-of-asian-earth-sciences',
  'journal-of-asian-economics',
  'journal-of-asian-natural-products-research',
  'journal-of-assisted-reproduction-and-genetics',
  'journal-of-astronomical-telescopes-instruments-and-systems',
  'journal-of-atmospheric-chemistry',
  'journal-of-atmospheric-and-oceanic-technology',
  'journal-of-atmospheric-and-solar-terrestrial-physics',
  'journal-of-atrial-fibrillation',
  'journal-of-autism-and-developmental-disorders',
  'journal-of-autoimmunity',
  'journal-of-automated-reasoning',
  'journal-of-avian-biology',
  'journal-of-bacteriology',
  'journal-of-baltic-studies',
  'journal-of-banking-and-finance',
  'journal-of-banking-and-finance-law-and-practice',
  'journal-of-basic-microbiology',
  'journal-of-behavior-therapy-and-experimental-psychiatry',
  'journal-of-behavioral-education',
  'journal-of-behavioral-medicine',
  'journal-of-behavioral-and-experimental-finance',
  'journal-of-beliefs-and-values',
  'journal-of-big-data',
  'journal-of-bio-and-tribo-corrosion',
  'journal-of-bioeconomics',
  'journal-of-bioenergetics-and-biomembranes',
  'journal-of-biogeography',
  'journal-of-biological-education',
  'journal-of-biological-engineering',
  'journal-of-biological-physics',
  'journal-of-biological-research-thessaloniki',
  'journal-of-biomaterials-science-polymer-edition',
  'journal-of-biomechanical-engineering',
  'journal-of-biomechanics',
  'journal-of-biomedical-informatics',
  'journal-of-biomedical-materials-research-part-a',
  'journal-of-biomedical-optics',
  'journal-of-biomedical-science',
  'journal-of-biomedical-semantics',
  'journal-of-biomolecular-nmr',
  'journal-of-biomolecular-screening',
  'journal-of-biomolecular-structure-and-dynamics',
  'journal-of-biotechnology',
  'journal-of-bodywork-and-movement-therapies',
  'journal-of-bone-oncology',
  'journal-of-bone-and-mineral-metabolism',
  'journal-of-bone-and-mineral-research',
  'journal-of-brachial-plexus-and-peripheral-nerve-injury',
  'journal-of-breath-research',
  'journal-of-bridge-engineering',
  'journal-of-building-engineering',
  'journal-of-building-pathology-and-rehabilitation',
  'journal-of-building-performance-simulation',
  'journal-of-burn-care-and-research',
  'journal-of-business-economics',
  'journal-of-business-ethics',
  'journal-of-business-logistics',
  'journal-of-business-research',
  'journal-of-business-venturing',
  'journal-of-business-venturing-insights',
  'journal-of-business-and-psychology',
  'journal-of-co2-utilization',
  'journal-of-cancer-education',
  'journal-of-cancer-policy',
  'journal-of-cancer-research-and-clinical-oncology',
  'journal-of-cancer-research-and-therapeutics',
  'journal-of-cancer-survivorship',
  'journal-of-cardiology',
  'journal-of-cardiology-cases',
  'journal-of-cardiothoracic-surgery',
  'journal-of-cardiothoracic-and-vascular-anesthesia',
  'journal-of-cardiovascular-computed-tomography',
  'journal-of-cardiovascular-development-and-disease',
  'journal-of-cardiovascular-disease-research',
  'journal-of-cardiovascular-magnetic-resonance',
  'journal-of-cardiovascular-pharmacology-and-therapeutics',
  'journal-of-cardiovascular-translational-research',
  'journal-of-catalysis',
  'journal-of-cataract-and-refractive-surgery',
  'journal-of-cell-communication-and-signaling',
  'journal-of-cell-science',
  'journal-of-cellular-immunotherapy',
  'journal-of-cellular-and-molecular-medicine',
  'journal-of-cereal-science',
  'journal-of-cerebral-blood-flow-and-metabolism',
  'journal-of-change-management',
  'journal-of-chemical-and-engineering-data',
  'journal-of-chemical-biology',
  'journal-of-chemical-crystallography',
  'journal-of-chemical-ecology',
  'journal-of-chemical-education',
  'journal-of-chemical-information-and-modeling',
  'journal-of-chemical-neuroanatomy',
  'journal-of-chemical-theory-and-computation',
  'journal-of-cheminformatics',
  'journal-of-chemistry-and-chemical-engineering',
  'journal-of-chemotherapy',
  'journal-of-child-and-adolescent-trauma',
  'journal-of-child-and-adolescent-psychopharmacology',
  'journal-of-child-and-family-studies',
  'journal-of-children-and-media',
  'journal-of-children-and-poverty',
  'journal-of-childrens-orthopaedics',
  'journal-of-chinese-economic-and-business-studies',
  'journal-of-chinese-management',
  'journal-of-chinese-political-science',
  'journal-of-chinese-studies',
  'journal-of-chiropractic-medicine',
  'journal-of-choice-modelling',
  'journal-of-chromatography-a',
  'journal-of-chromatography-b',
  'journal-of-civil-litigation-and-practice',
  'journal-of-civil-structural-health-monitoring',
  'journal-of-cleaner-production',
  'journal-of-climate',
  'journal-of-clinical-and-translational-endocrinology',
  'journal-of-clinical-anesthesia',
  'journal-of-clinical-bioinformatics',
  'journal-of-clinical-epidemiology',
  'journal-of-clinical-gastroenterology',
  'journal-of-clinical-immunology',
  'journal-of-clinical-lipidology',
  'journal-of-clinical-medicine',
  'journal-of-clinical-microbiology',
  'journal-of-clinical-monitoring-and-computing',
  'journal-of-clinical-movement-disorders',
  'journal-of-clinical-neuroscience',
  'journal-of-clinical-oncology',
  'journal-of-clinical-orthopaedics-and-trauma',
  'journal-of-clinical-pathology',
  'journal-of-clinical-psychology-in-medical-settings',
  'journal-of-clinical-tuberculosis-and-other-mycobacterial-diseases',
  'journal-of-clinical-virology',
  'journal-of-clinical-and-experimental-hepatology',
  'journal-of-clinical-and-experimental-neuropsychology',
  'journal-of-clinical-and-translational-endocrinology-case-reports',
  'journal-of-cloud-computing',
  'journal-of-co-operative-organization-and-management',
  'journal-of-coastal-conservation',
  'journal-of-cognitive-psychology',
  'journal-of-cold-regions-engineering',
  'journal-of-colloid-and-interface-science',
  'journal-of-combinatorial-optimization',
  'journal-of-combinatorial-theory-series-a',
  'journal-of-combinatorics',
  'journal-of-commodity-markets',
  'journal-of-common-market-studies',
  'journal-of-communication-disorders',
  'journal-of-communications-and-networks',
  'journal-of-community-genetics',
  'journal-of-community-health',
  'journal-of-comparative-asian-development',
  'journal-of-comparative-economics',
  'journal-of-comparative-effectiveness-research',
  'journal-of-comparative-physiology-a',
  'journal-of-comparative-physiology-b',
  'journal-of-comparative-psychology',
  'journal-of-compassionate-health-care',
  'journal-of-complexity',
  'journal-of-composites-for-construction',
  'journal-of-computational-chemistry',
  'journal-of-computational-electronics',
  'journal-of-computational-neuroscience',
  'journal-of-computational-physics',
  'journal-of-computational-science',
  'journal-of-computational-surgery',
  'journal-of-computational-and-applied-mathematics',
  'journal-of-computational-and-nonlinear-dynamics',
  'journal-of-computer-virology-and-hacking-techniques',
  'journal-of-computer-and-system-sciences',
  'journal-of-computer-aided-molecular-design',
  'journal-of-computers-in-education',
  'journal-of-computing-and-information-science-in-engineering',
  'journal-of-computing-in-civil-engineering',
  'journal-of-computing-in-higher-education',
  'journal-of-congenital-cardiology',
  'journal-of-construction-engineering-and-management',
  'journal-of-constructional-steel-research',
  'journal-of-consulting-and-clinical-psychology',
  'journal-of-consumer-policy',
  'journal-of-consumer-psychology',
  'journal-of-consumer-research',
  'journal-of-contaminant-hydrology',
  'journal-of-contemporary-accounting-and-economics',
  'journal-of-contemporary-african-studies',
  'journal-of-contemporary-asia',
  'journal-of-contemporary-european-studies',
  'journal-of-contemporary-psychotherapy',
  'journal-of-contextual-behavioral-science',
  'journal-of-control-automation-and-electrical-systems',
  'journal-of-controlled-release',
  'journal-of-corporate-finance',
  'journal-of-cosmology-and-astroparticle-physics',
  'journal-of-counseling-psychology',
  'journal-of-criminal-justice',
  'journal-of-criminal-justice-education',
  'journal-of-critical-care',
  'journal-of-crohns-and-colitis',
  'journal-of-crohns-and-colitis-supplements',
  'journal-of-cross-cultural-gerontology',
  'journal-of-cryptographic-engineering',
  'journal-of-crystal-growth',
  'journal-of-cultural-economics',
  'journal-of-cultural-economy',
  'journal-of-cultural-heritage',
  'journal-of-current-ophthalmology',
  'journal-of-curriculum-studies',
  'journal-of-cystic-fibrosis',
  'journal-of-dairy-science',
  'journal-of-data-and-information-quality',
  'journal-of-decision-systems',
  'journal-of-dental-education',
  'journal-of-dental-research',
  'journal-of-dentistry',
  'journal-of-dermatological-science',
  'journal-of-dermatological-science-supplement',
  'journal-of-dermatology-and-dermatologic-surgery',
  'journal-of-destination-marketing-and-management',
  'journal-of-development-economics',
  'journal-of-development-effectiveness',
  'journal-of-development-studies',
  'journal-of-developmental-biology',
  'journal-of-developmental-and-life-course-criminology',
  'journal-of-developmental-and-physical-disabilities',
  'journal-of-diabetes-and-metabolic-disorders',
  'journal-of-diabetes-and-its-complications',
  'journal-of-differential-equations',
  'journal-of-discrete-algorithms',
  'journal-of-display-technology',
  'journal-of-diversity-in-higher-education',
  'journal-of-drug-delivery-science-and-technology',
  'journal-of-dynamic-behavior-of-materials',
  'journal-of-dynamic-systems-measurement-and-control',
  'journal-of-dynamical-and-control-systems',
  'journal-of-dynamics-and-differential-equations',
  'journal-of-east-asian-linguistics',
  'journal-of-eastern-african-studies',
  'journal-of-eating-disorders',
  'journal-of-echocardiography',
  'journal-of-ecology',
  'journal-of-econometrics',
  'journal-of-economic-behavior-and-organization',
  'journal-of-economic-dynamics-and-control',
  'journal-of-economic-entomology',
  'journal-of-economic-growth',
  'journal-of-economic-interaction-and-coordination',
  'journal-of-economic-methodology',
  'journal-of-economic-policy-reform',
  'journal-of-economic-psychology',
  'journal-of-economic-structures',
  'journal-of-economic-theory',
  'journal-of-economics',
  'journal-of-economics-and-business',
  'journal-of-economics-and-finance',
  'journal-of-economics-finance-and-administrative-science',
  'journal-of-ecotourism',
  'journal-of-education-policy',
  'journal-of-education-and-work',
  'journal-of-education-for-teaching',
  'journal-of-educational-change',
  'journal-of-educational-evaluation-for-health-professions',
  'journal-of-educational-psychology',
  'journal-of-educational-and-behavioral-statistics',
  'journal-of-elasticity',
  'journal-of-elections-public-opinion-and-parties',
  'journal-of-electrical-systems-and-information-technology',
  'journal-of-electroanalytical-chemistry',
  'journal-of-electrocardiology',
  'journal-of-electroceramics',
  'journal-of-electromagnetic-waves-and-applications',
  'journal-of-electromyography-and-kinesiology',
  'journal-of-electron-spectroscopy-and-related-phenomena',
  'journal-of-electronic-imaging',
  'journal-of-electronic-materials',
  'journal-of-electronic-packaging',
  'journal-of-electronic-testing',
  'journal-of-electrostatics',
  'journal-of-emergency-nursing',
  'journal-of-empirical-finance',
  'journal-of-endocrinological-investigation',
  'journal-of-endocrinology',
  'journal-of-endodontics',
  'journal-of-energy-chemistry',
  'journal-of-energy-engineering',
  'journal-of-energy-resources-technology',
  'journal-of-energy-storage',
  'journal-of-engineering-materials-and-technology',
  'journal-of-engineering-mathematics',
  'journal-of-engineering-mechanics',
  'journal-of-engineering-and-technology-management',
  'journal-of-engineering-for-gas-turbines-and-power',
  'journal-of-english-for-academic-purposes',
  'journal-of-environmental-chemical-engineering',
  'journal-of-environmental-economics-and-management',
  'journal-of-environmental-economics-and-policy',
  'journal-of-environmental-engineering',
  'journal-of-environmental-health-science-and-engineering',
  'journal-of-environmental-management',
  'journal-of-environmental-planning-and-management',
  'journal-of-environmental-policy-and-planning',
  'journal-of-environmental-psychology',
  'journal-of-environmental-quality',
  'journal-of-environmental-radioactivity',
  'journal-of-environmental-sciences',
  'journal-of-environmental-studies-and-sciences',
  'journal-of-epidemiology-and-community-health',
  'journal-of-epidemiology-and-global-health',
  'journal-of-equine-veterinary-science',
  'journal-of-ethnic-foods',
  'journal-of-ethnic-and-migration-studies',
  'journal-of-ethnobiology-and-ethnomedicine',
  'journal-of-ethnopharmacology',
  'journal-of-ethology',
  'journal-of-eurasian-studies',
  'journal-of-european-public-policy',
  'journal-of-evolutionary-biology',
  'journal-of-evolutionary-economics',
  'journal-of-exercise-science-and-fitness',
  'journal-of-experimental-and-clinical-assisted-reproduction',
  'journal-of-experimental-and-clinical-cancer-research',
  'journal-of-experimental-and-theoretical-artificial-intelligence',
  'journal-of-experimental-algorithmics',
  'journal-of-experimental-botany',
  'journal-of-experimental-child-psychology',
  'journal-of-experimental-criminology',
  'journal-of-experimental-marine-biology-and-ecology',
  'journal-of-experimental-nanoscience',
  'journal-of-experimental-orthopaedics',
  'journal-of-experimental-psychology-animal-learning-and-cognition',
  'journal-of-experimental-psychology-applied',
  'journal-of-experimental-psychology-general',
  'journal-of-experimental-psychology-human-perception-and-performance',
  'journal-of-experimental-psychology-learning-memory-and-cognition',
  'journal-of-experimental-social-psychology',
  'journal-of-experimental-zoology',
  'journal-of-exposure-science-and-environmental-epidemiology',
  'journal-of-failure-analysis-and-prevention',
  'journal-of-family-business-strategy',
  'journal-of-family-planning-and-reproductive-health-care',
  'journal-of-family-psychology',
  'journal-of-family-violence',
  'journal-of-family-and-economic-issues',
  'journal-of-fetal-medicine',
  'journal-of-field-ornithology',
  'journal-of-finance',
  'journal-of-financial-economics',
  'journal-of-financial-intermediation',
  'journal-of-financial-markets',
  'journal-of-financial-services-research',
  'journal-of-financial-stability',
  'journal-of-fish-diseases',
  'journal-of-fluency-disorders',
  'journal-of-fluids-engineering',
  'journal-of-fluids-and-structures',
  'journal-of-fluorescence',
  'journal-of-fluorine-chemistry',
  'journal-of-food-composition-and-analysis',
  'journal-of-food-engineering',
  'journal-of-food-measurement-and-characterization',
  'journal-of-food-protection',
  'journal-of-food-science-and-technology',
  'journal-of-food-and-drug-analysis',
  'journal-of-foot-and-ankle-research',
  'journal-of-forensic-psychiatry-and-psychology',
  'journal-of-forensic-radiology-and-imaging',
  'journal-of-forensic-sciences',
  'journal-of-forensic-and-legal-medicine',
  'journal-of-forest-economics',
  'journal-of-forest-research',
  'journal-of-forestry-research',
  'journal-of-fourier-analysis-and-applications',
  'journal-of-frailty-and-aging',
  'journal-of-freshwater-ecology',
  'journal-of-frugal-innovation',
  'journal-of-fuel-cell-science-and-technology',
  'journal-of-functional-analysis',
  'journal-of-functional-biomaterials',
  'journal-of-functional-foods',
  'journal-of-further-and-higher-education',
  'journal-of-fusion-energy',
  'journal-of-gambling-studies',
  'journal-of-gastroenterology',
  'journal-of-gastroenterology-and-hepatology',
  'journal-of-gastrointestinal-cancer',
  'journal-of-gastrointestinal-and-liver-diseases',
  'journal-of-gender-studies',
  'journal-of-general-internal-medicine',
  'journal-of-general-plant-pathology',
  'journal-of-general-virology',
  'journal-of-genetic-counseling',
  'journal-of-genetic-engineering-and-biotechnology',
  'journal-of-genetics-and-genomics',
  'journal-of-geochemical-exploration',
  'journal-of-geodesy',
  'journal-of-geodynamics',
  'journal-of-geographical-systems',
  'journal-of-geography-in-higher-education',
  'journal-of-geometry',
  'journal-of-geometry-and-physics',
  'journal-of-geophysics-and-engineering',
  'journal-of-geotechnical-and-geoenvironmental-engineering',
  'journal-of-geriatric-psychiatry-and-neurology',
  'journal-of-gerontological-nursing',
  'journal-of-ginseng-research',
  'journal-of-glaciology',
  'journal-of-glaucoma',
  'journal-of-global-antimicrobial-resistance',
  'journal-of-global-entrepreneurship-research',
  'journal-of-global-fashion-marketing',
  'journal-of-global-optimization',
  'journal-of-global-scholars-of-marketing-science',
  'journal-of-graphic-novels-and-comics',
  'journal-of-great-lakes-research',
  'journal-of-grid-computing',
  'journal-of-guidance-control-and-dynamics',
  'journal-of-gynecologic-oncology',
  'journal-of-hand-therapy',
  'journal-of-hand-and-microsurgery',
  'journal-of-happiness-studies',
  'journal-of-hazardous-materials',
  'journal-of-hazardous-toxic-and-radioactive-waste',
  'journal-of-health-economics',
  'journal-of-health-and-social-behavior',
  'journal-of-health-population-and-nutrition',
  'journal-of-hearing-science',
  'journal-of-heat-transfer',
  'journal-of-hematology-and-oncology',
  'journal-of-hematopathology',
  'journal-of-hepatology',
  'journal-of-herbal-medicine',
  'journal-of-heritage-tourism',
  'journal-of-heuristics',
  'journal-of-high-technology-management-research',
  'journal-of-highway-and-transportation-research-and-development',
  'journal-of-hip-preservation-surgery',
  'journal-of-homotopy-and-related-structures',
  'journal-of-hospital-infection',
  'journal-of-hospitality-and-tourism-management',
  'journal-of-hospitality-leisure-sport-and-tourism-education',
  'journal-of-housing-economics',
  'journal-of-housing-and-the-built-environment',
  'journal-of-human-evolution',
  'journal-of-human-hypertension',
  'journal-of-human-rights-and-social-work',
  'journal-of-hydraulic-engineering',
  'journal-of-hydro-environment-research',
  'journal-of-hydrologic-engineering',
  'journal-of-hydrology',
  'journal-of-hydrology-regional-studies',
  'journal-of-hydrometeorology',
  'journal-of-hypertension',
  'journal-of-iberian-and-latin-american-studies',
  'journal-of-immigrant-and-minority-health',
  'journal-of-immunological-methods',
  'journal-of-inclusion-phenomena-and-macrocyclic-chemistry',
  'journal-of-indian-association-for-child-and-adolescent-mental-health',
  'journal-of-indian-association-of-pediatric-surgeons',
  'journal-of-indian-college-of-cardiology',
  'journal-of-indian-council-of-philosophical-research',
  'journal-of-indian-philosophy',
  'journal-of-individual-differences',
  'journal-of-industrial-ecology',
  'journal-of-industrial-engineering-international',
  'journal-of-industrial-microbiology-and-biotechnology',
  'journal-of-industrial-and-engineering-chemistry',
  'journal-of-industry-competition-and-trade',
  'journal-of-inequalities-and-applications',
  'journal-of-infection',
  'journal-of-infection-and-chemotherapy',
  'journal-of-infection-and-public-health',
  'journal-of-infectious-diseases',
  'journal-of-inflammation',
  'journal-of-information-security-and-applications',
  'journal-of-information-technology',
  'journal-of-informetrics',
  'journal-of-infrastructure-systems',
  'journal-of-inherited-metabolic-disease',
  'journal-of-innate-immunity',
  'journal-of-innovation-and-entrepreneurship',
  'journal-of-innovation-in-digital-ecosystems',
  'journal-of-inorganic-biochemistry',
  'journal-of-inorganic-and-organometallic-polymers-and-materials',
  'journal-of-insect-behavior',
  'journal-of-insect-conservation',
  'journal-of-insect-physiology',
  'journal-of-institute-of-medicine',
  'journal-of-institutional-and-theoretical-economics',
  'journal-of-instrumentation',
  'journal-of-integrated-omics',
  'journal-of-integrative-environmental-sciences',
  'journal-of-intellectual-and-developmental-disability',
  'journal-of-intelligence',
  'journal-of-intelligent-and-robotic-systems',
  'journal-of-intelligent-information-systems',
  'journal-of-intelligent-manufacturing',
  'journal-of-intensive-care',
  'journal-of-interaction-science',
  'journal-of-interactive-marketing',
  'journal-of-intercultural-communication-research',
  'journal-of-internal-medicine',
  'journal-of-international-accounting-auditing-and-taxation',
  'journal-of-international-business-studies',
  'journal-of-international-economics',
  'journal-of-international-entrepreneurship',
  'journal-of-international-financial-markets-institutions-and-money',
  'journal-of-international-humanitarian-action',
  'journal-of-international-management',
  'journal-of-international-marketing',
  'journal-of-international-migration-and-integration',
  'journal-of-international-money-and-finance',
  'journal-of-international-and-comparative-social-policy',
  'journal-of-internet-services-and-applications',
  'journal-of-interprofessional-education-and-practice',
  'journal-of-intervention-and-statebuilding',
  'journal-of-interventional-cardiac-electrophysiology',
  'journal-of-invasive-and-interventional-cardiology',
  'journal-of-invertebrate-pathology',
  'journal-of-investigative-dermatology',
  'journal-of-investigative-dermatology-symposium-proceedings',
  'journal-of-irrigation-and-drainage-engineering',
  'journal-of-israeli-history',
  'journal-of-judicial-administration',
  'journal-of-king-saud-university-computer-and-information-sciences',
  'journal-of-king-saud-university-engineering-sciences',
  'journal-of-king-saud-university-languages-and-translation',
  'journal-of-king-saud-university-science',
  'journal-of-knee-surgery',
  'journal-of-korean-medical-science',
  'journal-of-labor-research',
  'journal-of-laboratory-automation',
  'journal-of-laboratory-physicians',
  'journal-of-land-use-science',
  'journal-of-latin-american-cultural-studies',
  'journal-of-latina-o-psychology',
  'journal-of-law-and-medicine',
  'journal-of-legal-affairs-and-dispute-resolution-in-engineering-and-construction',
  'journal-of-lightwave-technology',
  'journal-of-lipid-research',
  'journal-of-location-based-services',
  'journal-of-logic-and-algebraic-programming',
  'journal-of-logic-language-and-information',
  'journal-of-logical-and-algebraic-methods-in-programming',
  'journal-of-loss-prevention-in-the-process-industries',
  'journal-of-low-power-electronics-and-applications',
  'journal-of-low-temperature-physics',
  'journal-of-luminescence',
  'journal-of-macroeconomics',
  'journal-of-magnetic-resonance',
  'journal-of-magnetism-and-magnetic-materials',
  'journal-of-mammalogy',
  'journal-of-mammary-gland-biology-and-neoplasia',
  'journal-of-management',
  'journal-of-management-and-governance',
  'journal-of-management-control',
  'journal-of-management-information-systems',
  'journal-of-management-in-engineering',
  'journal-of-managerial-psychology',
  'journal-of-manipulative-and-physiological-therapeutics',
  'journal-of-manufacturing-processes',
  'journal-of-manufacturing-science-and-engineering',
  'journal-of-manufacturing-systems',
  'journal-of-maps',
  'journal-of-marine-science-and-engineering',
  'journal-of-marine-science-and-technology',
  'journal-of-marine-systems',
  'journal-of-marine-and-island-cultures',
  'journal-of-maritime-archaeology',
  'journal-of-marketing',
  'journal-of-marketing-communications',
  'journal-of-marketing-management',
  'journal-of-marketing-research',
  'journal-of-marketing-for-higher-education',
  'journal-of-material-cycles-and-waste-management',
  'journal-of-materials-chemistry-a',
  'journal-of-materials-chemistry-b',
  'journal-of-materials-chemistry-c',
  'journal-of-materials-engineering-and-performance',
  'journal-of-materials-processing-tech',
  'journal-of-materials-research-and-technology',
  'journal-of-materials-science',
  'journal-of-materials-science-materials-in-electronics',
  'journal-of-materials-science-materials-in-medicine',
  'journal-of-materials-in-civil-engineering',
  'journal-of-materiomics',
  'journal-of-mathematical-behavior',
  'journal-of-mathematical-biology',
  'journal-of-mathematical-chemistry',
  'journal-of-mathematical-economics',
  'journal-of-mathematical-fluid-mechanics',
  'journal-of-mathematical-imaging-and-vision',
  'journal-of-mathematical-physics',
  'journal-of-mathematical-psychology',
  'journal-of-mathematics-teacher-education',
  'journal-of-mathematics-and-music',
  'journal-of-mathematics-in-industry',
  'journal-of-maxillofacial-and-oral-surgery',
  'journal-of-mechanical-design',
  'journal-of-mechanisms-and-robotics',
  'journal-of-media-psychology-theories-methods-and-applications',
  'journal-of-medical-case-reports',
  'journal-of-medical-devices',
  'journal-of-medical-entomology',
  'journal-of-medical-ethics',
  'journal-of-medical-genetics',
  'journal-of-medical-imaging',
  'journal-of-medical-imaging-and-radiation-oncology',
  'journal-of-medical-imaging-and-radiation-sciences',
  'journal-of-medical-internet-research',
  'journal-of-medical-microbiology',
  'journal-of-medical-physics',
  'journal-of-medical-toxicology',
  'journal-of-medical-ultrasonics',
  'journal-of-medical-ultrasound',
  'journal-of-medical-and-biological-engineering',
  'journal-of-medicinal-chemistry',
  'journal-of-medicine-and-the-person',
  'journal-of-membrane-science',
  'journal-of-memory-and-language',
  'journal-of-mens-health',
  'journal-of-micro-and-nano-manufacturing',
  'journal-of-micro-bio-robotics',
  'journal-of-micro-nanolithography-mems-and-moems',
  'journal-of-microbiological-methods',
  'journal-of-microbiology-immunology-and-infection',
  'journal-of-microelectromechanical-systems',
  'journal-of-micromechanics-and-microengineering',
  'journal-of-micropalaeontology',
  'journal-of-microscopy-and-ultrastructure',
  'journal-of-midwifery-and-womens-health',
  'journal-of-minimal-access-surgery',
  'journal-of-minimally-invasive-gynecology',
  'journal-of-modern-italian-studies',
  'journal-of-modern-jewish-studies',
  'journal-of-modern-power-systems-and-clean-energy',
  'journal-of-modern-transportation',
  'journal-of-molecular-biology',
  'journal-of-molecular-catalysis-a-chemical',
  'journal-of-molecular-catalysis-b-enzymatic',
  'journal-of-molecular-endocrinology',
  'journal-of-molecular-evolution',
  'journal-of-molecular-graphics-and-modelling',
  'journal-of-molecular-histology',
  'journal-of-molecular-liquids',
  'journal-of-molecular-medicine',
  'journal-of-molecular-microbiology-and-biotechnology',
  'journal-of-molecular-modeling',
  'journal-of-molecular-neuroscience',
  'journal-of-molecular-psychiatry',
  'journal-of-molecular-signaling',
  'journal-of-molecular-spectroscopy',
  'journal-of-molecular-structure',
  'journal-of-molecular-and-cellular-cardiology',
  'journal-of-monetary-economics',
  'journal-of-moral-education',
  'journal-of-morphology',
  'journal-of-multilingual-and-multicultural-development',
  'journal-of-multinational-financial-management',
  'journal-of-muscle-research-and-cell-motility',
  'journal-of-music-technology-and-education',
  'journal-of-nanobiotechnology',
  'journal-of-nanomechanics-and-micromechanics',
  'journal-of-nanoparticle-research',
  'journal-of-nanophotonics',
  'journal-of-nanoscience-and-nanotechnology',
  'journal-of-nanostructure-in-chemistry',
  'journal-of-nanotechnology-in-engineering-and-medicine',
  'journal-of-natural-gas-science-and-engineering',
  'journal-of-natural-history',
  'journal-of-natural-medicines',
  'journal-of-natural-products',
  'journal-of-natural-resources-policy-research',
  'journal-of-negative-results-in-biomedicine',
  'journal-of-neonatal-nursing',
  'journal-of-nephrology',
  'journal-of-network-and-computer-applications',
  'journal-of-network-and-systems-management',
  'journal-of-neural-engineering',
  'journal-of-neural-transmission',
  'journal-of-neuro-oncology',
  'journal-of-neuroengineering-and-rehabilitation',
  'journal-of-neurointerventional-surgery',
  'journal-of-neurovirology',
  'journal-of-neurochemistry',
  'journal-of-neurodevelopmental-disorders',
  'journal-of-neuroimmune-pharmacology',
  'journal-of-neuroimmunology',
  'journal-of-neuroinflammation',
  'journal-of-neurolinguistics',
  'journal-of-neurological-disorders',
  'journal-of-neurology',
  'journal-of-neurology-neurosurgery-and-psychiatry',
  'journal-of-neuropathology-and-experimental-neurology',
  'journal-of-neurophysiology',
  'journal-of-neuropsychology',
  'journal-of-neuroradiology',
  'journal-of-neuroscience-methods',
  'journal-of-neuroscience-and-neuroengineering',
  'journal-of-neuroscience-psychology-and-economics',
  'journal-of-neurosurgery',
  'journal-of-neurosurgery-pediatrics',
  'journal-of-neurosurgery-spine',
  'journal-of-neurotrauma',
  'journal-of-new-music-research',
  'journal-of-non-crystalline-solids',
  'journal-of-non-newtonian-fluid-mechanics',
  'journal-of-nondestructive-evaluation',
  'journal-of-nonlinear-science',
  'journal-of-nonverbal-behavior',
  'journal-of-northeast-agricultural-university',
  'journal-of-nuclear-cardiology',
  'journal-of-nuclear-materials',
  'journal-of-nuclear-medicine-technology',
  'journal-of-nuclear-science-and-technology',
  'journal-of-nursing-education',
  'journal-of-nursing-regulation',
  'journal-of-nutrigenetics-and-nutrigenomics',
  'journal-of-nutrition',
  'journal-of-nutrition-and-intermediary-metabolism',
  'journal-of-nutrition-education-and-behavior',
  'journal-of-obsessive-compulsive-and-related-disorders',
  'journal-of-obstetrics-and-gynaecology-canada',
  'journal-of-occupational-health-psychology',
  'journal-of-occupational-medicine-and-toxicology',
  'journal-of-occupational-rehabilitation',
  'journal-of-occupational-science',
  'journal-of-occupational-and-organizational-psychology',
  'journal-of-ocean-engineering-and-marine-energy',
  'journal-of-oceanography',
  'journal-of-ocular-pharmacology-and-therapeutics',
  'journal-of-offshore-mechanics-and-arctic-engineering',
  'journal-of-open-innovation-technology-market-and-complexity',
  'journal-of-operations-management',
  'journal-of-ophthalmic-inflammation-and-infection',
  'journal-of-optics',
  'journal-of-optics-official-publication-of-the-optical-society-of-india',
  'journal-of-optimization-theory-and-applications',
  'journal-of-optometry',
  'journal-of-oral-biology-and-craniofacial-research',
  'journal-of-oral-biosciences',
  'journal-of-oral-and-maxillofacial-surgery',
  'journal-of-oral-and-maxillofacial-surgery-medicine-and-pathology',
  'journal-of-organometallic-chemistry',
  'journal-of-ornithology',
  'journal-of-orofacial-orthopedics',
  'journal-of-orthopaedic-research',
  'journal-of-orthopaedic-surgery-and-research',
  'journal-of-orthopaedic-translation',
  'journal-of-orthopaedic-trauma',
  'journal-of-orthopaedics',
  'journal-of-orthopaedics-and-traumatology',
  'journal-of-orthopaedics-trauma-and-rehabilitation',
  'journal-of-otolaryngology-head-and-neck-surgery',
  'journal-of-otology',
  'journal-of-outdoor-recreation-and-tourism',
  'journal-of-ovarian-research',
  'journal-of-paediatrics-and-child-health',
  'journal-of-palaeogeography',
  'journal-of-paleolimnology',
  'journal-of-paleontology',
  'journal-of-palliative-medicine',
  'journal-of-parallel-and-distributed-computing',
  'journal-of-parasitic-diseases',
  'journal-of-patient-safety-and-infection-control',
  'journal-of-peace-education',
  'journal-of-peace-research',
  'journal-of-pediatric-health-care',
  'journal-of-pediatric-neuropsychology',
  'journal-of-pediatric-neurosciences',
  'journal-of-pediatric-nursing',
  'journal-of-pediatric-ophthalmology-and-strabismus',
  'journal-of-pediatric-surgery',
  'journal-of-pediatric-surgery-case-reports',
  'journal-of-pediatric-urology',
  'journal-of-pediatric-and-adolescent-gynecology',
  'journal-of-peptide-science',
  'journal-of-performance-of-constructed-facilities',
  'journal-of-perianesthesia-nursing',
  'journal-of-perinatal-medicine',
  'journal-of-perinatology',
  'journal-of-periodontology',
  'journal-of-personality-and-social-psychology',
  'journal-of-personalized-medicine',
  'journal-of-personnel-psychology',
  'journal-of-pest-science',
  'journal-of-petroleum-exploration-and-production-technology',
  'journal-of-petroleum-science-and-engineering',
  'journal-of-petrology',
  'journal-of-pharmaceutical-analysis',
  'journal-of-pharmaceutical-health-care-and-sciences',
  'journal-of-pharmaceutical-innovation',
  'journal-of-pharmaceutical-investigation',
  'journal-of-pharmaceutical-policy-and-practice',
  'journal-of-pharmaceutical-and-biomedical-analysis',
  'journal-of-pharmacokinetics-and-pharmacodynamics',
  'journal-of-pharmacological-and-toxicological-methods',
  'journal-of-pharmacology-and-pharmacotherapeutics',
  'journal-of-pharmacy-practice-and-research',
  'journal-of-pharmacy-research',
  'journal-of-pharmacy-and-pharmacology',
  'journal-of-phase-equilibria-and-diffusion',
  'journal-of-philosophical-logic',
  'journal-of-phonetics',
  'journal-of-photochemistry-and-photobiology-a-chemistry',
  'journal-of-photochemistry-and-photobiology-b-biology',
  'journal-of-photochemistry-and-photobiology-c-photochemistry-reviews',
  'journal-of-photonics-for-energy',
  'journal-of-phycology',
  'journal-of-physical-oceanography',
  'journal-of-physical-therapy-science',
  'journal-of-physical-and-chemical-reference-data',
  'journal-of-physics-a-mathematical-and-theoretical',
  'journal-of-physics-b-atomic-molecular-and-optical-physics',
  'journal-of-physics-d-applied-physics',
  'journal-of-physics-g-nuclear-and-particle-physics',
  'journal-of-physics-and-chemistry-of-solids',
  'journal-of-physics-condensed-matter',
  'journal-of-physics-conference-series',
  'journal-of-physiological-anthropology',
  'journal-of-physiology-paris',
  'journal-of-physiology-and-biochemistry',
  'journal-of-physiotherapy',
  'journal-of-pierre-fauchard-academy',
  'journal-of-pipeline-systems-engineering-and-practice',
  'journal-of-plant-biochemistry-and-biotechnology',
  'journal-of-plant-growth-regulation',
  'journal-of-plant-interactions',
  'journal-of-plant-nutrition-and-soil-science',
  'journal-of-plant-physiology',
  'journal-of-plant-research',
  'journal-of-plastic-reconstructive-and-aesthetic-surgery',
  'journal-of-poetry-therapy',
  'journal-of-police-and-criminal-psychology',
  'journal-of-policing-intelligence-and-counter-terrorism',
  'journal-of-policy-modeling',
  'journal-of-policy-research-in-tourism-leisure-and-events',
  'journal-of-pollination-ecology',
  'journal-of-polymer-research',
  'journal-of-polymers-and-the-environment',
  'journal-of-population-ageing',
  'journal-of-population-economics',
  'journal-of-population-research',
  'journal-of-porous-materials',
  'journal-of-postcolonial-writing',
  'journal-of-postgraduate-medicine',
  'journal-of-power-sources',
  'journal-of-pragmatics',
  'journal-of-pressure-vessel-technology',
  'journal-of-primary-health-care',
  'journal-of-process-control',
  'journal-of-product-innovation-management',
  'journal-of-productivity-analysis',
  'journal-of-professional-issues-in-engineering-education-and-practice',
  'journal-of-professional-nursing',
  'journal-of-property-research',
  'journal-of-propulsion-and-power',
  'journal-of-prosthodontic-research',
  'journal-of-proteome-research',
  'journal-of-proteomics',
  'journal-of-pseudo-differential-operators-and-applications',
  'journal-of-psychiatric-research',
  'journal-of-psychiatric-and-mental-health-nursing',
  'journal-of-psychiatry-and-neuroscience',
  'journal-of-psycholinguistic-research',
  'journal-of-psychopathology-and-behavioral-assessment',
  'journal-of-psychophysiology',
  'journal-of-psychosocial-nursing-and-mental-health-services',
  'journal-of-psychosocial-rehabilitation-and-mental-health',
  'journal-of-psychosomatic-research',
  'journal-of-psychotherapy-integration',
  'journal-of-public-economics',
  'journal-of-public-health',
  'journal-of-public-policy-and-marketing',
  'journal-of-purchasing-and-supply-management',
  'journal-of-pure-and-applied-algebra',
  'journal-of-quantitative-criminology',
  'journal-of-quantitative-economics',
  'journal-of-quantitative-spectroscopy-and-radiative-transfer',
  'journal-of-racial-and-ethnic-health-disparities',
  'journal-of-radiation-oncology',
  'journal-of-radiation-research',
  'journal-of-radiation-research-and-applied-sciences',
  'journal-of-radioanalytical-and-nuclear-chemistry',
  'journal-of-radiological-protection',
  'journal-of-radiology-nursing',
  'journal-of-rail-transport-planning-and-management',
  'journal-of-rational-emotive-and-cognitive-behavior-therapy',
  'journal-of-real-time-image-processing',
  'journal-of-reconstructive-microsurgery',
  'journal-of-refractive-surgery',
  'journal-of-regulatory-economics',
  'journal-of-rehabilitation-research-and-development',
  'journal-of-reliable-intelligent-environments',
  'journal-of-religion-and-health',
  'journal-of-religious-education',
  'journal-of-remanufacturing',
  'journal-of-renewable-and-sustainable-energy',
  'journal-of-reproductive-health-and-medicine',
  'journal-of-reproductive-immunology',
  'journal-of-reproductive-and-infant-psychology',
  'journal-of-research-in-personality',
  'journal-of-research-in-science-teaching',
  'journal-of-retailing',
  'journal-of-retailing-and-consumer-services',
  'journal-of-rheumatology',
  'journal-of-risk-research',
  'journal-of-risk-and-financial-management',
  'journal-of-risk-and-uncertainty',
  'journal-of-robotic-surgery',
  'journal-of-rock-mechanics-and-geotechnical-engineering',
  'journal-of-roman-archaeology-a',
  'journal-of-roman-archaeology-b',
  'journal-of-rural-mental-health',
  'journal-of-rural-studies',
  'journal-of-safety-research',
  'journal-of-saudi-chemical-society',
  'journal-of-scheduling',
  'journal-of-school-psychology',
  'journal-of-science-education-and-technology',
  'journal-of-science-and-medicine-in-sport',
  'journal-of-scientific-computing',
  'journal-of-sea-research',
  'journal-of-second-language-writing',
  'journal-of-seismology',
  'journal-of-semiconductors',
  'journal-of-sensor-and-actuator-networks',
  'journal-of-sensors-and-sensor-systems',
  'journal-of-separation-science',
  'journal-of-sexual-aggression',
  'journal-of-shipping-and-trade',
  'journal-of-shoulder-and-elbow-surgery',
  'journal-of-signal-processing-systems',
  'journal-of-simulation',
  'journal-of-sleep-research',
  'journal-of-small-business-and-entrepreneurship',
  'journal-of-social-archaeology',
  'journal-of-social-and-economic-development',
  'journal-of-socio-economics',
  'journal-of-software-engineering-research-and-development',
  'journal-of-soils-and-sediments',
  'journal-of-sol-gel-science-and-technology',
  'journal-of-solar-energy-engineering',
  'journal-of-solid-state-chemistry',
  'journal-of-solid-state-electrochemistry',
  'journal-of-solid-state-lighting',
  'journal-of-solution-chemistry',
  'journal-of-sound-and-vibration',
  'journal-of-south-american-earth-sciences',
  'journal-of-spacecraft-and-rockets',
  'journal-of-spinal-disorders-and-techniques',
  'journal-of-sport-and-tourism',
  'journal-of-sports-sciences',
  'journal-of-statistical-computation-and-simulation',
  'journal-of-statistical-distributions-and-applications',
  'journal-of-statistical-mechanics-theory-and-experiment',
  'journal-of-statistical-physics',
  'journal-of-statistical-planning-and-inference',
  'journal-of-steroid-biochemistry-and-molecular-biology',
  'journal-of-stored-products-research',
  'journal-of-strategic-information-systems',
  'journal-of-strategic-marketing',
  'journal-of-strength-and-conditioning-research',
  'journal-of-structural-biology',
  'journal-of-structural-engineering',
  'journal-of-structural-geology',
  'journal-of-structural-and-functional-genomics',
  'journal-of-studies-on-alcohol-and-drugs',
  'journal-of-substance-abuse-treatment',
  'journal-of-sulfur-chemistry',
  'journal-of-superconductivity-and-novel-magnetism',
  'journal-of-surfactants-and-detergents',
  'journal-of-surgical-education',
  'journal-of-surgical-research',
  'journal-of-surveying-engineering',
  'journal-of-sustainable-cement-based-materials',
  'journal-of-sustainable-finance-and-investment',
  'journal-of-sustainable-metallurgy',
  'journal-of-sustainable-mining',
  'journal-of-sustainable-tourism',
  'journal-of-sustainable-water-in-the-built-environment',
  'journal-of-symbolic-computation',
  'journal-of-synchrotron-radiation',
  'journal-of-systems-architecture',
  'journal-of-systems-chemistry',
  'journal-of-systems-engineering-and-electronics',
  'journal-of-taibah-university-for-science',
  'journal-of-terramechanics',
  'journal-of-the-american-society-for-mass-spectrometry',
  'journal-of-the-electrochemical-society',
  'journal-of-the-institution-of-engineers-series-a',
  'journal-of-the-institution-of-engineers-series-b',
  'journal-of-the-institution-of-engineers-series-c',
  'journal-of-the-institution-of-engineers-series-d',
  'journal-of-the-institution-of-engineers-series-e',
  'journal-of-the-japanese-and-international-economies',
  'journal-of-the-textile-institute',
  'journal-of-theoretical-biology',
  'journal-of-theoretical-probability',
  'journal-of-theoretical-and-applied-physics',
  'journal-of-theoretical-and-philosophical-psychology',
  'journal-of-therapeutic-ultrasound',
  'journal-of-thermal-analysis-and-calorimetry',
  'journal-of-thermal-biology',
  'journal-of-thermal-science-and-engineering-applications',
  'journal-of-thermal-spray-technology',
  'journal-of-thermophysics-and-heat-transfer',
  'journal-of-thoracic-oncology',
  'journal-of-threat-assessment-and-management',
  'journal-of-thrombosis-and-haemostasis',
  'journal-of-thrombosis-and-thrombolysis',
  'journal-of-tissue-viability',
  'journal-of-tourism-and-cultural-change',
  'journal-of-trace-elements-in-medicine-and-biology',
  'journal-of-traditional-chinese-medical-sciences',
  'journal-of-traditional-chinese-medicine',
  'journal-of-traditional-and-complementary-medicine',
  'journal-of-traffic-and-transportation-engineering',
  'journal-of-translational-medicine',
  'journal-of-transport-and-health',
  'journal-of-transport-geography',
  'journal-of-transportation-engineering',
  'journal-of-transportation-security',
  'journal-of-trauma-management-and-outcomes',
  'journal-of-tribology',
  'journal-of-tropical-ecology',
  'journal-of-trust-management',
  'journal-of-trust-research',
  'journal-of-turbomachinery',
  'journal-of-ultrasound',
  'journal-of-uncertainty-analysis-and-applications',
  'journal-of-unconventional-oil-and-gas-resources',
  'journal-of-universal-computer-science',
  'journal-of-urban-design',
  'journal-of-urban-economics',
  'journal-of-urban-health',
  'journal-of-urban-management',
  'journal-of-urban-planning-and-development',
  'journal-of-urbanism-international-research-on-placemaking-and-urban-sustainability',
  'journal-of-vacuum-science-and-technology-a-vacuum-surfaces-and-films',
  'journal-of-vacuum-science-and-technology-b-microelectronics-and-nanometer-structures',
  'journal-of-vascular-research',
  'journal-of-vascular-surgery',
  'journal-of-vascular-surgery-cases',
  'journal-of-vegetation-science',
  'journal-of-venomous-animals-and-toxins-including-tropical-diseases',
  'journal-of-vertebrate-paleontology',
  'journal-of-veterinary-behavior-clinical-applications-and-research',
  'journal-of-veterinary-cardiology',
  'journal-of-veterinary-internal-medicine',
  'journal-of-vibration-and-acoustics',
  'journal-of-virological-methods',
  'journal-of-virology',
  'journal-of-visceral-surgery',
  'journal-of-vision',
  'journal-of-visual-communication-and-image-representation',
  'journal-of-visual-languages-and-computing',
  'journal-of-visualization',
  'journal-of-visualized-experiments',
  'journal-of-vocational-behavior',
  'journal-of-vocational-education-and-training',
  'journal-of-voice',
  'journal-of-volcanology-and-geothermal-research',
  'journal-of-water-process-engineering',
  'journal-of-water-resources-planning-and-management',
  'journal-of-waterway-port-coastal-and-ocean-engineering',
  'journal-of-wildlife-diseases',
  'journal-of-wind-engineering-and-industrial-aerodynamics',
  'journal-of-wine-research',
  'journal-of-wood-science',
  'journal-of-world-business',
  'journal-of-world-prehistory',
  'journal-of-world-systems-research',
  'journal-of-wound-ostomy-and-continence-nursing',
  'journal-of-young-pharmacists',
  'journal-of-youth-studies',
  'journal-of-youth-and-adolescence',
  'journal-of-zoo-and-wildlife-medicine',
  'journal-of-zoology',
  'journal-of-the-acm',
  'journal-of-the-academy-of-marketing-science',
  'journal-of-the-academy-of-nutrition-and-dietetics',
  'journal-of-the-air-and-waste-management-association',
  'journal-of-the-american-academy-of-dermatology',
  'journal-of-the-american-academy-of-orthopaedic-surgeons',
  'journal-of-the-american-association-of-laboratory-animal-science',
  'journal-of-the-american-board-of-family-medicine',
  'journal-of-the-american-ceramic-society',
  'journal-of-the-american-chemical-society',
  'journal-of-the-american-college-of-cardiology',
  'journal-of-the-american-college-of-clinical-wound-specialists',
  'journal-of-the-american-college-of-radiology',
  'journal-of-the-american-college-of-surgeons',
  'journal-of-the-american-oil-chemists-society',
  'journal-of-the-american-society-of-brewing-chemists',
  'journal-of-the-american-society-of-cytopathology',
  'journal-of-the-american-society-of-echocardiography',
  'journal-of-the-american-society-of-nephrology',
  'journal-of-the-american-veterinary-medical-association',
  'journal-of-the-american-water-resources-association',
  'journal-of-the-anatomical-society-of-india',
  'journal-of-the-asia-pacific-economy',
  'journal-of-the-association-for-information-science-and-technology',
  'journal-of-the-association-for-information-systems',
  'journal-of-the-association-for-research-in-otolaryngology',
  'journal-of-the-association-for-vascular-access',
  'journal-of-the-association-of-arab-universities-for-basic-and-applied-sciences',
  'journal-of-the-atmospheric-sciences',
  'journal-of-the-brazilian-chemical-society',
  'journal-of-the-brazilian-computer-society',
  'journal-of-the-brazilian-society-of-mechanical-sciences-and-engineering',
  'journal-of-the-canadian-chiropractic-association',
  'journal-of-the-chinese-advanced-materials-society',
  'journal-of-the-chinese-institute-of-engineers',
  'journal-of-the-college-of-physicians-and-surgeons-pakistan',
  'journal-of-the-economic-science-association',
  'journal-of-the-egyptian-mathematical-society',
  'journal-of-the-egyptian-national-cancer-institute',
  'journal-of-the-egyptian-public-health-association',
  'journal-of-the-energy-institute',
  'journal-of-the-european-ceramic-society',
  'journal-of-the-formosan-medical-association',
  'journal-of-the-franklin-institute',
  'journal-of-the-geological-society',
  'journal-of-the-indian-academy-of-wood-science',
  'journal-of-the-indian-ocean-region',
  'journal-of-the-indian-society-for-probability-and-statistics',
  'journal-of-the-indian-society-of-pedodontics-and-preventive-dentistry',
  'journal-of-the-indian-society-of-remote-sensing',
  'journal-of-the-international-aids-society',
  'journal-of-the-international-society-of-sports-nutrition',
  'journal-of-the-iranian-chemical-society',
  'journal-of-the-knowledge-economy',
  'journal-of-the-korean-society-for-applied-biological-chemistry',
  'journal-of-the-korean-statistical-society',
  'journal-of-the-mechanical-behavior-of-biomedical-materials',
  'journal-of-the-mechanics-and-physics-of-solids',
  'journal-of-the-medical-library-association',
  'journal-of-the-national-cancer-institute',
  'journal-of-the-national-medical-association',
  'journal-of-the-neurological-sciences',
  'journal-of-the-nigerian-mathematical-society',
  'journal-of-the-operations-research-society-of-china',
  'journal-of-the-philosophy-of-sport',
  'journal-of-the-royal-anthropological-institute',
  'journal-of-the-royal-army-medical-corps',
  'journal-of-the-royal-society-interface',
  'journal-of-the-royal-society-of-medicine',
  'journal-of-the-saudi-heart-association',
  'journal-of-the-saudi-society-of-agricultural-sciences',
  'journal-of-the-saudi-society-of-dermatology-and-dermatologic-surgery',
  'journal-of-the-society-of-archivists',
  'journal-of-the-taiwan-institute-of-chemical-engineers',
  'journal-of-the-world-federation-of-orthodontists',
  'journal-on-computing-and-cultural-heritage',
  'journal-on-data-semantics',
  'journal-on-multimodal-user-interfaces',
  'journalism-practice',
  'journalism-studies',
  'journalistica',
  'juristische-schulung',
  'juristische-zitierweise',
  'justice-quarterly',
  'ki-kunstliche-intelligenz',
  'kontakt',
  'kth-royal-institute-of-technology-school-of-computer-science-and-communication',
  'kth-royal-institute-of-technology-school-of-computer-science-and-communication-sv',
  'kaohsiung-journal-of-medical-sciences',
  'karbala-international-journal-of-modern-science',
  'karger-journals',
  'karger-journals-author-date',
  'kidney-and-blood-pressure-research',
  'kidney-disease-and-transplantation',
  'kidney-international',
  'kidney-international-supplements',
  'kidney-research-and-clinical-practice',
  'kind-and-adolescent',
  'kindheit-und-entwicklung',
  'kinesitherapie-la-revue',
  'klinische-monatsblatter-fur-augenheilkunde',
  'knee-surgery-sports-traumatology-arthroscopy',
  'knowledge-and-information-systems',
  'knowledge-based-systems',
  'kommunikation-und-recht',
  'korean-journal-of-anesthesiology',
  'korean-social-science-journal',
  'kritische-ausgabe',
  'kolner-zeitschrift-fur-soziologie-und-sozialpsychologie',
  'lanthropologie',
  'lencephale',
  'lendocrinologo',
  'laide-soignante',
  'levolution-psychiatrique',
  'lithos',
  'lo-scalpello-otodi-educational',
  'lwt-food-science-and-technology',
  'la-presse-medicale',
  'la-revue-gestion-et-organisation',
  'la-revue-sage-femme',
  'la-revue-dhomeopathie',
  'la-rivista-italiana-della-medicina-di-laboratorio-italian-journal-of-laboratory-medicine',
  'la-radiologia-medica',
  'la-revue-de-linfirmiere',
  'la-revue-de-medecine-interne',
  'la-revue-de-medecine-legale',
  'la-revue-de-sante-scolaire-et-universitaire',
  'lab-animal',
  'lab-on-a-chip',
  'labor-history',
  'laboratory-investigation',
  'labour-economics',
  'lancashire-business-school-harvard',
  'land',
  'land-use-policy',
  'landes-bioscience-journals',
  'landscape-ecology',
  'landscape-research',
  'landscape-and-ecological-engineering',
  'landscape-and-urban-planning',
  'landslides',
  'langenbecks-archives-of-surgery',
  'langmuir',
  'language',
  'language-awareness',
  'language-policy',
  'language-resources-and-evaluation',
  'language-sciences',
  'language-testing-in-asia',
  'language-and-cognitive-processes',
  'language-and-communication',
  'language-and-education',
  'language-and-intercultural-communication',
  'language-in-society',
  'language-culture-and-curriculum',
  'large-scale-assessments-in-education',
  'laser-physics',
  'laser-physics-letters',
  'lasers-in-manufacturing-and-materials-processing',
  'lasers-in-medical-science',
  'laterality-asymmetries-of-body-brain-and-cognition',
  'latin-american-economic-review',
  'latin-american-perspectives',
  'latin-american-research-review',
  'latin-american-and-caribbean-ethnic-studies',
  'law-and-society-review',
  'law-and-critique',
  'law-and-human-behavior',
  'laws',
  'le-mouvement-social',
  'le-pharmacien-hospitalier-et-clinicien',
  'le-praticien-en-anesthesie-reanimation',
  'le-tapuscrit-author-date',
  'le-tapuscrit-note',
  'leadership-and-management-in-engineering',
  'learning-and-memory',
  'learning-environments-research',
  'learning-and-individual-differences',
  'learning-and-instruction',
  'learning-and-motivation',
  'learning-culture-and-social-interaction',
  'learning-media-and-technology',
  'legal-medicine',
  'legal-and-criminological-psychology',
  'leidraad-voor-juridische-auteurs',
  'leisure-studies',
  'leisure-loisir',
  'leprosy-review',
  'les-journees-de-la-recherche-avicole',
  'les-journees-de-la-recherche-porcine',
  'lethaia',
  'lettera-matematica',
  'letters-in-mathematical-physics',
  'letters-in-spatial-and-resource-sciences',
  'lettres-et-sciences-humaines-fr',
  'leukemia',
  'leukemia-research',
  'leukemia-research-reports',
  'leukemia-supplements',
  'leviathan',
  'lexicography',
  'lluelles-lexisnexis',
  'library-collections-acquisitions-and-technical-services',
  'library-and-information-science-research',
  'life',
  'life-sciences',
  'life-sciences-in-space-research',
  'life-sciences-society-and-policy',
  'lifetime-data-analysis',
  'light-science-and-applications',
  'limnologica',
  'limnology',
  'limnology-and-oceanography',
  'lindbergia',
  'linear-algebra-and-its-applications',
  'linear-and-multilinear-algebra',
  'lingua',
  'lingua-sinica',
  'linguistics-and-education',
  'linguistics-and-philosophy',
  'lipids',
  'lipids-in-health-and-disease',
  'liquid-crystals',
  'liquid-crystals-reviews',
  'liquid-crystals-today',
  'list-forum-fur-wirtschafts-und-finanzpolitik',
  'lithosphere',
  'liver-cancer',
  'liver-international',
  'liverpool-hope-university-harvard',
  'liverpool-law-review',
  'livestock-science',
  'local-environment',
  'local-government-law-journal',
  'logica-universalis',
  'logistics-research',
  'loisir-et-societe-society-and-leisure',
  'london-south-bank-university-numeric',
  'long-range-planning',
  'longevity-and-healthspan',
  'longevity-sciences-and-medicine',
  'low-temperature-physics',
  'lubricants',
  'lund-university-school-of-economics-and-management',
  'lung',
  'lung-cancer',
  'lung-cancer-management',
  'lung-india',
  'lupus-science-and-medicine',
  'lakartidningen',
  'mis-quarterly',
  'musculoskeletal-surgery',
  'macedonian-journal-of-medical-sciences',
  'machine-learning',
  'machine-translation',
  'machine-vision-and-applications',
  'machines',
  'macromolecular-reaction-engineering',
  'macromolecules',
  'magister',
  'magnetic-resonance-imaging',
  'magnetic-resonance-materials-in-physics-biology-and-medicine',
  'magnetic-resonance-in-medicine',
  'malaria-journal',
  'mammal-research',
  'mammal-review',
  'mammalian-biology',
  'mammalian-genome',
  'management-accounting-research',
  'management-international-review',
  'management-review-quarterly',
  'managing-leisure',
  'manchester-university-press',
  'manual-therapy',
  'mcgill-fr',
  'manuelle-medizin',
  'manufacturing-letters',
  'manuscripta-mathematica',
  'marine-and-freshwater-research',
  'marine-biodiversity',
  'marine-biodiversity-records',
  'marine-biology',
  'marine-biotechnology',
  'marine-chemistry',
  'marine-drugs',
  'marine-ecology-progress-series',
  'marine-environmental-research',
  'marine-genomics',
  'marine-geology',
  'marine-geophysical-research',
  'marine-micropaleontology',
  'marine-policy',
  'marine-pollution-bulletin',
  'marine-structures',
  'marine-systems-and-ocean-technology',
  'marine-and-coastal-fisheries',
  'marine-and-freshwater-behaviour-and-physiology',
  'marine-and-petroleum-geology',
  'maritime-policy-and-management',
  'maritime-studies',
  'marketing-letters',
  'mastozoologia-neotropical',
  'materials',
  'materials-and-design',
  'materials-characterization',
  'materials-chemistry-and-physics',
  'materials-discovery',
  'materials-horizons',
  'materials-letters',
  'materials-research-bulletin',
  'materials-science-and-engineering-a',
  'materials-science-and-engineering-b',
  'materials-science-and-engineering-c',
  'materials-science-and-engineering-r',
  'materials-science-in-semiconductor-processing',
  'materials-today',
  'materials-today-communications',
  'materials-today-proceedings',
  'materials-and-structures',
  'materials-for-renewable-and-sustainable-energy',
  'maternal-health-neonatology-and-perinatology',
  'maternal-and-child-health-journal',
  'mathematical-biosciences',
  'mathematical-geosciences',
  'mathematical-methods-of-operations-research',
  'mathematical-physics-analysis-and-geometry',
  'mathematical-programming',
  'mathematical-programming-computation',
  'mathematical-sciences',
  'mathematical-social-sciences',
  'mathematical-and-computer-modelling',
  'mathematics',
  'mathematics-education-research-journal',
  'mathematics-and-computers-in-simulation',
  'mathematics-and-financial-economics',
  'mathematics-in-computer-science',
  'mathematics-of-control-signals-and-systems',
  'mathematics-in-industry-case-studies',
  'mathematische-annalen',
  'mathematische-semesterberichte',
  'mathematische-zeitschrift',
  'matrix-biology',
  'maturitas',
  'maxillofacial-plastic-and-reconstructive-surgery',
  'mayo-clinic-proceedings',
  'mcdonald-institute-monographs',
  'measurement',
  'measurement-science-and-technology',
  'meat-science',
  'meccanica',
  'mechanical-sciences',
  'mechanical-systems-and-signal-processing',
  'mechanics-research-communications',
  'mechanics-of-advanced-materials-and-modern-processes',
  'mechanics-of-materials',
  'mechanics-of-time-dependent-materials',
  'mechanism-and-machine-theory',
  'mechanisms-of-ageing-and-development',
  'mechanisms-of-development',
  'mechatronics',
  'medchemcomm',
  'media-culture-and-society',
  'medical-and-biological-engineering-and-computing',
  'medical-acupuncture',
  'medical-care',
  'medical-dosimetry',
  'medical-education',
  'medical-engineering-and-physics',
  'medical-epigenetics',
  'medical-gas-research',
  'medical-history',
  'medical-humanities',
  'medical-hypotheses',
  'medical-image-analysis',
  'medical-journal-armed-forces-india',
  'medical-microbiology-and-immunology',
  'medical-molecular-morphology',
  'medical-mycology-case-reports',
  'medical-oncology',
  'medical-photonics',
  'medical-physics',
  'medical-principles-and-practice',
  'medical-science-educator',
  'medical-sciences',
  'medicina',
  'medicina-clinica',
  'medicina-fluminensis',
  'medicina-intensiva',
  'medicina-reproductiva-y-embriologia-clinica',
  'medicinal-chemistry-research',
  'medicine',
  'medicine-and-science-in-sports-and-exercise',
  'medicine-studies',
  'medicine-conflict-and-survival',
  'medicine-health-care-and-philosophy',
  'mediterranean-journal-of-mathematics',
  'mediterranean-journal-of-nutrition-and-metabolism',
  'medizinische-klinik-intensivmedizin-und-notfallmedizin',
  'melanoma-management',
  'melbourne-school-of-theology',
  'membranes',
  'memetic-computing',
  'memory',
  'memorias-do-instituto-oswaldo-cruz',
  'mental-health-and-prevention',
  'mental-health-and-physical-activity',
  'mental-health-and-substance-use',
  'mental-health-religion-and-culture',
  'mentoring-and-tutoring-partnership-in-learning',
  'mercatus-center',
  'meta-gene',
  'metabolic-brain-disease',
  'metabolic-engineering',
  'metabolic-engineering-communications',
  'metabolism',
  'metabolites',
  'metabolomics',
  'metacognition-and-learning',
  'metal-powder-report',
  'metallography-microstructure-and-analysis',
  'metallomics',
  'metallurgical-and-materials-transactions',
  'metallurgical-and-materials-transactions-a',
  'metallurgical-and-materials-transactions-b',
  'metallurgical-and-materials-transactions-e',
  'metals',
  'metamaterials',
  'metascience',
  'meteoritics-and-planetary-science',
  'meteorological-applications',
  'meteorological-monographs',
  'meteorology-and-atmospheric-physics',
  'methodology-and-computing-in-applied-probability',
  'methodology-european-journal-of-research-methods-for-the-behavioral-and-social-sciences',
  'methods',
  'methods-and-applications-in-fluorescence',
  'methods-in-ecology-and-evolution',
  'methods-in-oceanography',
  'methods-of-information-in-medicine',
  'methodsx',
  'metrika',
  'metrologia',
  'micro-and-nano-systems-letters',
  'microarrays',
  'microbes-and-infection',
  'microbial-cell-factories',
  'microbial-drug-resistance',
  'microbial-ecology',
  'microbial-informatics-and-experimentation',
  'microbial-pathogenesis',
  'microbial-risk-analysis',
  'microbiological-research',
  'microbiology',
  'microbiology-australia',
  'microbiology-and-molecular-biology-reviews',
  'microbiome',
  'microchemical-journal',
  'microchimica-acta',
  'microelectronic-engineering',
  'microelectronics-journal',
  'microelectronics-reliability',
  'microfluidics-and-nanofluidics',
  'microgravity-science-and-technology',
  'micromachines',
  'micron',
  'microorganisms',
  'microporous-and-mesoporous-materials',
  'microprocessors-and-microsystems',
  'microscopy-and-microanalysis',
  'microsystem-technologies',
  'microvascular-research',
  'middle-east-critique',
  'midwifery',
  'migration-and-development',
  'milan-journal-of-mathematics',
  'military-medical-research',
  'military-medicine',
  'military-psychology',
  'mind-and-society',
  'mindfulness',
  'minds-and-machines',
  'mine-water-and-the-environment',
  'mineral-economics',
  'mineralium-deposita',
  'mineralogical-magazine',
  'mineralogy-and-petrology',
  'minerals',
  'minerals-engineering',
  'minerva',
  'minerva-medica',
  'mitigation-and-adaptation-strategies-for-global-change',
  'mitochondrion',
  'mobile-dna',
  'mobile-genetic-elements',
  'mobile-networks-and-applications',
  'mobilities',
  'modeling-earth-systems-and-environment',
  'modelling-and-simulation-in-materials-science-and-engineering',
  'modern-humanities-research-association-author-date',
  'modern-humanities-research-association',
  'modern-italy',
  'modern-language-association-6th-edition-note',
  'mla7',
  'modern-language-association-de',
  'modern-language-association-underline',
  'modern-language-association-with-url',
  'mla8',
  'mla9',
  'modern-language-review',
  'modern-pathology',
  'mohr-siebeck-recht',
  'molbank',
  'molecular-and-biochemical-parasitology',
  'molecular-and-cellular-proteomics',
  'molecular-aspects-of-medicine',
  'molecular-autism',
  'molecular-biosystems',
  'molecular-biology-reports',
  'molecular-biology-and-evolution',
  'molecular-biology-of-the-cell',
  'molecular-biotechnology',
  'molecular-brain',
  'molecular-breeding',
  'molecular-cancer',
  'molecular-cancer-research',
  'molecular-cancer-therapeutics',
  'molecular-cell',
  'molecular-cytogenetics',
  'molecular-diagnosis-and-therapy',
  'molecular-diversity',
  'molecular-ecology',
  'molecular-endocrinology',
  'molecular-genetics-and-genomics',
  'molecular-genetics-and-metabolism',
  'molecular-genetics-and-metabolism-reports',
  'molecular-imaging-and-biology',
  'molecular-immunology',
  'molecular-medicine-reports',
  'molecular-metabolism',
  'molecular-microbiology',
  'molecular-neurobiology',
  'molecular-neurodegeneration',
  'molecular-nutrition-and-food-research',
  'molecular-oncology',
  'molecular-pain',
  'molecular-pharmaceutics',
  'molecular-pharmacology',
  'molecular-phylogenetics-and-evolution',
  'molecular-plant',
  'molecular-plant-pathology',
  'molecular-plant-microbe-interactions',
  'molecular-psychiatry',
  'molecular-psychiatry-letters',
  'molecular-simulation',
  'molecular-systems-biology',
  'molecular-therapy',
  'molecular-therapy-nucleic-acids',
  'molecular-vision',
  'molecular-and-cellular-biochemistry',
  'molecular-and-cellular-biology',
  'molecular-and-cellular-endocrinology',
  'molecular-and-cellular-neuroscience',
  'molecular-and-cellular-pediatrics',
  'molecular-and-cellular-probes',
  'molecular-and-cellular-therapies',
  'molecular-and-clinical-oncology',
  'molecules',
  'monash-bioethics-review',
  'monatshefte-fur-chemie-chemical-monthly',
  'monatshefte-fur-mathematik',
  'monatsschrift-kinderheilkunde',
  'monthly-weather-review',
  'moore-theological-college',
  'moorlands-college',
  'morphologie',
  'morphology',
  'mortality',
  'motivation-and-emotion',
  'motricite-cerebrale',
  'mount-sinai-journal-of-medicine',
  'movement-ecology',
  'mucosal-immunology',
  'multibody-system-dynamics',
  'multidimensional-systems-and-signal-processing',
  'multidisciplinary-digital-publishing-institute',
  'multidisciplinary-respiratory-medicine',
  'multilingual-education',
  'multimedia-systems',
  'multimedia-tools-and-applications',
  'multiple-sclerosis-journal',
  'multiple-sclerosis-and-demyelinating-disorders',
  'multiple-sclerosis-and-related-disorders',
  'museum-management-and-curatorship',
  'music-education-research',
  'mutagenesis',
  'mutation-research-fundamental-and-molecular-mechanisms-of-mutagenesis',
  'mutation-research-genetic-toxicology-and-environmental-mutagenesis',
  'mutation-research-reviews-in-mutation-research',
  'mycologia',
  'mycological-progress',
  'mycology',
  'mycopathologia',
  'mycorrhiza',
  'mycotoxin-research',
  'myrmecological-news',
  'manedsskrift-for-almen-praksis',
  'medecine-nucleaire',
  'medecine-palliative-soins-de-support-accompagnement-ethique',
  'medecine-du-sommeil',
  'medecine-et-droit',
  'medecine-et-maladies-infectieuses',
  'melanges-de-l-ecole-francaise-de-rome-antiquite',
  'melanges-de-l-ecole-francaise-de-rome-italie-et-mediterranee-modernes-et-contemporaines',
  'melanges-de-l-ecole-francaise-de-rome-moyen-age',
  'metiers-de-la-petite-enfance',
  'metropolitiques',
  'nccr-mediality',
  'ndt-and-e-international',
  'netnomics-economic-research-and-electronic-networking',
  'nfs-journal',
  'njas-wageningen-journal-of-life-sciences',
  'npg-asia-materials',
  'npg-neurologie-psychiatrie-geriatrie',
  'nriag-journal-of-astronomy-and-geophysics',
  'nano-biomedicine-and-engineering',
  'nano-communication-networks',
  'nano-convergence',
  'nano-energy',
  'nano-letters',
  'nano-today',
  'nano-micro-letters',
  'nano-structures-and-nano-objects',
  'nanoethics',
  'nanomaterials',
  'nanomedicine',
  'nanoscale',
  'nanoscale-research-letters',
  'nanoscience-methods',
  'nanotechnology',
  'nanotechnology-for-environmental-engineering',
  'national-academy-science-letters',
  'national-archives-of-australia',
  'national-identities',
  'national-institute-of-health-research',
  'national-library-of-medicine',
  'national-library-of-medicine-brackets-no-et-al',
  'national-library-of-medicine-grant-proposals',
  'national-medical-journal-of-china',
  'national-science-foundation-grant-proposals',
  'nationalities-papers',
  'natural-computing',
  'natural-gas-industry-b',
  'natural-hazards',
  'natural-hazards-review',
  'natural-hazards-and-earth-system-sciences',
  'natural-hazards-and-earth-system-sciences-discussions',
  'natural-language-and-linguistic-theory',
  'natural-language-semantics',
  'natural-product-reports',
  'natural-product-research',
  'natural-products-and-bioprospecting',
  'natural-resources-research',
  'nature',
  'nature-no-et-al',
  'nature-no-superscript',
  'nature-biotechnology',
  'nature-cell-biology',
  'nature-chemical-biology',
  'nature-chemistry',
  'nature-climate-change',
  'nature-communications',
  'nature-digest',
  'nature-genetics',
  'nature-geoscience',
  'nature-immunology',
  'nature-materials',
  'nature-medicine',
  'nature-methods',
  'nature-nanotechnology',
  'nature-neuroscience',
  'nature-neuroscience-brief-communications',
  'nature-photonics',
  'nature-physics',
  'nature-protocols',
  'nature-publishing-group-vancouver',
  'nature-reviews-cancer',
  'nature-reviews-cardiology',
  'nature-reviews-clinical-oncology',
  'nature-reviews-drug-discovery',
  'nature-reviews-endocrinology',
  'nature-reviews-gastroenterology-and-hepatology',
  'nature-reviews-genetics',
  'nature-reviews-immunology',
  'nature-reviews-microbiology',
  'nature-reviews-molecular-cell-biology',
  'nature-reviews-nephrology',
  'nature-reviews-neurology',
  'nature-reviews-neuroscience',
  'nature-reviews-rheumatology',
  'nature-reviews-urology',
  'nature-structural-and-molecular-biology',
  'natureza-and-conservacao',
  'natureza-e-conservacao',
  'naunyn-schmiedebergs-archives-of-pharmacology',
  'navigation',
  'nehet',
  'nederlands-tijdschrift-voor-geneeskunde',
  'neohelicon',
  'neonatology',
  'neophilologus',
  'neotropical-entomology',
  'nephrologie-et-therapeutique',
  'nephrology',
  'nephrology-dialysis-transplantation',
  'nephron',
  'nephron-clinical-practice',
  'nephron-experimental-nephrology',
  'nephron-extra',
  'nephron-physiology',
  'netherlands-heart-journal',
  'netherlands-international-law-review',
  'network-modeling-analysis-in-health-informatics-and-bioinformatics',
  'networks-and-spatial-economics',
  'neue-juristische-wochenschrift',
  'neumologia-y-cirugia-de-torax',
  'neural-computing-and-applications',
  'neural-development',
  'neural-networks',
  'neural-processing-letters',
  'neuroimage',
  'neuroimage-clinical',
  'neurometals',
  'neuromolecular-medicine',
  'neuroreport',
  'neurobiology-of-aging',
  'neurobiology-of-disease',
  'neurobiology-of-learning-and-memory',
  'neurobiology-of-sleep-and-circadian-rhythms',
  'neurobiology-of-stress',
  'neurocase',
  'neurochemical-research',
  'neurochemistry-international',
  'neurochirurgie',
  'neurocomputing',
  'neurocritical-care',
  'neurodegenerative-disease-management',
  'neurodegenerative-diseases',
  'neuroendocrinology',
  'neuroepidemiology',
  'neuroepigenetics',
  'neuroethics',
  'neuroforum',
  'neuroimaging-clinics-of-north-america',
  'neuroimmunomodulation',
  'neuroinformatics',
  'neurologia-i-neurochirurgia-polska',
  'neurological-sciences',
  'neurology',
  'neurology-india',
  'neurology-and-therapy',
  'neurology-psychiatry-and-brain-research',
  'neurologia',
  'neurologia-argentina',
  'neuromuscular-disorders',
  'neuron',
  'neuropathology',
  'neuropeptides',
  'neuropharmacology',
  'neurophotonics',
  'neurophysiologie-clinique-clinical-neurophysiology',
  'neuropraxis',
  'neuropsychiatric-electrophysiology',
  'neuropsychiatrie-de-lenfance-et-de-ladolescence',
  'neuropsychiatry',
  'neuropsychobiology',
  'neuropsychologia',
  'neuropsychological-rehabilitation',
  'neuropsychology',
  'neuropsychology-review',
  'neuropsychopharmacology',
  'neuroradiology',
  'neurorehabilitation-and-neural-repair',
  'neuroscience',
  'neuroscience-letters',
  'neuroscience-research',
  'neuroscience-and-biobehavioral-reviews',
  'neurosignals',
  'neurosurgery-clinics-of-north-america',
  'neurosurgical-focus',
  'neurosurgical-review',
  'neurotoxicity-research',
  'neurotoxicology',
  'neurotoxicology-and-teratology',
  'neurourology-and-urodynamics',
  'neurovascular-imaging',
  'new-astronomy',
  'new-astronomy-reviews',
  'new-biotechnology',
  'new-forests',
  'new-genetics-and-society',
  'new-harts-rules-the-oxford-style-guide',
  'new-horizons-in-translational-medicine',
  'new-ideas-in-psychology',
  'new-journal-of-chemistry',
  'new-journal-of-physics',
  'new-microbes-and-new-infections',
  'new-negatives-in-plant-science',
  'new-phytologist',
  'new-review-of-film-and-television-studies',
  'new-solutions',
  'new-testament-studies',
  'new-writing',
  'new-zealand-dental-journal',
  'new-zealand-economic-papers',
  'new-zealand-journal-of-educational-studies',
  'new-zealand-journal-of-forestry-science',
  'new-zealand-journal-of-medical-laboratory-science',
  'new-zealand-plant-protection',
  'new-zealand-veterinary-journal',
  'newborn-and-infant-nursing-reviews',
  'nigerian-food-journal',
  'nigerian-journal-of-physiological-sciences',
  'nigerian-journal-of-genetics',
  'nigerian-journal-of-pharmaceutical-sciences',
  'nigerian-medical-journal',
  'nitric-oxide',
  'nonlinear-analysis',
  'nonlinear-analysis-hybrid-systems',
  'nonlinear-analysis-real-world-applications',
  'nonlinear-differential-equations-and-applications-nodea',
  'nonlinear-dynamics',
  'nonlinear-processes-in-geophysics',
  'nonlinear-processes-in-geophysics-discussions',
  'nonlinearity',
  'nordic-journal-of-botany',
  'nordic-journal-of-music-therapy',
  'nordic-psychology',
  'nordic-social-work-research',
  'norma-portuguesa-405',
  'north-american-journal-of-aquaculture',
  'north-american-journal-of-economics-and-finance',
  'north-american-journal-of-fisheries-management',
  'north-carolina-medical-journal',
  'northeastern-naturalist',
  'northern-territory-law-journal-and-reports',
  'notfall-rettungsmedizin',
  'nowa-audiofonologia',
  'nuclear-engineering-and-design',
  'nuclear-engineering-and-technology',
  'nuclear-fusion',
  'nuclear-inst-and-methods-in-physics-research-a',
  'nuclear-inst-and-methods-in-physics-research-b',
  'nuclear-materials-and-energy',
  'nuclear-medicine-and-biology',
  'nuclear-medicine-and-molecular-imaging',
  'nuclear-physics-b',
  'nuclear-physics-section-a',
  'nuclear-physics-section-b',
  'nuclear-and-particle-physics-proceedings',
  'nucleic-acids-research',
  'nucleus',
  'numerical-algorithms',
  'numerische-mathematik',
  'nurse-education-today',
  'nurse-education-in-practice',
  'nurse-leader',
  'nursing-inquiry',
  'nursing-outlook',
  'nursingplus-open',
  'nutrient-cycling-in-agroecosystems',
  'nutrients',
  'nutrition',
  'nutrition-and-metabolism',
  'nutrition-journal',
  'nutrition-research',
  'nutrition-reviews',
  'nutrition-and-diabetes',
  'nutrition-clinique-et-metabolisme',
  'nutrition-metabolism-and-cardiovascular-diseases',
  'owbarth-verlag',
  'opsearch',
  'or-spectrum',
  'orl',
  'oscola',
  'oscola-no-ibid',
  'obere-extremitat',
  'obesity',
  'obesity-facts',
  'obesity-medicine',
  'obesity-research-and-clinical-practice',
  'obesity-surgery',
  'occupation-participation-and-health',
  'occupational-medicine',
  'occupational-and-environmental-medicine',
  'ocean-dynamics',
  'ocean-engineering',
  'ocean-modelling',
  'ocean-science',
  'ocean-science-discussions',
  'ocean-and-coastal-management',
  'oceanologia',
  'ocular-immunology-and-inflammation',
  'ocular-oncology-and-pathology',
  'odontology',
  'oecologia',
  'oikos',
  'omega',
  'oncoimmunology',
  'oncogene',
  'oncogenesis',
  'oncology',
  'oncology-letters',
  'oncology-reports',
  'oncology-research-and-treatment',
  'oncology-and-therapy',
  'onderstepoort-journal-of-veterinary-research',
  'one-health',
  'online-currents',
  'open-biology',
  'open-economies-review',
  'open-geospatial-data-software-and-standards',
  'open-heart',
  'open-learning-the-journal-of-open-distance-and-e-learning',
  'opennano',
  'operational-research',
  'operations-management-research',
  'operations-research-letters',
  'operations-research-perspectives',
  'operations-research-for-health-care',
  'operative-orthopadie-und-traumatologie',
  'ophthalmic-and-physiological-optics',
  'ophthalmic-epidemiology',
  'ophthalmic-genetics',
  'ophthalmic-research',
  'ophthalmic-surgery-lasers-and-imaging-retina',
  'ophthalmologica',
  'ophthalmologica-extra',
  'ophthalmology',
  'ophthalmology-and-therapy',
  'optical-engineering',
  'optical-fiber-technology',
  'optical-materials',
  'optical-nanoscopy',
  'optical-review',
  'optical-switching-and-networking',
  'optical-and-quantum-electronics',
  'optics-communications',
  'optics-and-laser-technology',
  'optics-and-lasers-in-engineering',
  'optik-international-journal-for-light-and-electron-optics',
  'optimization',
  'optimization-letters',
  'optimization-and-engineering',
  'optometry-and-vision-science',
  'oral-diseases',
  'oral-oncology',
  'oral-radiology',
  'oral-surgery-oral-medicine-oral-pathology-and-oral-radiology',
  'oral-and-maxillofacial-surgery',
  'oral-and-maxillofacial-surgery-cases',
  'order',
  'ore-geology-reviews',
  'organic-and-biomolecular-chemistry',
  'organic-agriculture',
  'organic-chemistry-frontiers',
  'organic-electronics',
  'organic-geochemistry',
  'organic-letters',
  'organic-process-research-and-development',
  'organisationsberatung-supervision-coaching',
  'organisms-diversity-and-evolution',
  'organization',
  'organization-science',
  'organization-studies',
  'organizational-behavior-and-human-decision-processes',
  'organogenesis',
  'organometallics',
  'oriental-pharmacy-and-experimental-medicine',
  'origins-of-life-and-evolution-of-biospheres',
  'ornitologia-neotropical',
  'orphanet-journal-of-rare-diseases',
  'ortho-magazine',
  'orthodontic-waves',
  'orthopaedics-and-traumatology-surgery-and-research',
  'orthopedic-clinics-of-north-america',
  'orthopedics',
  'oryx',
  'osteoarthritis-and-cartilage',
  'osteoporosis-international',
  'osteoporosis-and-sarcopenia',
  'otolaryngologia-polska',
  'otolaryngology-head-and-neck-surgery',
  'oxford-the-university-of-new-south-wales',
  'oxford-art-journal',
  'oxford-centre-for-mission-studies-harvard',
  'oxford-german-studies',
  'oxford-review-of-education',
  'oxford-studies-in-ancient-philosophy',
  'oxford-studies-on-the-roman-economy',
  'oxford-university-press-humsoc',
  'oxford-university-press-scimed-author-date',
  'oxford-university-press-scimed-numeric',
  'oxymag',
  'pain',
  'plos-biology',
  'plos-computational-biology',
  'plos-genetics',
  'plos-medicine',
  'plos-neglected-tropical-diseases',
  'plos-one',
  'plos-pathogens',
  'pm-and-r',
  'prospects',
  'proteomics',
  'ps-political-science-and-politics',
  'pacific-journal-of-mathematics-for-industry',
  'pacific-science-review',
  'pacific-science-review-a-natural-science-and-engineering',
  'pacific-science-review-b-humanities-and-social-sciences',
  'pacific-basin-finance-journal',
  'paddy-and-water-environment',
  'paediatric-respiratory-reviews',
  'pain-management',
  'pain-management-nursing',
  'pain-and-therapy',
  'pakistan-journal-of-medical-research',
  'pakistan-journal-of-otolaryngology-head-and-neck-surgery',
  'palaeobiodiversity-and-palaeoenvironments',
  'palaeogeography-palaeoclimatology-palaeoecology',
  'palaeontologia-electronica',
  'palaeontology',
  'palaeoworld',
  'palaios',
  'paleobiology',
  'palynology',
  'palaontologische-zeitschrift',
  'pancreatology',
  'papillomavirus-research',
  'parallel-computing',
  'parasite-epidemiology-and-control',
  'parasites-and-vectors',
  'parasitology',
  'parasitology-international',
  'parasitology-research',
  'parkinsonism-and-related-disorders',
  'particle-and-fibre-toxicology',
  'particuology',
  'past-and-present',
  'pastoral-care-in-education',
  'pastoral-psychology',
  'pastoralism',
  'pathobiology',
  'pathogenesis',
  'pathogens',
  'pathogens-and-disease',
  'pathologie-biologie',
  'pathology',
  'pathology-and-oncology-research',
  'pathology-research-and-practice',
  'pathology-international',
  'pathophysiology',
  'patient-education-and-counseling',
  'patient-safety-in-surgery',
  'pattern-analysis-and-applications',
  'pattern-recognition',
  'pattern-recognition-letters',
  'peace-and-conflict-journal-of-peace-psychology',
  'pedagogies-an-international-journal',
  'pedagogy-culture-and-society',
  'pediatria-polska',
  'pediatric-allergy-and-immunology',
  'pediatric-anesthesia',
  'pediatric-annals',
  'pediatric-blood-and-cancer',
  'pediatric-cardiology',
  'pediatric-critical-care-medicine',
  'pediatric-dental-journal',
  'pediatric-dentistry-case-reports',
  'pediatric-drugs',
  'pediatric-infectious-disease',
  'pediatric-nephrology',
  'pediatric-neurology',
  'pediatric-neurosurgery',
  'pediatric-physical-therapy',
  'pediatric-radiology',
  'pediatric-research',
  'pediatric-rheumatology',
  'pediatric-surgery-international',
  'pediatrics',
  'pediatrics-international',
  'pedobiologia-journal-of-soil-ecology',
  'peer-to-peer-networking-and-applications',
  'peerj',
  'peptides',
  'performance-enhancement-and-health',
  'performance-evaluation',
  'periodica-mathematica-hungarica',
  'periodontology-2000',
  'perioperative-care-and-operating-room-management',
  'perioperative-medicine',
  'permafrost-and-periglacial-processes',
  'person-centered-and-experiential-psychotherapies',
  'personal-and-ubiquitous-computing',
  'personality-disorders-theory-research-and-treatment',
  'personality-and-individual-differences',
  'personalized-medicine',
  'personalized-medicine-universe',
  'perspectives',
  'perspectives-in-medicine',
  'perspectives-in-plant-ecology-evolution-and-systematics',
  'perspectives-in-science',
  'perspectives-on-medical-education',
  'perspectives-on-politics',
  'perspectives-policy-and-practice-in-higher-education',
  'pervasive-and-mobile-computing',
  'pesticide-biochemistry-and-physiology',
  'petit-chicago-author-date',
  'petroleum',
  'petroleum-geoscience',
  'petroleum-science',
  'pflugers-archiv-european-journal-of-physiology',
  'pharmanutrition',
  'pharmaceutical-bioprocessing',
  'pharmaceutical-medicine',
  'pharmaceutical-methods',
  'pharmaceutical-patent-analyst',
  'pharmaceutical-research',
  'pharmaceuticals',
  'pharmaceutics',
  'pharmaceutisch-weekblad',
  'pharmacoeconomics',
  'pharmacoeconomics-italian-research-articles',
  'pharmacoeconomics-spanish-research-articles',
  'pharmacoepidemiology-and-drug-safety',
  'pharmacogenomics',
  'pharmacognosy-journal',
  'pharmacognosy-magazine',
  'pharmacognosy-reviews',
  'pharmacological-reports',
  'pharmacological-research',
  'pharmacological-reviews',
  'pharmacology',
  'pharmacology-and-therapeutics',
  'pharmacology-biochemistry-and-behavior',
  'pharmacotherapy',
  'pharmacy',
  'phase-transitions',
  'phenomenology-and-the-cognitive-sciences',
  'philippika',
  'philippine-political-science-journal',
  'philosophia',
  'philosophia-scientiae',
  'philosophical-explorations',
  'philosophical-psychology',
  'philosophical-studies',
  'philosophical-transactions-of-the-royal-society-a',
  'philosophical-transactions-of-the-royal-society-b',
  'philosophiques',
  'philosophy-and-technology',
  'philosophy-of-management',
  'philosophy-ethics-and-humanities-in-medicine',
  'photoacoustics',
  'photochemical-and-photobiological-sciences',
  'photodiagnosis-and-photodynamic-therapy',
  'photonic-network-communications',
  'photonics',
  'photonics-and-nanostructures-fundamentals-and-applications',
  'photosynthesis-research',
  'phycological-research',
  'phyllomedusa',
  'physica-a-statistical-mechanics-and-its-applications',
  'physica-b-physics-of-condensed-matter',
  'physica-c-superconductivity-and-its-applications',
  'physica-d-nonlinear-phenomena',
  'physica-e-low-dimensional-systems-and-nanostructures',
  'physica-medica',
  'physica-scripta',
  'physical-biology',
  'physical-chemistry-chemical-physics',
  'physical-communication',
  'physical-education-and-sport-pedagogy',
  'physical-review-a',
  'physical-review-b',
  'physical-review-c',
  'physical-review-d',
  'physical-review-e',
  'physical-review-letters',
  'physical-therapy-in-sport',
  'physics-education',
  'physics-letters-a',
  'physics-letters-b',
  'physics-reports',
  'physics-and-chemistry-of-liquids',
  'physics-and-chemistry-of-minerals',
  'physics-and-chemistry-of-the-earth',
  'physics-in-medicine',
  'physics-in-medicine-and-biology',
  'physics-of-fluids',
  'physics-of-life-reviews',
  'physics-of-plasmas',
  'physics-of-the-dark-universe',
  'physics-of-the-earth-and-planetary-interiors',
  'physics-uspekhi',
  'physiological-genomics',
  'physiological-measurement',
  'physiological-reviews',
  'physiological-and-biochemical-zoology',
  'physiological-and-molecular-plant-pathology',
  'physiology',
  'physiology-and-behavior',
  'physiology-and-molecular-biology-of-plants',
  'physiotherapy',
  'phytochemistry',
  'phytochemistry-letters',
  'phytochemistry-reviews',
  'phytomedicine',
  'phytoparasitica',
  'phytopathology',
  'pilot-and-feasibility-studies',
  'pisa-university-press',
  'pituitary',
  'placenta',
  'planetary-science',
  'planetary-and-space-science',
  'planning-perspectives',
  'planning-theory-and-practice',
  'plant-biology',
  'plant-biotechnology-reports',
  'plant-cell-reports',
  'plant-cell-tissue-and-organ-culture',
  'plant-disease',
  'plant-ecology',
  'plant-foods-for-human-nutrition',
  'plant-gene',
  'plant-growth-regulation',
  'plant-methods',
  'plant-molecular-biology',
  'plant-molecular-biology-reporter',
  'plant-pathology',
  'plant-physiology',
  'plant-physiology-and-biochemistry',
  'plant-reproduction',
  'plant-science',
  'plant-signaling-and-behavior',
  'plant-systematics-and-evolution',
  'plant-and-soil',
  'planta',
  'plants',
  'plasma-chemistry-and-plasma-processing',
  'plasma-physics-and-controlled-fusion',
  'plasma-science-and-technology',
  'plasma-sources-science-and-technology',
  'plasmid',
  'plasmonics',
  'podosophia',
  'podzemna-voda',
  'poetics',
  'polar-biology',
  'polar-science',
  'police-practice-and-research',
  'policy-sciences',
  'policy-studies',
  'policy-and-society',
  'polish-annals-of-medicine',
  'polish-journal-of-applied-psychology',
  'polish-legal',
  'political-behavior',
  'political-geography',
  'political-studies',
  'politics-groups-and-identities',
  'politikon',
  'politische-vierteljahresschrift',
  'polski-przeglad-otorynolaryngologiczny',
  'polyhedron',
  'polymer',
  'polymer-bulletin',
  'polymer-chemistry',
  'polymer-degradation-and-stability',
  'polymer-journal',
  'polymer-reviews',
  'polymer-testing',
  'polymers',
  'pontifical-athenaeum-regina-apostolorum',
  'pontifical-biblical-institute',
  'pontifical-gregorian-university',
  'population-en',
  'population',
  'population-ecology',
  'population-health-metrics',
  'population-research-and-policy-review',
  'population-and-environment',
  'population-space-and-place',
  'porcine-health-management',
  'portuguese-economic-journal',
  'portuguese-studies',
  'positivity',
  'post-soviet-affairs',
  'postgraduate-medical-journal',
  'postgraduate-medicine',
  'postharvest-biology-and-technology',
  'postepy-psychiatrii-i-neurologii',
  'potato-research',
  'potential-analysis',
  'poultry-science',
  'pour-reussir-note',
  'powder-technology',
  'practical-laboratory-medicine',
  'practical-neurology',
  'practical-radiation-oncology',
  'practice',
  'practice-periodical-on-structural-design-and-construction',
  'pratique-neurologique-fmc',
  'pratique-medicale-et-chirurgicale-de-lanimal-de-compagnie',
  'pratiques-en-nutrition',
  'pratiques-psychologiques',
  'precambrian-research',
  'precision-agriculture',
  'precision-engineering',
  'pregnancy-hypertension-an-international-journal-of-womens-cardiovascular-health',
  'preslia',
  'presses-universitaires-de-rennes',
  'prevention-science',
  'preventive-medicine',
  'preventive-veterinary-medicine',
  'primary-care-diabetes',
  'primary-care-clinics-in-office-practice',
  'primate-biology',
  'primates',
  'prion',
  'proinflow',
  'probabilistic-engineering-mechanics',
  'probability-theory-and-related-fields',
  'probiotics-and-antimicrobial-proteins',
  'procedia-early-career-research',
  'procedia-economics-and-finance',
  'procedia-manufacturing',
  'procedia-materials-science',
  'proceedings-of-the-geologists-association',
  'proceedings-of-the-ieee',
  'pnas',
  'proceedings-of-the-national-academy-of-sciences-india-section-a-physical-sciences',
  'proceedings-of-the-national-academy-of-sciences-india-section-b-biological-sciences',
  'proceedings-of-the-royal-society-a',
  'proceedings-of-the-royal-society-b',
  'proceedings-of-the-yorkshire-geological-society',
  'proceedings-of-the-zoological-society',
  'process-biochemistry',
  'process-safety-and-environmental-protection',
  'processes',
  'production-and-manufacturing-research',
  'production-engineering',
  'production-planning-and-control',
  'professional-psychology-research-and-practice',
  'programme-grants-for-applied-research',
  'progress-in-additive-manufacturing',
  'progress-in-aerospace-sciences',
  'progress-in-artificial-intelligence',
  'progress-in-biomaterials',
  'progress-in-biophysics-and-molecular-biology',
  'progress-in-cardiovascular-diseases',
  'progress-in-crystal-growth-and-characterization-of-materials',
  'progress-in-earth-and-planetary-science',
  'progress-in-energy-and-combustion-science',
  'progress-in-histochemistry-and-cytochemistry',
  'progress-in-lipid-research',
  'progress-in-materials-science',
  'progress-in-natural-science-materials-international',
  'progress-in-neurobiology',
  'progress-in-neuropsychopharmacology-and-biological-psychiatry',
  'progress-in-nuclear-energy',
  'progress-in-nuclear-magnetic-resonance-spectroscopy',
  'progress-in-oceanography',
  'progress-in-organic-coatings',
  'progress-in-orthodontics',
  'progress-in-particle-and-nuclear-physics',
  'progress-in-pediatric-cardiology',
  'progress-in-planning',
  'progress-in-polymer-science',
  'progress-in-quantum-electronics',
  'progress-in-retinal-and-eye-research',
  'progress-in-solid-state-chemistry',
  'progress-in-surface-science',
  'progres-en-urologie',
  'progres-en-urologie-fmc',
  'property-law-review',
  'propulsion-and-power-research',
  'prostaglandins-and-other-lipid-mediators',
  'prostaglandins-leukotrienes-and-essential-fatty-acids',
  'prostate-cancer-and-prostatic-diseases',
  'prostate-international',
  'protein-and-cell',
  'protein-engineering-design-and-selection',
  'protein-expression-and-purification',
  'protein-science',
  'proteome-science',
  'proteomes',
  'protoplasma',
  'pravention-und-gesundheitsforderung',
  'psicologia-educativa',
  'psychiatric-annals',
  'psychiatric-clinics-of-north-america',
  'psychiatric-rehabilitation-journal',
  'psychiatric-services',
  'psychiatry-research',
  'psychiatry-research-neuroimaging',
  'psychiatry-and-clinical-neurosciences',
  'psychoanalytic-psychology',
  'psychoanalytic-psychotherapy',
  'psychodynamic-practice',
  'psychological-assessment',
  'psychological-bulletin',
  'psychological-injury-and-law',
  'psychological-medicine',
  'psychological-methods',
  'psychological-research',
  'psychological-review',
  'psychological-services',
  'psychological-studies',
  'psychological-trauma-theory-research-practice-and-policy',
  'psychologie-francaise',
  'psychology-and-health',
  'psychology-and-sexuality',
  'psychology-and-aging',
  'psychology-and-psychotherapy-theory-research-and-practice',
  'psychology-of-addictive-behaviors',
  'psychology-of-aesthetics-creativity-and-the-arts',
  'psychology-of-consciousness-theory-research-and-practice',
  'psychology-of-men-and-masculinity',
  'psychology-of-popular-media-culture',
  'psychology-of-religion-and-spirituality',
  'psychology-of-sexual-orientation-and-gender-diversity',
  'psychology-of-sport-and-exercise',
  'psychology-of-violence',
  'psychology-of-well-being',
  'psychology-crime-and-law',
  'psychology-health-and-medicine',
  'psychology-public-policy-and-law',
  'psychometrika',
  'psychomusicology-music-mind-and-brain',
  'psychoneuroendocrinology',
  'psychopathology',
  'psychopharmacology',
  'psychosis',
  'psychosocial-intervention',
  'psychosomatics',
  'psychotherapeut',
  'psychotherapie-forum',
  'psychotherapy',
  'psychotherapy-research',
  'psychotherapy-and-psychosomatics',
  'public-choice',
  'public-health',
  'public-health-forum',
  'public-health-genomics',
  'public-health-nutrition',
  'public-health-research',
  'public-health-reviews',
  'public-law-review',
  'plos',
  'public-organization-review',
  'public-relations-review',
  'public-transport',
  'publications',
  'publishing-research-quarterly',
  'publizistik',
  'puerto-rico-health-sciences-journal',
  'pulmonary-pharmacology-and-therapeutics',
  'pulmonary-therapy',
  'pulse',
  'purinergic-signalling',
  'padagogische-hochschule-fachhochschule-nordwestschweiz',
  'padagogische-hochschule-heidelberg',
  'padagogische-hochschule-vorarlberg',
  'padiatrie-und-padologie',
  'qjm',
  'quaderni-italiani-di-psichiatria',
  'quaderni-degli-avogadro-colloquia',
  'qualitative-psychology',
  'qualitative-sociology',
  'qualitative-theory-of-dynamical-systems',
  'quality-and-quantity',
  'quality-of-life-research',
  'quantitative-marketing-and-economics',
  'quantum-electronics',
  'quantum-information-processing',
  'quantum-studies-mathematics-and-foundations',
  'quarterly-journal-of-engineering-geology-and-hydrogeology',
  'quarterly-journal-of-speech',
  'quarterly-review-of-economics-and-finance',
  'quaternary-geochronology',
  'quaternary-international',
  'quaternary-research',
  'quaternary-science-reviews',
  'queen-margaret-university-harvard',
  'queueing-systems',
  'reach-reviews-in-human-space-exploration',
  'rna',
  'rna-biology',
  'robomech-journal',
  'rose-school',
  'rsc-advances',
  'rtf-scan',
  'race-ethnicity-and-education',
  'race-and-social-problems',
  'radiation-measurements',
  'radiation-oncology',
  'radiation-physics-and-chemistry',
  'radiation-and-environmental-biophysics',
  'radiographics',
  'radiography',
  'radiologic-clinics-of-north-america',
  'radiological-physics-and-technology',
  'radiology',
  'radiology-case-reports',
  'radiology-of-infectious-diseases',
  'radiologia',
  'radiopaedia',
  'radiotherapy-and-oncology',
  'rangeland-ecology-and-management',
  'rapid-communications-in-mass-spectrometry',
  'rare-diseases',
  'rare-metals',
  'ravensbourne-harvard',
  'reaction-kinetics-mechanisms-and-catalysis',
  'reactive-and-functional-polymers',
  'reading-and-writing',
  'real-time-systems',
  'rechtsmedizin',
  'redox-biology',
  'reflective-practice',
  'regenerative-engineering-and-translational-medicine',
  'regenerative-medicine',
  'regenerative-medicine-research',
  'regenerative-therapy',
  'regional-environmental-change',
  'regional-science-and-urban-economics',
  'regional-studies-in-marine-science',
  'regulatory-peptides',
  'regulatory-toxicology-and-pharmacology',
  'rehabilitation-psychology',
  'reinforced-plastics',
  'reliability-engineering-and-system-safety',
  'religions',
  'remote-sensing',
  'remote-sensing-applications-society-and-environment',
  'remote-sensing-of-environment',
  'renal-replacement-therapy',
  'rendiconti-lincei',
  'rendiconti-del-circolo-matematico-di-palermo',
  'renewable-energy',
  'renewable-energy-focus',
  'renewable-and-sustainable-energy-reviews',
  'renewables-wind-water-and-solar',
  'reports-of-practical-oncology-and-radiotherapy',
  'reports-on-progress-in-physics',
  'reproduction',
  'reproductive-biomedicine-online',
  'reproductive-biology',
  'reproductive-biology-and-endocrinology',
  'reproductive-biomedicine-and-society-online',
  'reproductive-health',
  'reproductive-medicine-and-biology',
  'reproductive-toxicology',
  'requirements-engineering',
  'res-publica',
  'research-evaluation',
  'research-integrity-and-peer-review',
  'research-involvement-and-engagement',
  'research-papers-in-education',
  'research-policy',
  'research-and-practice-in-technology-enhanced-learning',
  'research-in-accounting-regulation',
  'research-in-astronomy-and-astrophysics',
  'research-in-autism-spectrum-disorders',
  'research-in-dance-education',
  'research-in-developmental-disabilities',
  'research-in-drama-education-the-journal-of-applied-theatre-and-performance',
  'research-in-economics',
  'research-in-engineering-design',
  'research-in-gerontological-nursing',
  'research-in-higher-education',
  'research-in-international-business-and-finance',
  'research-in-mathematics-education',
  'research-in-microbiology',
  'research-in-number-theory',
  'research-in-organizational-behavior',
  'research-in-post-compulsory-education',
  'research-in-science-and-technological-education',
  'research-in-science-education',
  'research-in-social-stratification-and-mobility',
  'research-in-social-and-administrative-pharmacy',
  'research-in-transportation-business-and-management',
  'research-in-transportation-economics',
  'research-in-veterinary-science',
  'research-in-the-mathematical-sciences',
  'research-on-chemical-intermediates',
  'resource-and-energy-economics',
  'resource-efficient-technologies',
  'resources',
  'resources-policy',
  'resources-conservation-and-recycling',
  'respiration',
  'respiratory-medicine',
  'respiratory-medicine-case-reports',
  'respiratory-physiology-and-neurobiology',
  'respiratory-research',
  'results-in-immunology',
  'results-in-mathematics',
  'results-in-pharma-sciences',
  'results-in-physics',
  'resuscitation',
  'rethinking-history',
  'retina',
  'retrovirology',
  'reumatologia-clinica',
  'review-journal-of-autism-and-developmental-disorders',
  'review-of-accounting-studies',
  'review-of-african-political-economy',
  'review-of-communication',
  'review-of-derivatives-research',
  'review-of-development-finance',
  'review-of-economic-design',
  'review-of-economic-dynamics',
  'review-of-economics-of-the-household',
  'review-of-educational-research',
  'review-of-financial-economics',
  'review-of-general-psychology',
  'review-of-industrial-organization',
  'review-of-managerial-science',
  'review-of-palaeobotany-and-palynology',
  'review-of-philosophy-and-psychology',
  'review-of-quantitative-finance-and-accounting',
  'review-of-regional-research',
  'review-of-religious-research',
  'review-of-research-in-education',
  'review-of-scientific-instruments',
  'review-of-world-economics',
  'reviews-in-endocrine-and-metabolic-disorders',
  'reviews-in-environmental-science-and-bio-technology',
  'reviews-in-fish-biology-and-fisheries',
  'reviews-in-physics',
  'reviews-in-vascular-medicine',
  'reviews-of-modern-physics-with-titles',
  'revista-argentina-de-antropologia-biologica',
  'revista-argentina-de-cirugia',
  'revista-brasileira-de-ciencia-do-solo',
  'revista-brasileira-de-ciencias-do-esporte',
  'revista-brasileira-de-entomologia',
  'revista-brasileira-de-farmacognosia',
  'revista-brasileira-de-reumatologia',
  'revista-chilena-de-historia-natural',
  'revista-chilena-de-pediatria',
  'revista-ciencias-tecnicas-agropecuarias',
  'revista-clinica-espanola',
  'revista-cubana-de-alimentacion-y-nutiricion',
  'revista-cubana-de-cirugia',
  'revista-cubana-de-endocrinologia',
  'revista-cubana-de-enfermeria',
  'revista-cubana-de-estomatologia',
  'revista-cubana-de-farmacia',
  'revista-cubana-de-hematologia-immunologia-y-hemoterapia',
  'revista-cubana-de-higiene-y-epidemiologia',
  'revista-cubana-de-investigaciones-biomedicas',
  'revista-cubana-de-medicina',
  'revista-cubana-de-medicina-general-integral',
  'revista-cubana-de-medicina-militar',
  'revista-cubana-de-medicina-tropical',
  'revista-cubana-de-obstetricia-y-ginecologia',
  'revista-cubana-de-oftalmologia',
  'revista-cubana-de-ortopedia-y-traumatologia',
  'revista-cubana-de-pediatria',
  'revista-cubana-de-salud-publica',
  'revista-cuicuilco',
  'revista-espanola-de-investigacion-en-marketing-esic',
  'revista-espanola-de-anestesiologia-y-reanimacion',
  'revista-espanola-de-salud-publica',
  'revista-europea-de-direccion-y-economia-de-la-empresa',
  'revista-fave-seccion-ciencias-agrarias',
  'revista-iberoamericana-de-psicologia-y-salud',
  'revista-internacional-de-metodos-numericos-para-calculo-y-diseno-en-ingenieria',
  'revista-latinoamericana-de-psicologia',
  'revista-matematica-complutense',
  'revista-mexicana-de-biodiversidad',
  'revista-mexicana-de-trastornos-alimentarios',
  'revista-medica-clinica-las-condes',
  'revista-medica-de-chile',
  'revista-medica-del-instituto-mexicano-del-seguro-social',
  'revista-panamericana-de-salud-publica',
  'revista-portuguesa-de-cardiologia',
  'revista-virtual-de-quimica',
  'revista-de-biologia-tropical',
  'revista-de-contabilidad',
  'revista-de-filologia-espanola',
  'revista-de-gastroenterologia-de-mexico',
  'revista-de-logopedia-foniatria-y-audiologia',
  'revista-de-psicologia-del-trabajo-y-de-las-organizaciones',
  'revista-de-la-real-academia-de-ciencias-exactas-fisicas-y-naturales-serie-a-matematicas',
  'revista-de-la-educacion-superior',
  'revista-del-laboratorio-clinico',
  'revue-archeologique',
  'revue-francophone-dorthoptie',
  'revue-francaise-dallergologie',
  'revue-neurologique',
  'revue-archeologique-du-centre-de-la-france',
  'revue-depidemiologie-et-de-sante-publique',
  'revue-doncologie-hematologie-pediatrique',
  'revue-dhistoire-moderne-et-contemporaine',
  'revue-de-chirurgie-orthopedique-et-traumatologique',
  'revue-de-medecine-veterinaire',
  'revue-de-pneumologie-clinique',
  'revue-de-stomatologie-de-chirurgie-maxillo-faciale-et-de-chirurgie-orale',
  'revue-de-micropaleontologie',
  'revue-des-maladies-respiratoires',
  'revue-des-nouvelles-technologies-de-l-information',
  'revue-du-rhumatisme-monographies',
  'revue-du-podologue',
  'revue-du-rhumatisme',
  'revue-europeenne-de-psychologie-appliquee',
  'revue-francophone-internationale-de-recherche-infirmiere',
  'revue-francaise-de-sociologie-en',
  'revue-francaise-de-sociologie',
  'revue-veterinaire-clinique',
  'rheologica-acta',
  'rheumatology',
  'rheumatology-international',
  'rheumatology-and-therapy',
  'rhodora',
  'rice',
  'ricerche-di-matematica',
  'risk-analysis',
  'risks',
  'road-materials-and-pavement-design',
  'harvard-robert-gordon-university',
  'robotics',
  'robotics-and-autonomous-systems',
  'robotics-and-biomimetics',
  'robotics-and-computer-integrated-manufacturing',
  'rock-mechanics-and-rock-engineering',
  'romanian-humanities',
  'rorschachiana',
  'royal-society-of-chemistry',
  'russian-chemical-reviews',
  'gost-r-7-0-5-2008',
  'gost-r-7-0-5-2008-numeric',
  'gost-r-7-0-5-2008-numeric-alphabetical',
  'russian-geology-and-geophysics',
  'russian-journal-of-communication',
  'russian-linguistics',
  'russian-mathematical-surveys',
  'rofo',
  'sage-harvard',
  'sage-vancouver',
  'sage-vancouver-brackets',
  'series',
  'sist02',
  'soil',
  'soil-discussions',
  'spie-bios',
  'spie-proceedings',
  'spie-journals',
  'spip-cite',
  'ssm-population-health',
  'safety-science',
  'safety-and-health-at-work',
  'safety-in-health',
  'salud-colectiva',
  'salud-publica-de-mexico',
  'samples',
  'sanidad-militar',
  'foerster-geisteswissenschaft',
  'saudi-journal-of-biological-sciences',
  'saudi-pharmaceutical-journal',
  'sbornik-mathematics',
  'scandinavian-journal-of-disability-research',
  'scandinavian-journal-of-educational-research',
  'scandinavian-journal-of-forest-research',
  'scandinavian-journal-of-hospitality-and-tourism',
  'scandinavian-journal-of-infectious-diseases',
  'scandinavian-journal-of-management',
  'scandinavian-journal-of-pain',
  'scandinavian-journal-of-public-health',
  'scandinavian-journal-of-trauma-resuscitation-and-emergency-medicine',
  'scandinavian-journal-of-work-environment-and-health',
  'scandinavian-political-studies',
  'schizophrenia-research',
  'schizophrenia-research-cognition',
  'school-effectiveness-and-school-improvement',
  'school-leadership-and-management',
  'school-mental-health',
  'school-psychology-quarterly',
  'schweizerische-zeitschrift-fur-ganzheitsmedizin',
  'science',
  'science-and-education',
  'science-and-justice',
  'science-without-titles',
  'science-bulletin',
  'science-foundation-in-china',
  'science-translational-medicine',
  'science-and-engineering-ethics',
  'science-and-technology-of-advanced-materials',
  'science-et-sports',
  'science-of-computer-programming',
  'science-of-the-total-environment',
  'scientia-agriculturae-bohemica',
  'scientia-horticulturae',
  'scientific-drilling',
  'scientific-phone-apps-and-mobile-devices',
  'scientific-reports',
  'scientometrics',
  'scoliosis',
  'scottish-journal-of-geology',
  'scrinium',
  'scripta-materialia',
  'securitas-vialis',
  'security-informatics',
  'sedimentary-geology',
  'seizure-european-journal-of-epilepsy',
  'selecta-mathematica',
  'self-and-identity',
  'selcuk-tip-dergisi',
  'semiconductor-science-and-technology',
  'semigroup-forum',
  'seminars-in-arthritis-and-rheumatism',
  'seminars-in-arthroplasty',
  'seminars-in-cancer-biology',
  'seminars-in-cell-and-developmental-biology',
  'seminars-in-colon-and-rectal-surgery',
  'seminars-in-diagnostic-pathology',
  'seminars-in-fetal-and-neonatal-medicine',
  'seminars-in-immunology',
  'seminars-in-immunopathology',
  'seminars-in-orthodontics',
  'seminars-in-pediatric-neurology',
  'seminars-in-pediatric-surgery',
  'seminars-in-perinatology',
  'seminars-in-spine-surgery',
  'seminars-in-vascular-surgery',
  'sensing-and-bio-sensing-research',
  'sensing-and-imaging',
  'sensors',
  'sensors-and-actuators-a-physical',
  'sensors-and-actuators-b-chemical',
  'separation-and-purification-technology',
  'serials-review',
  'service-business',
  'service-oriented-computing-and-applications',
  'set-valued-and-variational-analysis',
  'sex-education',
  'sex-roles',
  'sexologies',
  'sexual-and-reproductive-healthcare',
  'sexual-development',
  'sexual-medicine-reviews',
  'sexual-and-relationship-therapy',
  'sexuality-and-culture',
  'sexuality-research-and-social-policy',
  'sexuality-and-disability',
  'sexuality-and-early-development-in-aquatic-organisms',
  'sexually-transmitted-diseases',
  'sexually-transmitted-infections',
  'shakespeare',
  'shape-memory-and-superelasticity',
  'sheffield-hallam-university-history',
  'ships-and-offshore-structures',
  'shock-waves',
  'signal-processing',
  'signal-processing-image-communication',
  'signal-image-and-video-processing',
  'silicon',
  'simulation-modelling-practice-and-theory',
  'singapore-dental-journal',
  'skeletal-muscle',
  'skeletal-radiology',
  'skin-pharmacology-and-physiology',
  'slavonic-and-east-european-review',
  'sleep-health-journal-of-the-national-sleep-foundation',
  'sleep-medicine',
  'sleep-medicine-reviews',
  'sleep-science',
  'sleep-and-biological-rhythms',
  'sleep-and-breathing',
  'small',
  'small-business-economics',
  'small-gtpases',
  'small-ruminant-research',
  'small-wars-and-insurgencies',
  'small-scale-forestry',
  'smart-learning-environments',
  'smart-materials-and-structures',
  'smart-water',
  'soccer-and-society',
  'social-choice-and-welfare',
  'social-dynamics',
  'social-identities',
  'social-indicators-research',
  'social-influence',
  'social-justice-research',
  'social-movement-studies',
  'social-network-analysis-and-mining',
  'social-networks',
  'social-neuroscience',
  'social-psychiatry-and-psychiatric-epidemiology',
  'social-psychology',
  'social-psychology-quarterly',
  'social-psychology-of-education',
  'social-science-and-medicine',
  'social-science-research',
  'social-sciences',
  'social-semiotics',
  'social-studies-of-science',
  'social-work-education',
  'social-and-environmental-accountability-journal',
  'sociedade-brasileira-de-computacao',
  'societies',
  'society-and-mental-health',
  'society-for-american-archaeology',
  'society-for-general-microbiology',
  'society-for-historical-archaeology',
  'society-for-laboratory-automation-and-screening',
  'society-of-automotive-engineers-technical-papers-numeric',
  'society-of-biblical-literature-fullnote-bibliography',
  'socio-economic-planning-sciences',
  'socio-economic-review',
  'sociological-methodology',
  'sociological-theory',
  'sociologie-du-travail',
  'sociology',
  'sociology-of-education',
  'sociology-of-health-and-illness',
  'societe-nationale-des-groupements-techniques-veterinaires',
  'soft-computing',
  'soft-matter',
  'software-and-systems-modeling',
  'software-quality-journal',
  'softwarex',
  'soil-and-tillage-research',
  'soil-biology-and-biochemistry',
  'soil-dynamics-and-earthquake-engineering',
  'soil-research',
  'soil-science-society-of-america-journal',
  'soil-science-and-plant-nutrition',
  'soils-and-foundations',
  'soins',
  'soins-aides-soignantes',
  'soins-cadres',
  'soins-gerontologie',
  'soins-psychiatrie',
  'soins-pediatrie-puericulture',
  'solar-energy',
  'solar-energy-materials-and-solar-cells',
  'solid-earth',
  'solid-earth-discussions',
  'solid-earth-sciences',
  'solid-state-communications',
  'solid-state-electronics',
  'solid-state-ionics',
  'solid-state-nuclear-magnetic-resonance',
  'solid-state-sciences',
  'solutions',
  'somnologie-schlafforschung-und-schlafmedizin',
  'sophia',
  'source-code-for-biology-and-medicine',
  'south-african-geographical-journal',
  'south-african-journal-of-botany',
  'south-african-medical-journal',
  'south-asian-diaspora',
  'south-asian-history-and-culture',
  'southern-cross-university-harvard',
  'soziale-passagen',
  'soziale-probleme',
  'soziale-welt',
  'sozialpadagogisches-institut-berlin-walter-may',
  'sozialwissenschaften-heilmann',
  'soziologie',
  'space-policy',
  'space-science-reviews',
  'spandidos-publications',
  'spanish-legal',
  'spatial-demography',
  'spatial-statistics',
  'spatial-and-spatio-temporal-epidemiology',
  'special-care-in-dentistry',
  'spectrochimica-acta-part-a-molecular-and-biomolecular-spectroscopy',
  'spectrochimica-acta-part-b-atomic-spectroscopy',
  'spectroscopy-letters',
  'speech-communication',
  'spektrum-der-augenheilkunde',
  'spermatogenesis',
  'spinal-cord',
  'spine-deformity',
  'spirituality-in-clinical-practice',
  'sport-management-review',
  'sport-sciences-for-health',
  'sport-education-and-society',
  'sport-exercise-and-performance-psychology',
  'sports',
  'sports-biomechanics',
  'sports-coaching-review',
  'sports-engineering',
  'sports-medicine',
  'sports-medicine-open',
  'sports-technology',
  'sportwissenschaft',
  'springer-basic-author-date',
  'springer-basic-author-date-no-et-al',
  'springer-basic-brackets',
  'springer-basic-brackets-no-et-al',
  'springer-basic-brackets-no-et-al-alphabetical',
  'springer-fachzeitschriften-medizin-psychologie',
  'springer-humanities-author-date',
  'springer-humanities-brackets',
  'springer-lecture-notes-in-computer-science',
  'springer-lecture-notes-in-computer-science-alphabetical',
  'springer-mathphys-author-date',
  'springer-mathphys-brackets',
  'springer-physics-author-date',
  'springer-physics-brackets',
  'springer-science-reviews',
  'springer-socpsych-author-date',
  'springer-socpsych-brackets',
  'springer-vancouver',
  'springer-vancouver-author-date',
  'springer-vancouver-brackets',
  'springerplus',
  'springerprotocols',
  'st-patricks-college',
  'st-petersburg-polytechnical-university-journal-physics-and-mathematics',
  'standards-in-genomic-sciences',
  'standort',
  'statistical-inference-for-stochastic-processes',
  'statistical-methods-and-applications',
  'statistical-papers',
  'statistics',
  'statistics-and-computing',
  'statistics-and-probability-letters',
  'statistics-in-biosciences',
  'stavebni-obzor',
  'stem-cell-reports',
  'stem-cell-research',
  'stem-cell-research-and-therapy',
  'stem-cell-reviews-and-reports',
  'stem-cells',
  'stem-cells-and-development',
  'stephan-mueller-special-publication-series',
  'stereotactic-and-functional-neurosurgery',
  'steroids',
  'stochastic-environmental-research-and-risk-assessment',
  'stochastic-partial-differential-equations-analysis-and-computations',
  'stomatologie',
  'stomatoloski-vjesnik',
  'strahlentherapie-und-onkologie',
  'strategic-management-journal',
  'strategies-in-trauma-and-limb-reconstruction',
  'stroke',
  'structural-change-and-economic-dynamics',
  'structural-chemistry',
  'structural-control-and-health-monitoring',
  'structural-safety',
  'structural-and-multidisciplinary-optimization',
  'structure',
  'structures',
  'student-bmj',
  'studia-bas',
  'studia-theologica-nordic-journal-of-theology',
  'studies-in-communication-sciences',
  'studies-in-comparative-international-development',
  'studies-in-continuing-education',
  'studies-in-east-european-thought',
  'studies-in-educational-evaluation',
  'studies-in-history-and-philosophy-of-biol-and-biomed-sci',
  'studies-in-history-and-philosophy-of-modern-physics',
  'studies-in-history-and-philosophy-of-science',
  'studies-in-philosophy-and-education',
  'studies-in-science-education',
  'studii-teologice',
  'studying-teacher-education',
  'style-manual-australian-government',
  'substance-abuse-treatment-prevention-and-policy',
  'sugar-tech',
  'suma-psicologica',
  'suma-de-negocios',
  'sunway-college-johor-bahru',
  'suomen-laakarilehti',
  'superconductor-science-and-technology',
  'superlattices-and-microstructures',
  'supportive-care-in-cancer',
  'surface-and-coatings-technology',
  'surface-science',
  'surface-science-reports',
  'surface-topography-metrology-and-properties',
  'surgery',
  'surgery-today',
  'surgery-for-obesity-and-related-diseases',
  'surgical-case-reports',
  'surgical-clinics-of-north-america',
  'surgical-endoscopy',
  'surgical-neurology-international',
  'surgical-oncology',
  'surgical-pathology-clinics',
  'surgical-and-radiologic-anatomy',
  'survey-of-ophthalmology',
  'surveys-in-geophysics',
  'surveys-in-operations-research-and-management-science',
  'sustainability',
  'sustainability-science',
  'sustainability-of-water-quality-and-ecology',
  'sustainable-chemical-processes',
  'sustainable-chemistry-and-pharmacy',
  'sustainable-cities-and-society',
  'sustainable-computing-informatics-and-systems',
  'sustainable-energy-technologies-and-assessments',
  'sustainable-energy-grids-and-networks',
  'sustainable-materials-and-technologies',
  'sustainable-production-and-consumption',
  'sustainable-water-resources-management',
  'svensk-exegetisk-arsbok',
  'swarm-intelligence',
  'swarm-and-evolutionary-computation',
  'swedish-legal',
  'swiss-journal-of-geosciences',
  'swiss-journal-of-palaeontology',
  'swiss-journal-of-psychology',
  'swiss-medical-weekly',
  'symbiosis',
  'symmetry',
  'synergy',
  'synthese',
  'synthetic-metals',
  'synthetic-and-systems-biotechnology',
  'system',
  'systematic-biology',
  'systematic-parasitology',
  'systematic-reviews',
  'systematic-and-applied-microbiology',
  'systemic-practice-and-action-research',
  'systems',
  'systems-and-control-letters',
  'systems-biomedicine',
  'systems-science-and-control-engineering-an-open-access-journal',
  'systems-and-synthetic-biology',
  'sao-paulo-journal-of-mathematical-sciences',
  'seminaire-saint-sulpice-ecole-theologie',
  'test',
  'tgm-wien-diplom',
  'top',
  'taiwan-journal-of-ophthalmology',
  'taiwanese-journal-of-obstetrics-and-gynecology',
  'talanta',
  'tandlaegebladet',
  'tanta-dental-journal',
  'targeted-oncology',
  'taylor-and-francis-american-psychological-association',
  'taylor-and-francis-chicago-f',
  'taylor-and-francis-chicago-author-date',
  'taylor-and-francis-chicago-note',
  'taylor-and-francis-council-of-science-editors-author-date',
  'taylor-and-francis-harvard-v',
  'taylor-and-francis-harvard-x',
  'taylor-and-francis-national-library-of-medicine',
  'taylor-and-francis-numeric-q',
  'teacher-development',
  'teachers-and-teaching',
  'teaching-education',
  'teaching-sociology',
  'teaching-and-learning-in-nursing',
  'teaching-and-teacher-education',
  'teaching-in-higher-education',
  'techniques-in-coloproctology',
  'techniques-in-gastrointestinal-endoscopy',
  'techniques-in-regional-anesthesia-and-pain-management',
  'technische-universitat-dresden-betriebswirtschaftslehre-logistik-author-date',
  'technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date',
  'technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-note',
  'technische-universitat-dresden-medizin',
  'technische-universitat-dresden-wirtschaftswissenschaften',
  'technische-universitat-munchen-controlling',
  'technische-universitat-munchen-unternehmensfuhrung',
  'technische-universitat-wien',
  'technological-forecasting-and-social-change',
  'technologies',
  'technology-and-economics-of-smart-grids-and-sustainable-energy',
  'technology-in-society',
  'technology-innovation-and-education',
  'technology-knowledge-and-learning',
  'technology-pedagogy-and-education',
  'technovation',
  'tectonophysics',
  'telecommunication-systems',
  'telecommunications-policy',
  'telematics-and-informatics',
  'teologia-catalunya',
  'terra-nova',
  'tertiary-education-and-management',
  'tetrahedron-letters',
  'textiles-and-clothing-sustainability',
  'the-aaps-journal',
  'the-academy-of-management-annals',
  'the-accounting-review',
  'the-american-journal-of-cardiology',
  'the-american-journal-of-clinical-nutrition',
  'the-american-journal-of-gastroenterology',
  'the-american-journal-of-medicine',
  'the-american-journal-of-pathology',
  'the-american-journal-of-psychiatry',
  'the-american-journal-of-sports-medicine',
  'the-american-journal-of-surgery',
  'the-american-journal-of-tropical-medicine-and-hygiene',
  'the-american-naturalist',
  'the-american-sociologist',
  'the-american-surgeon',
  'the-analysis-of-verbal-behavior',
  'the-annals-of-pharmacotherapy',
  'the-annals-of-regional-science',
  'the-annals-of-thoracic-surgery',
  'the-arts-in-psychotherapy',
  'the-asia-pacific-journal-of-anthropology',
  'the-asia-pacific-education-researcher',
  'the-asian-journal-of-shipping-and-logistics',
  'the-astronomical-journal',
  'the-astronomy-and-astrophysics-review',
  'the-astrophysical-journal',
  'the-astrophysical-journal-letters',
  'the-astrophysical-journal-supplement-series',
  'the-auk',
  'the-australian-educational-researcher',
  'the-australian-law-journal',
  'the-australian-library-journal',
  'the-behavior-analyst',
  'the-biological-bulletin',
  'the-bone-and-joint-journal',
  'the-breast',
  'the-british-accounting-review',
  'the-british-journal-of-cardiology',
  'the-british-journal-of-psychiatry',
  'the-british-journal-of-sociology',
  'the-british-university-in-dubai-harvard',
  'the-canadian-journal-of-hospital-pharmacy',
  'the-canadian-veterinary-journal',
  'the-central-african-journal-of-medicine',
  'the-cerebellum',
  'the-ceylon-journal-of-medical-science',
  'the-ceylon-medical-journal',
  'the-chemical-society-of-japan',
  'the-clinical-neuropsychologist',
  'the-company-of-biologists',
  'the-computer-games-journal',
  'the-condor',
  'the-crop-journal',
  'the-cryosphere',
  'the-cryosphere-discussions',
  'the-design-journal',
  'the-embo-journal',
  'the-egyptian-heart-journal',
  'the-egyptian-journal-of-aquatic-research',
  'the-egyptian-journal-of-critical-care-medicine',
  'the-egyptian-journal-of-radiology-and-nuclear-medicine',
  'the-egyptian-journal-of-remote-sensing-and-space-sciences',
  'the-egyptian-rheumatologist',
  'the-electricity-journal',
  'the-european-journal-of-finance',
  'the-european-journal-of-health-economics',
  'the-european-journal-of-psychology-applied-to-legal-context',
  'the-european-journal-of-the-history-of-economic-thought',
  'the-european-physical-journal-c',
  'the-extractive-industries-and-society',
  'the-faseb-journal',
  'the-febs-journal',
  'the-foot',
  'the-geological-society-of-america',
  'the-geological-society-of-london',
  'the-hugo-journal',
  'the-historical-journal',
  'the-history-of-the-family',
  'the-holocene',
  'the-ies-journal-part-a-civil-and-structural-engineering',
  'the-isme-journal',
  'the-indian-journal-of-neurotrauma',
  'the-indian-journal-of-pediatrics',
  'the-institute-of-electronics-information-and-communication-engineers',
  'the-institution-of-engineering-and-technology',
  'the-international-journal-of-advanced-manufacturing-technology',
  'the-international-journal-of-cardiovascular-imaging',
  'the-international-journal-of-developmental-biology',
  'the-international-journal-of-life-cycle-assessment',
  'the-international-journal-of-management-education',
  'the-international-journal-of-psychiatry-in-medicine',
  'the-international-journal-of-psychoanalysis',
  'the-international-journal-of-the-history-of-sport',
  'the-international-review-of-retail-distribution-and-consumer-research',
  'the-international-sports-law-journal',
  'the-internet-and-higher-education',
  'the-irish-journal-of-psychology',
  'the-journal-for-nurse-practitioners',
  'the-journal-of-academic-librarianship',
  'the-journal-of-adhesive-dentistry',
  'the-journal-of-agricultural-education-and-extension',
  'the-journal-of-allergy-and-clinical-immunology',
  'the-journal-of-antibiotics',
  'the-journal-of-arthroplasty',
  'the-journal-of-basic-and-applied-zoology',
  'journal-of-biological-chemistry',
  'the-journal-of-bone-and-joint-surgery',
  'the-journal-of-cardiovascular-surgery',
  'the-journal-of-cell-biology',
  'the-journal-of-chemical-physics',
  'the-journal-of-chemical-thermodynamics',
  'the-journal-of-chinese-sociology',
  'the-journal-of-clinical-endocrinology-and-metabolism',
  'the-journal-of-clinical-investigation',
  'the-journal-of-clinical-psychiatry',
  'the-journal-of-comparative-germanic-linguistics',
  'the-journal-of-comparative-neurology',
  'the-journal-of-continuing-education-in-nursing',
  'the-journal-of-economic-asymmetries',
  'the-journal-of-economic-inequality',
  'the-journal-of-eukaryotic-microbiology',
  'the-journal-of-evidence-based-dental-practice',
  'the-journal-of-experimental-biology',
  'the-journal-of-experimental-medicine',
  'the-journal-of-finance-and-data-science',
  'the-journal-of-general-physiology',
  'the-journal-of-geometric-analysis',
  'the-journal-of-hand-surgery',
  'the-journal-of-headache-and-pain',
  'the-journal-of-heart-and-lung-transplantation',
  'the-journal-of-hellenic-studies',
  'the-journal-of-immunology',
  'the-journal-of-imperial-and-commonwealth-history',
  'the-journal-of-indian-prosthodontic-society',
  'the-journal-of-infection-in-developing-countries',
  'the-journal-of-international-trade-and-economic-development',
  'the-journal-of-juristic-papyrology',
  'the-journal-of-legal-pluralism-and-unofficial-law',
  'the-journal-of-mathematical-neuroscience',
  'the-journal-of-medieval-and-early-modern-studies',
  'the-journal-of-modern-history',
  'the-journal-of-neuropsychiatry-and-clinical-neurosciences',
  'the-journal-of-neuroscience',
  'the-journal-of-north-african-studies',
  'the-journal-of-nuclear-medicine',
  'the-journal-of-nutritional-biochemistry',
  'the-journal-of-obstetrics-and-gynecology-of-india',
  'the-journal-of-organic-chemistry',
  'the-journal-of-pain',
  'the-journal-of-pathology',
  'the-journal-of-peasant-studies',
  'the-journal-of-pediatrics',
  'the-journal-of-pharmacology-and-experimental-therapeutics',
  'the-journal-of-pharmacy-technology',
  'the-journal-of-physical-chemistry-a',
  'the-journal-of-physical-chemistry-b',
  'the-journal-of-physical-chemistry-c',
  'the-journal-of-physical-chemistry-letters',
  'the-journal-of-physiological-sciences',
  'the-journal-of-physiology',
  'the-journal-of-positive-psychology',
  'the-journal-of-primary-prevention',
  'the-journal-of-prosthetic-dentistry',
  'the-journal-of-real-estate-finance-and-economics',
  'the-journal-of-roman-studies',
  'the-journal-of-sexual-medicine',
  'the-journal-of-social-studies-research',
  'the-journal-of-supercomputing',
  'the-journal-of-supercritical-fluids',
  'the-journal-of-systems-and-software',
  'the-journal-of-technology-transfer',
  'the-journal-of-thoracic-and-cardiovascular-surgery',
  'the-journal-of-urology',
  'the-journal-of-value-inquiry',
  'the-journal-of-wildlife-management',
  'the-journal-of-the-acoustical-society-of-america',
  'the-journal-of-the-american-dental-association',
  'the-journal-of-the-american-osteopathic-association',
  'the-journal-of-the-astronautical-sciences',
  'the-journal-of-the-economics-of-ageing',
  'the-journal-of-the-torrey-botanical-society',
  'the-knee',
  'the-korean-journal-of-pathology',
  'the-lancet',
  'the-lancet-infectious-diseases',
  'the-lancet-neurology',
  'the-lancet-oncology',
  'the-leadership-quarterly',
  'the-library',
  'the-lichenologist',
  'the-malaysian-journal-of-pathology',
  'the-medical-journal-of-australia',
  'the-netherlands-journal-of-medicine',
  'the-neuroscientist',
  'the-new-england-journal-of-medicine',
  'the-new-iraqi-journal-of-medicine',
  'the-new-zealand-medical-journal',
  'the-nucleus',
  'the-ocular-surface',
  'the-oncologist',
  'the-open-university-harvard',
  'the-open-university-numeric',
  'the-open-university-numeric-superscript',
  'the-open-university-a251',
  'the-open-university-m801',
  'the-optical-society',
  'the-patient-patient-centered-outcomes-research',
  'the-pharmacogenomics-journal',
  'the-physician-and-sportsmedicine',
  'the-plant-cell',
  'the-plant-journal',
  'the-primary-care-companion-for-cns-disorders',
  'the-protein-journal',
  'the-psychological-record',
  'the-psychologist-manager-journal',
  'the-quarterly-journal-of-experimental-psychology',
  'the-queensland-lawyer',
  'the-ramanujan-journal',
  'the-rangeland-journal',
  'the-review-of-austrian-economics',
  'the-review-of-black-political-economy',
  'the-review-of-faith-and-international-affairs',
  'the-review-of-financial-studies',
  'the-review-of-international-organizations',
  'the-rockefeller-university-press',
  'the-saudi-dental-journal',
  'the-saudi-journal-for-dental-research',
  'the-scandinavian-journal-of-clinical-and-laboratory-investigation',
  'the-scandinavian-psychoanalytic-review',
  'the-science-of-nature',
  'the-seventeenth-century',
  'the-sixties',
  'the-social-science-journal',
  'the-spanish-review-of-financial-economics',
  'the-spine-journal',
  'the-surgeon',
  'the-tort-law-review',
  'the-ulster-medical-journal',
  'the-urban-review',
  'the-vldb-journal',
  'the-vaccine-companion',
  'the-veterinary-journal',
  'the-visual-computer',
  'the-world-journal-of-biological-psychiatry',
  'theologie-und-philosophie',
  'theoretical-biology-and-medical-modelling',
  'theoretical-chemistry-accounts',
  'theoretical-computer-science',
  'theoretical-ecology',
  'theoretical-issues-in-ergonomics-science',
  'theoretical-medicine-and-bioethics',
  'theoretical-population-biology',
  'theoretical-and-applied-climatology',
  'theoretical-and-applied-fracture-mechanics',
  'theoretical-and-applied-genetics',
  'theoretical-and-applied-mechanics-letters',
  'theoretical-and-computational-fluid-dynamics',
  'theoretical-and-experimental-plant-physiology',
  'theory-and-decision',
  'theory-and-society',
  'theory-in-biosciences',
  'theory-of-computing-systems',
  'theory-culture-and-society',
  'therapeutic-advances-in-neurological-disorders',
  'therapeutic-delivery',
  'theriogenology',
  'thermochimica-acta',
  'thieme-e-journals-vancouver',
  'thin-solid-films',
  'thin-walled-structures',
  'thinking-and-reasoning',
  'thinking-skills-and-creativity',
  'thomson-reuters-legal-tax-and-accounting-australia',
  'thorax',
  'thrombosis-journal',
  'thrombosis-research',
  'thrombosis-and-haemostasis',
  'thyroid-research',
  'ticks-and-tick-borne-diseases',
  'tidsskrift-for-den-norske-legeforening',
  'tijdschrift-voor-gerontologie-en-geriatrie',
  'tijdschrift-voor-nucleaire-geneeskunde',
  'tijdschrift-voor-psychotherapie',
  'tijdschrift-voor-urologie',
  'tissue-barriers',
  'tissue-engineering',
  'tissue-and-cell',
  'tobacco-control',
  'tobacco-induced-diseases',
  'topics-in-catalysis',
  'topics-in-current-chemistry',
  'topoi',
  'topology-and-its-applications',
  'tourism-management',
  'tourism-management-perspectives',
  'tourism-planning-and-development',
  'toxicological-and-environmental-chemistry',
  'toxicological-sciences',
  'toxicologie-analytique-et-clinique',
  'toxicology',
  'toxicology-letters',
  'toxicology-reports',
  'toxicology-research',
  'toxicology-and-applied-pharmacology',
  'toxicology-in-vitro',
  'toxicon',
  'toxics',
  'toxins',
  'traces',
  'traffic',
  'traffic-injury-prevention',
  'training-and-education-in-professional-psychology',
  'transactions-of-the-american-fisheries-society',
  'transactions-of-the-american-philological-association',
  'transactions-of-the-materials-research-society-of-japan',
  'transcription',
  'transfusion',
  'transfusion-medicine-reviews',
  'transfusion-medicine-and-hemotherapy',
  'transfusion-and-apheresis-science',
  'transfusion-clinique-et-biologique',
  'transgenic-research',
  'transition-metal-chemistry',
  'translation',
  'translation-studies',
  'translational-andrology-and-urology',
  'translational-behavioral-medicine',
  'translational-medicine-case-reports',
  'translational-medicine-in-diabetes-lipids-and-cardiovascular-prevention',
  'translational-neurodegeneration',
  'translational-proteomics',
  'translational-psychiatry',
  'translational-research',
  'translational-research-in-anatomy',
  'translational-respiratory-medicine',
  'translational-stroke-research',
  'transplant-immunology',
  'transplantation',
  'transplantation-proceedings',
  'transplantation-reports',
  'transplantation-research',
  'transplantation-reviews',
  'transport-policy',
  'transport-reviews',
  'transport-in-porous-media',
  'transportation',
  'transportation-geotechnics',
  'transportation-infrastructure-geotechnology',
  'transportation-planning-and-technology',
  'transportation-research-part-a',
  'transportation-research-part-b',
  'transportation-research-part-c',
  'transportation-research-part-d',
  'transportation-research-part-e',
  'transportation-research-part-f-psychology-and-behaviour',
  'transportation-research-procedia',
  'transportation-research-record',
  'transportation-in-developing-economies',
  'transportmetrica-a-transport-science',
  'transportmetrica-b-transport-dynamics',
  'trauma-case-reports',
  'trauma-und-berufskrankheit',
  'traumatology-an-international-journal',
  'travel-behaviour-and-society',
  'travel-medicine-and-infectious-disease',
  'tree-genetics-and-genomes',
  'tree-physiology',
  'trees',
  'trends-in-anaesthesia-and-critical-care',
  'trends-in-analytical-chemistry',
  'trends-in-biochemical-sciences',
  'trends-in-biotechnology',
  'trends-in-cardiovascular-medicine',
  'trends-in-cell-biology',
  'trends-in-cognitive-sciences',
  'trends-in-ecology-and-evolution',
  'trends-in-endocrinology-and-metabolism',
  'trends-in-environmental-analytical-chemistry',
  'trends-in-food-science-and-technology',
  'trends-in-genetics',
  'trends-in-immunology',
  'trends-in-microbiology',
  'trends-in-molecular-medicine',
  'trends-in-neuroscience-and-education',
  'trends-in-neurosciences',
  'trends-in-organized-crime',
  'trends-in-parasitology',
  'trends-in-pharmacological-sciences',
  'trends-in-plant-science',
  'trends-journals',
  'trials',
  'trials-in-vaccinology',
  'triangle',
  'tribology-international',
  'tribology-letters',
  'triple-helix',
  'tropical-diseases-travel-medicine-and-vaccines',
  'tropical-doctor',
  'tropical-gastroenterology',
  'tropical-plant-biology',
  'tropical-plant-pathology',
  'tsinghua-science-and-technology',
  'tuberculosis',
  'tumor-biology',
  'tunnelling-and-underground-space-technology-incorporating-trenchless-technology-research',
  'turabian-fullnote-bibliography',
  'turabian-fullnote-bibliography',
  'Turabian-9th-edition-author-date',
  'Turabian-9th-edition-Notes-Bib',
  'turabian-author-date',
  'turkish-journal-of-emergency-medicine',
  'turkish-studies',
  'tzu-chi-medical-journal',
  'tekhne-review-of-applied-management-studies',
  'u-schylku-starozytnosci',
  'us-geological-survey',
  'umk-procedia',
  'ugeskrift-for-laeger',
  'ultramicroscopy',
  'ultrasonics',
  'ultrasonics-sonochemistry',
  'ultrasound-in-medicine-and-biology',
  'ultrasound-in-obstetrics-and-gynecology',
  'ulusal-travma-ve-acil-cerrahi-dergisi',
  'undersea-and-hyperbaric-medicine-journal',
  'unified-style-linguistics',
  'united-nations-conference-on-trade-and-development',
  'universal-access-in-the-information-society',
  'universidad-evangelica-del-paraguay',
  'universidade-de-sao-paulo-instituto-de-matematica-e-estatistica',
  'universiteit-utrecht-onderzoeksgids-geschiedenis',
  'university-college-dublin-school-of-history-and-archives',
  'university-college-lillebaelt-apa',
  'university-college-lillebaelt-harvard',
  'university-college-lillebaelt-vancouver',
  'universita-di-bologna-lettere',
  'university-of-bradford-harvard',
  'university-of-brighton-harvard-chicago',
  'university-of-helsinki-faculty-of-theology',
  'university-of-leeds-harvard',
  'university-of-lincoln-harvard',
  'university-of-malta-harvard',
  'university-of-new-england-australia-note',
  'university-of-south-australia-harvard-2011',
  'university-of-south-australia-harvard-2013',
  'university-of-south-australia-harvard-2017',
  'university-of-western-australia-oxford',
  'universita-cattolica-del-sacro-cuore',
  'universita-pontificia-salesiana',
  'universita-pontificia-salesiana-en',
  'universita-pontificia-salesiana-fr',
  'universita-pontificia-salesiana-it',
  'universita-pontificia-salesiana-pt-br',
  'universita-pontificia-salesiana-es',
  'universitat-bremen-institut-fur-politikwissenschaft',
  'universitat-heidelberg-historisches-seminar',
  'universitat-mainz-geographisches-institut',
  'universitatsmedizin-gottingen',
  'universite-laval-departement-dinformation-et-de-communication',
  'universite-laval-faculte-de-theologie-et-de-sciences-religieuses',
  'universite-de-liege-histoire',
  'universite-de-picardie-jules-verne-ufr-de-medecine',
  'universite-de-sherbrooke-departement-de-geomatique',
  'universite-de-sherbrooke-faculte-d-education',
  'universite-du-quebec-a-montreal',
  'universite-libre-de-bruxelles-histoire',
  'updates-in-surgery',
  'uppsala-universitet-institutionen-for-biologisk-grundutbildning',
  'urban-climate',
  'urban-ecosystems',
  'urban-forestry-and-urban-greening',
  'urban-forum',
  'urban-habitats',
  'urban-rail-transit',
  'urban-research-and-practice',
  'urban-studies',
  'urolithiasis',
  'urologia-internationalis',
  'urologic-oncology-seminars-and-original-investigations',
  'urological-science',
  'urology',
  'urology-case-reports',
  'user-modeling-and-user-adapted-interaction',
  'utah-geological-survey',
  'utilities-policy',
  'voluntas-international-journal-of-voluntary-and-nonprofit-organizations',
  'vaccine',
  'vaccines',
  'vacuum',
  'vadose-zone-journal',
  'value-in-health',
  'value-in-health-regional-issues',
  'vancouver',
  'vancouver-fr-ca',
  'vancouver-author-date',
  'vancouver-brackets',
  'vancouver-brackets-no-et-al',
  'vancouver-brackets-only-year-no-issue',
  'vancouver-superscript',
  'vancouver-superscript-brackets-only-year',
  'vancouver-superscript-only-year',
  'vancouver-cardiff-university',
  'vancouver-imperial-college-london',
  'vancouver-university-of-southampton',
  'vascular-cell',
  'vascular-medicine',
  'vascular-pharmacology',
  'vegetation-history-and-archaeobotany',
  'vehicle-system-dynamics',
  'vehicular-communications',
  'venture-capital',
  'verhaltenstherapie',
  'verslaving',
  'veterinary-immunology-and-immunopathology',
  'veterinary-medicine-austria',
  'veterinary-microbiology',
  'veterinary-parasitology',
  'veterinary-parasitology-regional-studies-and-reports',
  'veterinary-quarterly',
  'veterinary-radiology-and-ultrasound',
  'veterinary-record',
  'veterinary-record-case-reports',
  'veterinary-record-open',
  'veterinary-research',
  'veterinary-research-communications',
  'veterinary-sciences',
  'vibrational-spectroscopy',
  'victoria-university-harvard',
  'victoria-university-oxford',
  'video-journal-and-encyclopedia-of-gi-endoscopy',
  'video-journal-of-education-and-pedagogy',
  'vienna-legal',
  'vietnam-journal-of-computer-science',
  'vietnam-journal-of-mathematics',
  'vietnam-ministry-of-education-and-training-en',
  'vietnam-ministry-of-education-and-training-vi',
  'vilnius-gediminas-technical-university',
  'vingtieme-siecle',
  'virchows-archiv',
  'virology',
  'virology-journal',
  'virology-reports',
  'virtual-reality',
  'virtual-and-physical-prototyping',
  'virulence',
  'virus-genes',
  'virus-research',
  'virusdisease',
  'viruses',
  'vision-research',
  'visual-cognition',
  'visual-journal-of-emergency-medicine',
  'visual-neuroscience',
  'visual-studies',
  'visualization-in-engineering',
  'viszeralmedizin',
  'vocation-sage-femme',
  'vocations-and-learning',
  'vodohospodarske-technicko-ekonomicke-informace',
  'vodohospodarske-technicko-ekonomicke-informace-en',
  'vox-sanguinis',
  'vulnerable-children-and-youth-studies',
  'who-europe-harvard',
  'who-europe-numeric',
  'who-south-east-asia-journal-of-public-health',
  'wmu-journal-of-maritime-affairs',
  'waste-management',
  'waste-and-biomass-valorization',
  'water',
  'water-alternatives',
  'water-conservation-science-and-engineering',
  'water-environment-research',
  'water-history',
  'water-international',
  'water-research',
  'water-resources-management',
  'water-resources-and-economics',
  'water-resources-and-industry',
  'water-science',
  'water-science-and-technology',
  'water-science-and-engineering',
  'water-resources-and-rural-development',
  'water-air-and-soil-pollution',
  'wave-motion',
  'waves-in-random-and-complex-media',
  'wear',
  'weather-and-climate-extremes',
  'weather-and-forecasting',
  'weather-climate-and-society',
  'web-ecology',
  'web-semantics-science-services-and-agents-on-the-world-wide-web',
  'webbia',
  'weed-science',
  'weed-science-society-of-america',
  'weed-technology',
  'welding-international',
  'welding-in-the-world',
  'west-european-politics',
  'west-virginia-medical-journal',
  'western-pacific-surveillance-and-response',
  'wetlands',
  'wetlands-ecology-and-management',
  'wheaton-college-phd-in-biblical-and-theological-studies',
  'wiener-medizinische-wochenschrift',
  'wiener-klinische-wochenschrift',
  'wiener-klinische-wochenschrift-education',
  'wiener-klinisches-magazin',
  'wilderness-and-environmental-medicine',
  'wildlife-biology',
  'wildlife-research',
  'wiley-vch-books',
  'wine-economics-and-policy',
  'wireless-communications-and-mobile-computing',
  'wireless-networks',
  'wireless-personal-communications',
  'wirtschaftsuniversitat-wien-master-management',
  'wissenschaftlicher-industrielogistik-dialog',
  'woman-psychosomatic-gynaecology-and-obstetrics',
  'women-and-performance-a-journal-of-feminist-theory',
  'womens-health',
  'womens-health-issues',
  'womens-midlife-health',
  'womens-studies-international-forum',
  'wood-science-and-technology',
  'work-and-stress',
  'workplace-health-and-safety',
  'workplace-review',
  'world-allergy-organization-journal',
  'world-archaeology',
  'world-congress-on-engineering-asset-management',
  'world-development',
  'world-journal-of-acupuncture-moxibustion',
  'world-journal-of-emergency-surgery',
  'world-journal-of-gastroenterology',
  'world-journal-of-microbiology-and-biotechnology',
  'world-journal-of-otorhinolaryngology-head-and-neck-surgery',
  'world-journal-of-surgery',
  'world-journal-of-surgical-oncology',
  'world-journal-of-urology',
  'world-medical-journal',
  'world-mycotoxin-journal',
  'world-neurosurgery',
  'world-patent-information',
  'world-politcs',
  'world-psychiatry',
  'world-wide-web',
  'worm',
  'wound-medicine',
  'writing-systems-research',
  'xenotransplantation',
  'yakugaku-zasshi',
  'yakuzai-ekigaku',
  'yale-journal-of-biology-and-medicine',
  'yearbook-of-english-studies',
  'yeast',
  'zdm',
  'zagazig-university-medical-journal',
  'zastosowania-komputerow-w-elektrotechnice',
  'zdravniski-vestnik',
  'zeitschrift-fur-aussen-und-sicherheitspolitik',
  'zeitschrift-fur-bildungsforschung',
  'zeitschrift-fur-didaktik-der-naturwissenschaften',
  'zeitschrift-fur-energiewirtschaft',
  'zeitschrift-fur-epileptologie',
  'zeitschrift-fur-erziehungswissenschaft',
  'zeitschrift-fur-gerontologie-und-geriatrie',
  'zeitschrift-fur-herz-thorax-und-gefasschirurgie',
  'zeitschrift-fur-immobilienokonomie',
  'zeitschrift-fur-internationale-beziehungen',
  'zeitschrift-fur-kunstgeschichte',
  'zeitschrift-fur-medienwissenschaft',
  'zeitschrift-fur-politikwissenschaft',
  'zeitschrift-fur-psychodrama-und-soziometrie',
  'zeitschrift-fur-psychologie',
  'zeitschrift-fur-padagogik',
  'zeitschrift-fur-religionswissenschaft-author-date',
  'zeitschrift-fur-religionswissenschaft-note',
  'zeitschrift-fur-rheumatologie',
  'zeitschrift-fur-soziologie',
  'zeitschrift-fur-theologie-und-kirche',
  'zeitschrift-fur-vergleichende-politikwissenschaft',
  'zeitschrift-fur-weiterbildungsforschung-report',
  'zeitschrift-fur-angewandte-mathematik-und-physik',
  'zeitschrift-fur-deutsche-philologie',
  'zeitschrift-fur-die-gesamte-versicherungswissenschaft',
  'zentralblatt-fur-arbeitsmedizin-arbeitsschutz-und-ergonomie',
  'zeszyty-naukowe-wco-letters-in-oncology-science',
  'zeszyty-prawnicze-bas',
  'zookeys',
  'zoological-journal-of-the-linnean-society',
  'zoological-letters',
  'zoological-studies',
  'zoologischer-anzeiger-a-journal-of-comparative-zoology',
  'zoology',
  'zoology-and-ecology',
  'zoology-in-the-middle-east',
  'zoomorphology',
  'zootaxa',
  'acta-ethologica',
  'annals-of-telecommunications-annales-des-telecommunications',
  'arktos',
  'best-practice-onkologie',
  'coloproctology',
  'der-junge-zahnarzt',
  'der-moderne-staat',
  'e-and-i-elektrotechnik-und-informationstechnik',
  'e-neuroforum',
  'eneurologicalsci',
  'ergoscience',
  'exercer',
  'h-bioscience',
  'hautnah',
  'international-journal-of-stomatology-and-occlusion-medicine',
  'mabs',
  'mbio',
  'mux-the-journal-of-mobile-user-experience',
  'medizinische-genetik',
  'memo-magazine-of-european-medical-oncology',
  'medecine-sciences',
  'neurogenetics',
  'neuropsychiatrie',
  'psychopraxis-neuropraxis',
  'rheuma-plus',
  'uwf-umweltwirtschaftsforum',
  'wissen-kompakt',
  'ets-ecole-de-technologie-superieure',
  'economie-et-statistique',
  'ecoscience',
  'epidemiologie-et-sante-animale',
  'osterreichische-zeitschrift-fur-politikwissenschaft',
  'osterreichische-zeitschrift-fur-soziologie',
  'ceska-a-slovenska-neurologie-a-neurochirurgie',
  'ceska-zemedelska-univerzita-v-praze-fakulta-agrobiologie-potravinovych-a-prirodnich-zdroju',
  'rossiiskii-fiziologicheskii-zhurnal-imeni-i-m-sechenova',
  'mla',
  'ama',
  'apa6',
  'harvard',
  'chicago',
  'mla-format',
  'apa-format',
  'mla-8',
  'turabian',
  'mla-8-format',
])
// The styleIds mla,ama,apa6,harvard,chicago,mla-format,apa-format,mla-8,turabian are not taken from style list
// present in CSL-Ruby but are used to support the special cases where there is mapping for some stylenames
// to be shown in the URL instead of actual styleIds.
